var _metadata, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRalewaySemiBoldItalic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by FontForge 20170731 at Sat Feb  6 03:22:28 2016\n By Aleksey,,,\nCopyright (c) 2010 - 2012, Matt McInerney (matt@pixelspread.com), Pablo Impallari (impallari@gmail.com), Rodrigo Fuenzalida (hello@rfuenzalida.com) with Reserved Font Name \"Raleway\"\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "Raleway-SemiBoldItalic",
    horizAdvX: 615
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "Raleway SemiBold",
    fontWeight: 600,
    fontStyle: "italic",
    fontStretch: "normal",
    unitsPerEm: 1000,
    panose1: "2 11 7 3 3 1 1 6 0 3",
    ascent: 800,
    descent: -200,
    xHeight: 523,
    capHeight: 709,
    bbox: "-248 -226 1342 930",
    underlineThickness: 50,
    underlinePosition: -150,
    slope: -12,
    unicodeRange: "U+000D-FB06"
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_f",
    unicode: "ff",
    horizAdvX: 600,
    d: "M117 425h-65l18 85h66l2 8q9 37 27 71t44 59t59.5 40t72.5 15q33 0 61 -8t51 -20q29 29 64 47t80 18q39 0 63.5 -11.5t43.5 -20.5l-40 -82q-11 8 -26 14t-38 6t-40.5 -10t-31 -25.5t-22.5 -35.5t-14 -41l-6 -24h138l-17 -85h-139l-90 -425h-110l90 425h-131l-90 -425 h-110zM376 510q4 18 12 42t17 41q-12 9 -30 12.5t-33 3.5q-41 0 -63.5 -26t-30.5 -63l-2 -10h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_i",
    unicode: "fi",
    horizAdvX: 528,
    d: "M117 425h-65l18 85h66l4 21q8 41 29 78.5t52 66.5t71.5 46.5t87.5 17.5q54 0 93 -17.5t67 -40.5l-62 -82q-18 20 -47 33t-64 13q-24 0 -43.5 -9.5t-34 -25.5t-24.5 -36t-14 -41l-5 -24h262l-109 -510h-110l90 425h-152l-90 -425h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_l",
    unicode: "fl",
    horizAdvX: 608,
    d: "M431 -7q-48 0 -73 24t-25 60q0 8 1 16.5t4 21.5l91 421q2 11 3.5 21t1.5 19q0 29 -15 49.5t-54 20.5q-48 0 -76.5 -34.5t-39.5 -88.5l-3 -13h88l-17 -85h-90l-90 -425h-110l90 425h-65l18 85h66l6 30q21 94 83.5 147t156.5 53q87 0 127 -36.5t40 -97.5q0 -23 -6 -47 l-86 -408q-2 -10 -2 -17q0 -17 8.5 -30t28.5 -13q9 0 19 2t19 4.5t15.5 4.5l6.5 2l-5 -89q-1 -1 -11.5 -4.5t-27 -7.5t-37 -7t-40.5 -3z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_f_i",
    unicode: "ffi",
    horizAdvX: 769,
    d: "M117 425h-65l18 85h66l2 8q8 35 26 68.5t44.5 59.5t60 41.5t72.5 15.5q33 0 61 -8t51 -20q32 29 73.5 47t92.5 18q50 0 90.5 -17.5t71.5 -40.5l-62 -82q-17 19 -47 32.5t-62 13.5q-25 0 -44.5 -9.5t-34 -25.5t-24.5 -36t-15 -41l-6 -24h263l-109 -510h-110l90 425h-152 l-90 -425h-110l90 425h-131l-90 -425h-110zM376 510q4 18 12 42t17 41q-12 9 -30 12.5t-33 3.5q-20 0 -36 -7.5t-28 -20t-19.5 -28.5t-10.5 -33l-2 -10h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_f_l",
    unicode: "ffl",
    horizAdvX: 850,
    d: "M674 -7q-50 0 -74.5 24t-24.5 60q0 9 1.5 18.5t4.5 23.5l90 419q2 10 3.5 19.5t1.5 18.5q0 29 -15 49.5t-55 20.5q-24 0 -43 -10t-33 -27.5t-23.5 -40.5t-15.5 -49l-2 -9h87l-17 -85h-89l-90 -425h-110l90 425h-133l-90 -425h-110l90 425h-65l18 85h66l2 8 q9 37 27.5 70.5t45.5 59t60.5 40.5t72.5 15q34 0 60 -8t50 -20q32 32 75 48.5t96 16.5q86 0 126 -36.5t40 -97.5q0 -23 -6 -47l-86 -408q-2 -10 -2 -17q0 -17 8.5 -30t28.5 -13q8 0 18.5 2t19.5 4.5t15.5 4.5t7.5 2l-6 -89q-1 -1 -11.5 -4.5t-27 -7.5t-37 -7t-39.5 -3z M379 510q4 20 10.5 44.5t14.5 39.5q-12 9 -27.5 12t-29.5 3q-20 0 -37 -7.5t-29.5 -20t-21 -28t-11.5 -31.5l-2 -12h133z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".notdef",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".null",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nonmarkingreturn",
    unicode: "\r",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "NULL",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "NULL",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "space",
    unicode: " ",
    horizAdvX: 242
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclam",
    unicode: "!",
    horizAdvX: 274,
    d: "M72 253l98 464h110l-98 -464h-110zM18 0l29 137h110l-29 -137h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedbl",
    unicode: "\"",
    horizAdvX: 351,
    d: "M103 501l47 220h94l-47 -220h-94zM236 501l47 220h94l-47 -220h-94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "numbersign",
    unicode: "#",
    horizAdvX: 678,
    d: "M670 436h-134l-68 -158h124l-17 -84h-145l-86 -194h-89l86 194h-131l-86 -194h-90l87 194h-107l18 84h127l68 158h-118l17 78h137l87 196h89l-87 -196h132l86 196h89l-87 -196h115zM379 278l68 158h-131l-68 -158h131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dollar",
    unicode: "$",
    horizAdvX: 603,
    d: "M537 543q-6 10 -20 21.5t-33.5 22t-44 18t-51.5 9.5l-44 -206q32 -11 67.5 -22t65.5 -29t49.5 -47t19.5 -74q0 -62 -23 -106.5t-62 -74.5t-90 -45t-107 -17l-22 -105h-51l23 107q-67 5 -125 28.5t-100 65.5l73 96q7 -12 24 -26t40 -27t52.5 -23t62.5 -14l44 207 q-29 7 -62 18.5t-61 29.5t-46 45t-18 66q0 56 21.5 101t58 77.5t85 51.5t103.5 23l22 101h51l-22 -101q62 -4 109.5 -26t80.5 -53zM420 202q0 34 -27 53.5t-74 35.5l-41 -197q69 1 105.5 29.5t36.5 78.5zM222 499q0 -32 22 -49.5t66 -31.5l42 196q-67 -4 -98.5 -35.5 t-31.5 -79.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "percent",
    unicode: "%",
    horizAdvX: 732,
    d: "M215 423q-56 0 -90 35.5t-34 87.5q0 35 16 66.5t42 55.5t59.5 38t69.5 14q28 0 51 -9.5t39.5 -26t25.5 -39t9 -48.5q0 -35 -16 -66.5t-42 -55.5t-60 -38t-70 -14zM227 480q18 0 35.5 9t31 24.5t22 35.5t8.5 41q0 31 -16 52t-42 21q-18 0 -35 -9.5t-30.5 -24.5t-22 -35 t-8.5 -41q0 -31 15.5 -52t41.5 -21zM477 -10q-56 0 -90 35.5t-34 87.5q0 35 16 66.5t42 55.5t59.5 38t69.5 14q57 0 90.5 -35.5t33.5 -87.5q0 -35 -15.5 -66.5t-42 -55.5t-60 -38t-69.5 -14zM489 47q18 0 35 9t31 24.5t22.5 35.5t8.5 41q0 31 -16.5 52t-42.5 21 q-18 0 -35 -9t-30.5 -24.5t-22 -35.5t-8.5 -41q0 -31 16 -52t42 -21zM26 40l338 333l323 343l42 -45l-332 -329l-329 -348z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ampersand",
    unicode: "&",
    horizAdvX: 684,
    d: "M401 82q-49 -45 -103 -68.5t-108 -23.5q-40 0 -72.5 13t-55 36t-34.5 53.5t-12 66.5q0 41 14.5 74.5t38.5 61.5t55.5 51.5t66.5 45.5q-26 42 -38.5 74t-12.5 62q0 40 17.5 75t47.5 61t69.5 40.5t82.5 14.5q57 0 101 -29.5t64 -86.5l-76 -53q-13 39 -41 63t-62 24 q-20 0 -38 -7.5t-32 -20t-22 -29t-8 -34.5q0 -20 13 -48t48 -78l122 -177q20 38 34.5 81t22.5 92h179l-15 -82h-90q-30 -93 -80 -164l119 -170h-139zM216 76q36 0 72.5 18.5t68.5 51.5l-119 176q-54 -34 -84.5 -69t-30.5 -82q0 -46 27 -70.5t66 -24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesingle",
    unicode: "'",
    horizAdvX: 219,
    d: "M103 500l47 221h94l-47 -221h-94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenleft",
    unicode: "(",
    horizAdvX: 291,
    d: "M39 262q0 66 18.5 127t50 120.5t74.5 118.5t92 122l76 -36q-33 -41 -70 -94t-67.5 -111.5t-50.5 -120t-20 -118.5q0 -63 14 -136.5t39 -139.5l-90 -41q-15 34 -27 72.5t-20.5 78.5t-13.5 80t-5 78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenright",
    unicode: ")",
    horizAdvX: 290,
    d: "M272 432q0 -65 -18.5 -126.5t-50.5 -121t-74.5 -117t-90.5 -114.5l-73 41q44 55 81 108.5t64 106.5t42 106t15 109q0 41 -5 84t-12.5 82t-16.5 71.5t-17 52.5l92 36q27 -76 45.5 -159t18.5 -159z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asterisk",
    unicode: "*",
    horizAdvX: 329,
    d: "M126 530l57 67l-61 22l26 50l61 -29l12 76h60l-20 -76l75 29l4 -50l-71 -22l29 -67l-50 -30l-27 71l-58 -71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plus",
    unicode: "+",
    horizAdvX: 421,
    d: "M380 399v-88h-110v-121h-100v121h-111v88h111v121h100v-121h110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "comma",
    unicode: ",",
    horizAdvX: 218,
    d: "M-11 -97l45 103h-35l25 122h98l-25 -122l-57 -103h-51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hyphen",
    unicode: "-",
    horizAdvX: 404,
    d: "M43 224l21 99h285l-21 -99h-285z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "period",
    unicode: ".",
    horizAdvX: 212,
    d: "M-3 0l27 128h92l-28 -128h-91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "slash",
    unicode: "/",
    horizAdvX: 659,
    d: "M711 710l-615 -710h-122l615 710h122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero",
    unicode: 0,
    horizAdvX: 594,
    d: "M231 -10q-44 0 -78.5 17.5t-59 48t-37.5 73.5t-13 94q0 78 26 146t70 118.5t101.5 80t119.5 29.5q43 0 78 -17.5t60 -48.5t38 -74t13 -94q0 -78 -26.5 -146t-70.5 -118.5t-101.5 -79.5t-119.5 -29zM252 92q36 0 69.5 20.5t59 55.5t40.5 82t15 101q0 65 -26 104.5 t-71 39.5q-38 0 -71.5 -20.5t-58.5 -56t-40 -83t-15 -100.5q0 -65 25.5 -104t72.5 -39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one",
    unicode: 1,
    horizAdvX: 455,
    d: "M23 99h135l74 349q-11 -12 -32 -25t-45.5 -24t-49.5 -18.5t-44 -7.5l22 103q19 0 47 12t54.5 28t47 32t25.5 23h113l-100 -472h121l-21 -99h-369z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two",
    unicode: 2,
    horizAdvX: 529,
    d: "M-23 0q9 43 23.5 79t38 67t59 58.5t86.5 55.5q56 30 93 51t59.5 38.5t32 34.5t9.5 40q0 26 -13.5 43t-51.5 17q-25 0 -50 -7.5t-48 -19t-42.5 -25.5t-32.5 -27l-53 81q13 11 37.5 27.5t57 31.5t71.5 25.5t83 10.5q81 0 124 -38.5t43 -100.5q0 -42 -18.5 -74.5t-46 -57.5 t-59 -42.5t-56.5 -30.5q-22 -11 -47 -25t-49 -30.5t-44.5 -37t-32.5 -45.5h292l-21 -99h-444v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three",
    unicode: 3,
    horizAdvX: 528,
    d: "M153 -147q-72 0 -122 26.5t-73 76.5l82 76q15 -37 46 -58t85 -21q74 0 115 36t41 102q0 45 -31.5 71.5t-94.5 26.5h-26l19 86h28q36 0 65 10t49.5 28t31.5 42t11 51q0 36 -24.5 54.5t-65.5 18.5q-47 0 -88 -22t-72 -63l-52 75q19 24 46 43.5t59 34t68 22t72 7.5 q83 0 130.5 -40t47.5 -106q0 -34 -12.5 -66.5t-34 -59t-50.5 -44.5t-62 -24q48 -9 74 -47t26 -92t-21.5 -99t-60 -77t-91 -50t-115.5 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four",
    unicode: 4,
    horizAdvX: 546,
    d: "M257 32h-288l21 98l417 441h75l-94 -439h84l-21 -100h-84l-34 -159h-110zM290 132l58 271l-246 -271h188z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five",
    unicode: 5,
    horizAdvX: 531,
    d: "M155 -149q-73 0 -124 34.5t-68 93.5l78 63q17 -42 53 -68t82 -26q33 0 63 12.5t52.5 35t36 53t13.5 66.5q0 48 -27 77t-72 29q-35 0 -69 -16.5t-59 -48.5h-97q6 14 19.5 47.5t30.5 77t35.5 91.5t35 89.5t28.5 71.5t16 38h331l-22 -101h-250l-74 -194q19 19 47 30t63 11 q40 0 73.5 -13.5t56.5 -37.5t36 -58t13 -74q0 -62 -24.5 -113.5t-66 -89.5t-96 -59t-114.5 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six",
    unicode: 6,
    horizAdvX: 591,
    d: "M237 -10q-92 0 -142 61t-50 169q0 100 26 190t73.5 158t113 107.5t145.5 39.5q64 0 110.5 -31t69.5 -88l-79 -68q-13 42 -45.5 66.5t-78.5 24.5q-69 0 -124 -63.5t-81 -178.5q30 45 76.5 71t98.5 26q43 0 77.5 -15t59.5 -41t38.5 -61.5t13.5 -77.5q0 -59 -25 -111 t-67 -92t-96.5 -63t-113.5 -23zM258 84q32 0 63 14.5t56 39.5t40 57t15 68q0 52 -30.5 87.5t-80.5 35.5q-33 0 -64 -14.5t-55 -39t-39 -56.5t-15 -67q0 -26 8 -48.5t22.5 -39.5t35 -27t44.5 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven",
    unicode: 7,
    horizAdvX: 530,
    d: "M386 482h-322l21 101h496l-488 -710h-124z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight",
    unicode: 8,
    horizAdvX: 579,
    d: "M222 -8q-44 0 -81 13.5t-63.5 37.5t-41 57.5t-14.5 72.5q0 40 14.5 73t37.5 59t50 45t53 30q-28 15 -46.5 45.5t-18.5 68.5q0 51 25.5 91t64.5 68t85.5 42.5t88.5 14.5q34 0 67 -10.5t59.5 -30.5t42.5 -50t16 -69q0 -30 -11 -56t-29 -48t-41 -39t-47 -27q34 -18 58 -55 t24 -87q0 -54 -25 -99.5t-66 -78t-93.5 -50.5t-108.5 -18zM245 91q28 0 56 10.5t51 29.5t37.5 45t14.5 58q0 24 -9 42.5t-24 31t-35 19.5t-41 7q-28 0 -56.5 -10.5t-51 -29.5t-36.5 -45.5t-14 -57.5q0 -23 9 -41.5t24 -31.5t34.5 -20t40.5 -7zM314 418q21 0 44.5 7.5t43 22 t32.5 36t13 49.5q0 37 -27 58t-65 21q-24 0 -48 -8t-42.5 -23t-30 -36t-11.5 -47q0 -20 8 -34.5t20.5 -25t29 -15.5t33.5 -5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine",
    unicode: 9,
    horizAdvX: 574,
    d: "M172 -154q-65 0 -111.5 31t-69.5 88l79 68q12 -42 45 -66.5t79 -24.5q69 0 124 63.5t81 178.5q-30 -45 -76 -71t-99 -26q-43 0 -78 15t-59.5 41t-38 61.5t-13.5 77.5q0 58 25 110.5t67 92.5t96.5 63t113.5 23q91 0 141.5 -61t50.5 -169q0 -101 -26 -190.5t-73.5 -157.5 t-113 -107.5t-144.5 -39.5zM252 175q33 0 64.5 14.5t55.5 39t39 56.5t15 67q0 26 -8 48.5t-22.5 39.5t-35 27t-44.5 10q-32 0 -63.5 -14.5t-56 -39.5t-40 -57t-15.5 -68q0 -26 8 -48.5t23 -39t35.5 -26t44.5 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colon",
    unicode: ":",
    horizAdvX: 220,
    d: "M83 391l27 127h91l-27 -127h-91zM0 0l28 128h90l-27 -128h-91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "semicolon",
    unicode: ";",
    horizAdvX: 223,
    d: "M84 391l27 127h90l-27 -127h-90zM-8 -97l45 103h-35l25 122h98l-26 -122l-56 -103h-51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "less",
    unicode: "<",
    horizAdvX: 549,
    d: "M30 284l420 254v-117l-261 -162l261 -158v-122l-420 250v55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "equal",
    unicode: "=",
    horizAdvX: 482,
    d: "M80 162v73h309v-73h-309zM80 317v73h309v-73h-309z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greater",
    unicode: ">",
    horizAdvX: 548,
    d: "M500 229l-421 -250v122l261 158l-261 162v117l421 -254v-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "question",
    unicode: "?",
    horizAdvX: 466,
    d: "M109 221q11 52 35.5 92t77.5 69q25 14 53.5 28.5t51.5 33.5t38.5 44t15.5 60q0 39 -24 60t-58 21q-22 0 -42.5 -7.5t-38.5 -20t-33 -28.5t-27 -32l-62 49q19 31 44.5 55t55 40.5t62 25t64.5 8.5q31 0 60 -9t51 -28t35 -48t13 -69q0 -46 -12 -79t-32.5 -57t-48 -42 t-58.5 -34q-21 -11 -41.5 -22.5t-38 -26.5t-30.5 -35t-19 -48h-92zM64 0l27 126h91l-26 -126h-92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "at",
    unicode: "@",
    horizAdvX: 811,
    d: "M573 36q30 0 54 27t41 67t26 86t9 84q0 50 -16 96.5t-48 82t-79 57t-108 21.5q-73 0 -141.5 -30.5t-122 -83.5t-85.5 -125t-32 -154q0 -57 16.5 -105.5t47 -83.5t75 -55t100.5 -20q40 0 76.5 10.5t77.5 27.5l5 -44q-43 -20 -85.5 -30t-83.5 -10q-62 0 -113 22t-88 62 t-57 96t-20 125q0 97 39 179t101.5 140.5t141.5 91.5t160 33q68 0 121.5 -23.5t90.5 -63t56.5 -92.5t19.5 -111q0 -28 -5 -63t-15 -71.5t-25.5 -71.5t-37.5 -62.5t-50.5 -44t-63.5 -16.5q-31 0 -51.5 15.5t-20.5 50.5v10t2 10q-35 -33 -77.5 -52.5t-86.5 -19.5 q-37 0 -66.5 14.5t-50 39.5t-31.5 58.5t-11 71.5q0 54 20.5 104.5t55 89t78.5 61.5t92 23q52 0 85 -26t46 -65l16 81h62l-72 -343q-2 -10 -3 -18.5t-1 -14.5q0 -38 32 -38zM349 56q23 0 45 8.5t41 23.5t34 34.5t24 41.5l22 133q-13 51 -42.5 76t-67.5 25q-30 0 -61 -16 t-56 -43t-40.5 -64t-15.5 -79q0 -30 8.5 -56t24.5 -44.5t37 -29t47 -10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A",
    unicode: "A",
    horizAdvX: 649,
    d: "M365 710h99l114 -710h-118l-28 193h-255l-109 -193h-118zM428 276l-40 305l-174 -305h214z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B",
    unicode: "B",
    horizAdvX: 651,
    d: "M166 710h351q30 0 52.5 -12.5t37.5 -32.5t22.5 -46t7.5 -54q0 -31 -9.5 -61.5t-27.5 -57t-43.5 -48t-56.5 -34.5q45 -15 68.5 -52.5t23.5 -89.5t-21.5 -93t-56.5 -69.5t-80.5 -44t-94.5 -15.5h-324zM359 97q23 0 45 10.5t39 28.5t27.5 41.5t10.5 49.5q0 35 -18.5 61 t-50.5 26h-218l-45 -217h210zM404 404q22 0 43 10t37 27t25.5 40.5t9.5 50.5q0 35 -17.5 58t-46.5 23h-197l-45 -209h191z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C",
    unicode: "C",
    horizAdvX: 655,
    d: "M294 -6q-60 0 -107.5 25.5t-79.5 67.5t-49 96t-17 112q0 73 31 147.5t86 135t130.5 98.5t164.5 38q92 0 149 -43t75 -112l-100 -59q-7 32 -22 54t-35.5 35t-44.5 18.5t-48 5.5q-61 0 -111 -29t-85.5 -74.5t-55 -100.5t-19.5 -107q0 -42 11 -79.5t32 -66t51.5 -45 t69.5 -16.5q24 0 51.5 6.5t54 21t51 36.5t44.5 53l82 -53q-24 -40 -60 -70.5t-78 -51.5t-86.5 -32t-84.5 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D",
    unicode: "D",
    horizAdvX: 692,
    d: "M166 710h241q68 0 118 -21t82.5 -58t48.5 -87t16 -108q0 -94 -31.5 -174t-87 -138t-132 -91t-165.5 -33h-241zM277 99q64 0 115.5 26t88 70.5t56 102.5t19.5 121q0 42 -11 77t-32 60.5t-53 40t-74 14.5h-128l-109 -512h128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E",
    unicode: "E",
    horizAdvX: 579,
    d: "M166 710h455l-21 -99h-342l-43 -202h296l-19 -93h-297l-46 -217h351l-21 -99h-464z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F",
    unicode: "F",
    horizAdvX: 561,
    d: "M166 710h450l-21 -99h-337l-45 -212h282l-20 -93h-282l-65 -306h-113z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G",
    unicode: "G",
    horizAdvX: 691,
    d: "M505 87q-104 -92 -213 -92q-57 0 -103.5 23.5t-79.5 63.5t-50.5 94t-17.5 114q0 83 34 160t91 136t130.5 94t152.5 35q97 0 153.5 -42.5t76.5 -112.5l-98 -62q-16 58 -57.5 87t-99.5 29q-54 0 -103 -27t-85.5 -71.5t-58 -101t-21.5 -115.5q0 -42 11.5 -79t33 -64.5 t52.5 -43.5t69 -16q104 0 208 105l16 75h-140l18 83h233l-76 -359h-94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H",
    unicode: "H",
    horizAdvX: 715,
    d: "M166 710h113l-63 -297h332l63 297h112l-151 -710h-112l67 313h-332l-67 -313h-113z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "I",
    horizAdvX: 271,
    d: "M166 709h113l-151 -709h-113z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J",
    unicode: "J",
    horizAdvX: 475,
    d: "M96 -11q-85 0 -137 44l46 92q13 -12 42 -23.5t70 -11.5q43 0 72 16.5t49.5 49t35 81t28.5 112.5l77 360h112l-77 -360q-17 -81 -38.5 -147.5t-57 -113.5t-88.5 -73t-134 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K",
    unicode: "K",
    horizAdvX: 634,
    d: "M166 709h113l-78 -365l386 366h125l-331 -314l195 -396h-126l-154 327l-123 -113l-45 -214h-113z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L",
    unicode: "L",
    horizAdvX: 560,
    d: "M166 710h113l-130 -611h357l-21 -99h-470z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M",
    unicode: "M",
    horizAdvX: 834,
    d: "M166 710h120l126 -434l311 434h119l-151 -710h-113l109 511l-276 -387h-62l-112 387l-109 -511h-113z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N",
    unicode: "N",
    horizAdvX: 736,
    d: "M166 710h88l269 -512l108 511h113l-151 -709h-92l-267 500l-106 -500h-113z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O",
    unicode: "O",
    horizAdvX: 725,
    d: "M297 -5q-62 0 -109.5 24.5t-80 65t-49.5 93.5t-17 111q0 81 34.5 157.5t91.5 136.5t131 96t154 36q62 0 109.5 -25t79.5 -66t48.5 -94.5t16.5 -110.5q0 -80 -34 -156.5t-90.5 -136t-130.5 -95.5t-154 -36zM319 96q58 0 108 28.5t86.5 74t57 101.5t20.5 111q0 40 -10.5 77 t-31 64.5t-50.5 44t-70 16.5q-59 0 -108.5 -28.5t-86.5 -73.5t-57.5 -101.5t-20.5 -111.5q0 -41 10.5 -77.5t30.5 -64t50.5 -44t71.5 -16.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P",
    unicode: "P",
    horizAdvX: 601,
    d: "M166 710h284q39 0 70 -16t52.5 -43t33 -61.5t11.5 -71.5q0 -49 -21 -97.5t-56.5 -87t-83 -62.5t-100.5 -24h-176l-52 -247h-113zM371 346q26 0 49.5 13t41.5 35.5t28.5 52t10.5 62.5q0 46 -22.5 74t-57.5 28h-163l-57 -265h170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q",
    unicode: "Q",
    horizAdvX: 724,
    d: "M483 48q-43 -25 -90 -39t-96 -14q-62 0 -110 24.5t-80.5 65t-49.5 93.5t-17 111q0 81 34.5 157.5t91.5 136.5t131.5 96t154.5 36q61 0 108.5 -25t80 -66t49 -94.5t16.5 -110.5q0 -89 -41 -172t-108 -144l66 -103h-109zM319 96q31 0 59.5 8.5t54.5 23.5l-75 119h107 l38 -60q42 47 65 106t23 118q0 40 -10.5 77t-31 65t-51 44.5t-70.5 16.5q-58 0 -108 -28.5t-86.5 -74t-57 -102t-20.5 -111.5q0 -41 10.5 -77.5t30.5 -64t50.5 -44t71.5 -16.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R",
    unicode: "R",
    horizAdvX: 637,
    d: "M15 0l151 710h295q39 0 70 -16t52.5 -43t32.5 -61.5t11 -71.5q0 -40 -14 -79t-38 -72.5t-56.5 -59t-70.5 -37.5l100 -270h-127l-92 247h-149l-52 -247h-113zM382 346q25 0 48.5 13.5t41.5 36t28.5 51.5t10.5 59q0 45 -22 75t-56 30h-175l-57 -265h181z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S",
    unicode: "S",
    horizAdvX: 590,
    d: "M243 -7q-77 0 -144.5 24.5t-115.5 71.5l73 96q8 -13 27.5 -29t47 -29.5t62 -23t73.5 -9.5q72 0 110 28.5t38 79.5q0 22 -11.5 37.5t-32 27.5t-50 21.5t-65.5 20.5q-80 23 -121.5 56.5t-41.5 95.5q0 60 24 107t64.5 80t94 50t113.5 17q69 0 123 -23t90 -57l-70 -92 q-6 11 -22 23.5t-38 23.5t-49.5 18t-57.5 7q-76 0 -112.5 -32.5t-36.5 -83.5q0 -20 9 -34t27 -24.5t44.5 -19.5t61.5 -18q42 -11 75.5 -25t57.5 -33t37 -45.5t13 -63.5q0 -63 -24.5 -109t-66 -76t-95 -44t-111.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T",
    unicode: "T",
    horizAdvX: 589,
    d: "M303 611h-222l21 99h557l-21 -99h-222l-130 -611h-112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U",
    unicode: "U",
    horizAdvX: 722,
    d: "M296 -5q-63 0 -107 18.5t-71 50.5t-39.5 75.5t-12.5 93.5q0 55 14 117l76 360h113l-77 -360q-11 -53 -11 -97q0 -33 7 -62t23 -50t42 -33t64 -12q52 0 91 22t67.5 57.5t47 81t28.5 93.5l76 360h113l-77 -360q-15 -73 -45 -137.5t-75.5 -113t-107 -76.5t-139.5 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V",
    unicode: "V",
    horizAdvX: 648,
    d: "M91 710h119l77 -569l318 569h119l-419 -710h-96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W",
    unicode: "W",
    horizAdvX: 1002,
    d: "M88 710h121l83 -580l153 261l-48 316h105l30 -241l133 241h105l-182 -316l41 -261l329 580h123l-429 -710h-95l-56 318l-192 -318h-95z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X",
    unicode: "X",
    d: "M258 350l-170 360h124l123 -280l242 280h123l-322 -360l163 -350h-123l-117 270l-232 -270h-124z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y",
    unicode: "Y",
    d: "M237 256l-152 454h123l106 -356l260 356h122l-347 -456l-54 -254h-113z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z",
    unicode: "Z",
    horizAdvX: 598,
    d: "M-16 86l514 525h-392l21 99h523l-18 -86l-504 -525h393l-21 -99h-535z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketleft",
    unicode: "[",
    horizAdvX: 282,
    d: "M6 -40l166 780h159l-18 -89h-59l-128 -602h59l-19 -89h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "backslash",
    unicode: "\\\\\\\\",
    horizAdvX: 579,
    d: "M231 710l262 -710h-122l-263 710h123z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketright",
    unicode: "]",
    horizAdvX: 283,
    d: "M-28 -40l19 89h58l128 602h-58l19 89h160l-165 -780h-161z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciicircum",
    unicode: "^",
    horizAdvX: 572,
    d: "M49 303l198 407h93l197 -407h-92l-151 312l-155 -312h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "underscore",
    unicode: "_",
    horizAdvX: 470,
    d: "M-27 -99l21 99h352l-21 -99h-352z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "grave",
    unicode: "`",
    horizAdvX: 234,
    d: "M66 730h104l30 -110l-76 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a",
    unicode: "a",
    d: "M205 -10q-44 0 -78.5 17t-58.5 46t-36.5 68.5t-12.5 84.5q0 64 23.5 123t63.5 104t92 72t109 27t95.5 -30.5t54.5 -77.5l21 98h111l-84 -392q-1 -5 -1.5 -8.5t-0.5 -6.5q0 -20 23 -21l-20 -94q-14 -2 -25.5 -3.5t-19.5 -1.5q-65 0 -65 52q0 16 7 48q-38 -51 -92 -78 t-106 -27zM253 84q20 0 42.5 8t44 22t39.5 33t29 41l28 137q-3 24 -13.5 44.5t-26.5 36t-35 24t-40 8.5q-38 0 -71.5 -19t-59 -49t-40.5 -68.5t-15 -77.5q0 -30 8 -55.5t23.5 -44t37.5 -29.5t49 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "b",
    unicode: "b",
    horizAdvX: 605,
    d: "M272 -10q-60 0 -99 28.5t-56 76.5l-20 -95h-97l155 730h110l-64 -306q38 49 88.5 78.5t107.5 29.5q42 0 74.5 -17t54 -46t32.5 -67.5t11 -81.5q0 -67 -25 -127t-66.5 -105t-95 -71.5t-110.5 -26.5zM266 84q36 0 69.5 18t60 47.5t42 68.5t15.5 81q0 28 -7 53t-21 44 t-34.5 30.5t-47.5 11.5q-23 0 -46 -9t-44 -24.5t-39.5 -36t-33.5 -43.5l-30 -138q3 -44 35.5 -73.5t80.5 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c",
    unicode: "c",
    horizAdvX: 536,
    d: "M227 -10q-50 0 -89 17.5t-65.5 47.5t-40 70t-13.5 85q0 63 24.5 121t68 102.5t102 71.5t127.5 27q78 0 126 -35.5t64 -94.5l-114 -34q-11 33 -36.5 51.5t-61.5 18.5t-69.5 -16.5t-59.5 -46t-41.5 -68.5t-15.5 -84q0 -30 8 -55.5t23 -44t35.5 -29t45.5 -10.5q19 0 38 5.5 t36.5 15.5t31.5 23t23 28l101 -32q-18 -29 -44.5 -53.5t-58.5 -42.5t-69 -28t-76 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d",
    unicode: "d",
    horizAdvX: 614,
    d: "M205 -10q-44 0 -78.5 17t-58.5 46t-36.5 68.5t-12.5 84.5q0 64 23.5 123t63.5 104t92 72t109 27t95.5 -30.5t54.5 -77.5l65 306h111l-128 -600q-1 -5 -1.5 -8.5t-0.5 -6.5q0 -20 23 -21l-20 -94q-14 -2 -25.5 -3.5t-19.5 -1.5q-31 0 -48.5 13.5t-17.5 37.5q0 8 1.5 19 t6.5 30q-38 -51 -92 -78t-106 -27zM253 84q20 0 42.5 8t44 22t39.5 33t29 41l28 137q-3 24 -13.5 44.5t-26.5 36t-35 24t-40 8.5q-38 0 -71.5 -19t-59 -49t-40.5 -68.5t-15 -77.5q0 -30 8 -55.5t23.5 -44t37.5 -29.5t49 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "e",
    unicode: "e",
    horizAdvX: 545,
    d: "M229 -10q-50 0 -88.5 17t-65.5 46.5t-41 70t-14 87.5q0 64 24.5 122t68 102t103 70.5t128.5 26.5q81 0 129.5 -36.5t48.5 -107.5q0 -164 -293 -164q-43 0 -97 3v-18q0 -29 7 -54t21 -44t36 -29.5t52 -10.5q43 0 83 21.5t63 58.5l87 -27q-19 -30 -46.5 -54.5t-60.5 -42 t-70 -27.5t-75 -10zM330 451q-36 0 -66 -12.5t-53 -33.5t-39 -48.5t-26 -57.5q46 -3 85 -3q53 0 89 6.5t58.5 18t32 28t9.5 36.5q0 34 -24 50t-66 16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f",
    unicode: "f",
    horizAdvX: 347,
    d: "M117 425h-65l18 85h66l4 21q10 48 29.5 87t46.5 66t60 41.5t70 14.5q29 0 57.5 -8.5t52.5 -23.5l-41 -82q-12 9 -30.5 15t-35.5 6q-36 0 -61 -29t-37 -84l-5 -24h126l-19 -85h-126l-135 -637h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "g",
    unicode: "g",
    horizAdvX: 605,
    d: "M163 -223q-83 0 -131.5 29.5t-75.5 82.5l74 58q20 -42 59.5 -64t90.5 -22q32 0 62.5 9t56.5 28t44.5 48t26.5 69l16 80q-35 -48 -87 -74t-103 -26q-42 0 -75 17t-55.5 46t-34.5 67t-12 81q0 64 24 123t64.5 104t94 72t113.5 27t97.5 -30t57.5 -78l21 99h97l-108 -508 q-12 -57 -42 -101t-72 -74.5t-94 -46.5t-109 -16zM251 84q23 0 46 8.5t44 23t38 33t27 39.5l30 137q-8 50 -41 81.5t-76 31.5q-38 0 -72 -19.5t-59.5 -50t-40 -69t-14.5 -75.5q0 -29 8.5 -54.5t24 -44.5t37 -30t48.5 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "h",
    unicode: "h",
    horizAdvX: 574,
    d: "M155 730h110l-66 -312q40 54 95 84t113 30q68 0 94.5 -36t26.5 -91q0 -20 -2.5 -41.5t-7.5 -44.5l-67 -319h-110l62 293q7 32 7 59q0 42 -18 62t-51 20q-20 0 -43.5 -9t-46 -25.5t-42 -39t-32.5 -49.5l-67 -311h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i",
    unicode: "i",
    horizAdvX: 239,
    d: "M112 523h110l-112 -523h-110zM155 730h110l-25 -121h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j",
    unicode: "j",
    horizAdvX: 245,
    d: "M-90 -191q-35 0 -63.5 11t-48.5 34l64 74q10 -12 24.5 -17.5t30.5 -5.5q27 0 52.5 21.5t32.5 54.5l115 542h110l-113 -534q-9 -40 -29 -73t-48 -57t-60.5 -37t-66.5 -13zM161 730h110l-26 -121h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "k",
    unicode: "k",
    horizAdvX: 551,
    d: "M155 730h110l-73 -343q22 31 47.5 57t53.5 45.5t59 30.5t65 11q54 0 80.5 -29.5t26.5 -79.5q0 -65 -41 -119.5t-119 -89.5l107 -213h-118l-113 246q90 20 137 61.5t47 87.5q0 24 -13 34.5t-33 10.5q-30 0 -61.5 -16.5t-61 -44.5t-54.5 -65.5t-41 -79.5l-50 -234h-110z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l",
    unicode: "l",
    horizAdvX: 294,
    d: "M116 -8q-46 0 -70.5 22t-24.5 63q0 8 1 16.5t3 17.5l131 619h109l-122 -579q-3 -11 -3 -20q0 -20 11.5 -31t31.5 -11q11 0 26 4t29 9l-4 -86q-26 -11 -59 -17.5t-59 -6.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "m",
    unicode: "m",
    horizAdvX: 887,
    d: "M112 523h99l-22 -105q38 54 93.5 84t113.5 30q60 0 89.5 -31.5t31.5 -87.5q44 58 97 88.5t112 30.5q65 0 91 -35t26 -90q0 -18 -3 -40t-8 -48l-68 -319h-110l62 293q8 38 8 63q0 78 -64 78q-43 0 -86.5 -35t-71.5 -89l-65 -310h-110l62 293q5 20 6.5 35t1.5 29 q0 40 -16.5 58.5t-46.5 18.5q-43 0 -86.5 -34t-70.5 -89l-67 -311h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "n",
    unicode: "n",
    horizAdvX: 574,
    d: "M112 523h99l-22 -105q39 53 99 83.5t126 30.5q33 0 55 -9t35.5 -25.5t19.5 -38.5t6 -49q0 -21 -3.5 -44t-8.5 -47l-67 -319h-110l62 293q4 19 6 34.5t2 29.5q0 77 -64 77q-22 0 -46 -9t-47 -25.5t-43.5 -39t-33.5 -49.5l-67 -311h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "o",
    unicode: "o",
    horizAdvX: 582,
    d: "M224 -10q-50 0 -88 17.5t-64 47t-39.5 69t-13.5 84.5q0 63 25 121.5t68 103.5t101.5 72t125.5 27q50 0 88.5 -17.5t65 -47t40 -69.5t13.5 -85q0 -62 -25 -120t-68.5 -103t-102 -72.5t-126.5 -27.5zM245 84q35 0 68.5 17t59.5 46.5t42 68.5t16 83q0 60 -30.5 99.5 t-81.5 39.5q-35 0 -68 -17.5t-59.5 -47t-42.5 -68.5t-16 -83q0 -60 30.5 -99t81.5 -39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "p",
    unicode: "p",
    horizAdvX: 606,
    d: "M111 523h97l-20 -94q39 47 90 75t108 28q43 0 77 -17t57.5 -46.5t36 -69t12.5 -84.5q0 -63 -23 -122t-62.5 -104t-91 -72t-108.5 -27q-60 0 -98.5 30t-54.5 78l-66 -311h-110zM268 84q37 0 71 19t59.5 49t40.5 68.5t15 77.5q0 29 -8 54.5t-23.5 44.5t-37.5 30t-49 11 q-20 0 -42.5 -8t-44 -22t-39.5 -32.5t-28 -40.5l-30 -137q9 -48 40 -81t76 -33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q",
    unicode: "q",
    horizAdvX: 605,
    d: "M189 -10q-41 0 -72.5 16.5t-53 45.5t-33 67.5t-11.5 82.5q0 67 25 127t67 105t95.5 71.5t110.5 26.5q58 0 97.5 -29t56.5 -75l20 95h97l-128 -601q-2 -10 -2 -14q0 -21 26 -22l-20 -94q-14 -2 -29 -3t-27 -1q-32 0 -52 17t-20 46q0 8 3 17l48 230q-42 -54 -92 -81 t-106 -27zM248 84q46 0 86 28.5t72 71.5l29 138q-1 24 -10 45t-24 36.5t-35.5 25t-42.5 9.5q-37 0 -71 -18.5t-60.5 -49.5t-42 -70t-15.5 -79q0 -29 7.5 -53.5t22.5 -43.5t36 -29.5t48 -10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "r",
    unicode: "r",
    horizAdvX: 366,
    d: "M112 523h102l-26 -117q38 54 86 87t95 33q10 0 15.5 -0.5t10.5 -1.5l-21 -96q-60 -2 -112 -29.5t-84 -78.5l-68 -320h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s",
    unicode: "s",
    horizAdvX: 477,
    d: "M181 -10q-61 0 -116 20.5t-90 58.5l59 70q75 -69 161 -69q51 0 82 23t31 61q0 27 -25.5 41t-79.5 29q-38 11 -66 21.5t-46 24t-27 30.5t-9 40q0 44 19 79.5t51 60.5t74 38.5t89 13.5q56 0 100 -18t76 -52l-61 -66q-29 29 -63 43.5t-71 14.5q-44 0 -75 -21t-31 -64 q0 -25 21 -37.5t70 -25.5q42 -11 73 -23t51.5 -26.5t30.5 -33.5t10 -44q0 -42 -17.5 -76.5t-49 -59.5t-75.5 -39t-96 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t",
    unicode: "t",
    horizAdvX: 355,
    d: "M148 -8q-43 0 -72 20.5t-29 65.5q0 17 4 33l70 327h-67l19 85h65l37 172h110l-37 -172h108l-18 -85h-107l-62 -292q-2 -10 -2 -15q0 -20 12 -29t29 -9q23 0 44 8t32 13l4 -87q-23 -14 -61 -24.5t-79 -10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u",
    unicode: "u",
    horizAdvX: 586,
    d: "M150 -10q-122 0 -122 130q0 37 10 83l69 320h109l-64 -298q-7 -32 -7 -60q0 -81 69 -81q44 0 88.5 29t78.5 84l69 326h110l-83 -393q-3 -9 -3 -15q0 -19 23 -21l-19 -94q-15 -2 -26 -3.5t-20 -1.5q-30 0 -47 12.5t-17 37.5q0 8 2 21t7 40q-45 -57 -104 -86.5t-123 -29.5z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "v",
    unicode: "v",
    horizAdvX: 517,
    d: "M53 523h114l46 -430q76 111 129.5 215t84.5 215h103q-36 -131 -108.5 -261.5t-174.5 -261.5h-117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w",
    unicode: "w",
    horizAdvX: 778,
    d: "M46 523h110l73 -425q12 16 26 36t27.5 40.5t26 40.5l22.5 36l-64 272h104l33 -166q8 16 18 38t19.5 45t17.5 44.5t13 38.5h96q-43 -138 -125 -269l34 -145q40 55 73 106t59.5 101t47.5 101t38 106h102q-40 -131 -116 -261.5t-182 -261.5h-98l-33 158q-10 -14 -24 -35.5 t-29.5 -44t-30 -43.5t-26.5 -35h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "x",
    unicode: "x",
    horizAdvX: 501,
    d: "M182 261l-125 262h114l80 -179l5 -17l12 17l156 179h114l-236 -262l127 -261h-115l-81 178l-6 16l-11 -16l-157 -178h-115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y",
    unicode: "y",
    horizAdvX: 510,
    d: "M-40 -140q31 3 53 8.5t39 15t31.5 25t30.5 38.5l29 42l-94 534h113l59 -426l34 56q37 60 63.5 108.5t45.5 91.5t32.5 84t24.5 86h108q-14 -48 -29 -90t-38 -88.5t-56.5 -104t-82.5 -137.5l-80 -129q-35 -56 -66 -94t-62.5 -61.5t-65.5 -34t-74 -10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "z",
    unicode: "z",
    horizAdvX: 470,
    d: "M-22 69l369 376h-279l17 78h399l-15 -69l-367 -376h290l-17 -78h-412z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceleft",
    unicode: "{",
    horizAdvX: 285,
    d: "M262 651l-48 -224q-4 -17 -15.5 -35t-29.5 -32q18 -20 18 -51v-7.5t-1 -8.5l-50 -235h52l-18 -89h-130q-6 0 -11.5 4t-5.5 15q0 7 1 11l55 260q1 5 1 15q0 19 -8.5 32t-23.5 16l17 78q10 0 19.5 6t17.5 15.5t13.5 20t7.5 19.5l52 249q4 19 14 24.5t15 5.5h130l-20 -89 h-52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bar",
    unicode: "|",
    horizAdvX: 314,
    d: "M115 -130v905h94v-905h-94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceright",
    unicode: "}",
    horizAdvX: 286,
    d: "M121 651l19 89h129q5 0 11 -4t6 -17q0 -6 -1 -9l-53 -249q-2 -8 -2 -13q0 -17 8.5 -32.5t25.5 -15.5l-17 -78q-20 -4 -36.5 -21.5t-21.5 -41.5l-55 -260q-4 -17 -13 -23.5t-16 -6.5h-129l19 89h52l50 235q4 17 15.5 35t28.5 32q-17 22 -17 50v8.5t2 8.5l47 224h-52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciitilde",
    unicode: "~",
    horizAdvX: 529,
    d: "M45 232q1 7 10.5 27t27.5 41t44.5 37.5t61.5 16.5q25 0 44.5 -8.5t37 -19t35 -19t38.5 -8.5q19 0 33.5 7.5t23.5 16.5t13.5 17t4.5 10h62q-1 -4 -10 -23t-27.5 -40t-46 -38t-64.5 -17q-25 0 -45 8.5t-37.5 19t-35 19t-36.5 8.5t-32.5 -8.5t-22 -18.5t-12.5 -18.5t-4 -9.5 h-63v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00A0",
    unicode: "\xA0",
    horizAdvX: 242
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclamdown",
    unicode: "\xA1",
    horizAdvX: 273,
    d: "M225 460l-98 -464h-110l98 464h110zM279 713l-29 -137h-110l29 137h110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cent",
    unicode: "\xA2",
    horizAdvX: 559,
    d: "M177 -120l24 111q-41 3 -73.5 23t-55 50.5t-34 68.5t-11.5 78q0 55 21 108.5t58.5 98t90.5 74.5t118 39l25 114h50l-24 -114q68 -2 113 -35.5t62 -93.5l-114 -34q-9 31 -30.5 47.5t-50.5 18.5l-74 -347q15 2 31.5 7.5t32 14.5t28.5 21t20 26l101 -32q-20 -33 -50 -58.5 t-62.5 -42t-64.5 -25t-57 -8.5l-23 -110h-51zM141 222q0 -46 21.5 -83t59.5 -47l72 338q-33 -6 -61 -26.5t-48.5 -50t-32 -64t-11.5 -67.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sterling",
    unicode: "\xA3",
    horizAdvX: 507,
    d: "M71 378h74q-8 33 -16 65.5t-8 64.5q0 43 19.5 80.5t52 65.5t74 44.5t85.5 16.5q57 0 101 -28t67 -77l-73 -68q-15 38 -47 60.5t-68 22.5q-23 0 -43 -9t-35.5 -25t-24.5 -37.5t-9 -45.5q0 -30 9 -62t17 -68h174l-18 -84h-150q-2 -25 -8.5 -48t-21.5 -47t-39 -51.5 t-61 -61.5q21 5 38.5 8t34.5 3q18 0 34 -3t31 -6l30 -6t32 -3t35.5 4.5t43.5 12.5l9 -82q-26 -14 -56 -21.5t-57 -7.5q-22 0 -42 4t-40 9.5t-40.5 9.5t-43.5 4q-24 0 -57 -5.5t-63 -14.5l-8 79q79 63 114.5 114t37.5 109h-101z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "currency",
    unicode: "\xA4",
    horizAdvX: 571,
    d: "M185 491q22 15 49 23.5t59 8.5q31 0 57.5 -8.5t49.5 -23.5l70 71l48 -47l-70 -70q15 -23 23.5 -50.5t8.5 -57.5t-8.5 -57.5t-24.5 -50.5l71 -70l-43 -42l-73 68q-22 -15 -49.5 -24t-59.5 -9q-33 0 -60.5 9t-50.5 24l-72 -68l-43 42l71 71q-32 47 -32 107q0 30 7.5 57 t23.5 50l-70 71l48 47zM191 336q0 -24 8 -44.5t21.5 -35.5t32.5 -23.5t40 -8.5q43 0 72.5 32.5t29.5 81.5t-29.5 80.5t-72.5 31.5t-72.5 -32t-29.5 -82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yen",
    unicode: "\xA5",
    horizAdvX: 672,
    d: "M477 389h74l-16 -73h-112l-47 -62l-6 -29h146l-15 -73h-147l-32 -152h-112l32 152h-144l16 73h144l7 31l-19 60h-113l16 73h74l-109 321h122l105 -356l259 356h124z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "brokenbar",
    unicode: "\xA6",
    horizAdvX: 308,
    d: "M206 269v-399h-94v399h94zM206 775v-399h-94v399h94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "section",
    unicode: "\xA7",
    horizAdvX: 506,
    d: "M406 208q20 -20 20 -67q0 -60 -25.5 -103.5t-63.5 -71.5t-82 -41t-81 -13q-36 0 -65.5 10t-51.5 25t-38 32t-25 32l85 68q24 -33 51 -47.5t61 -14.5q21 0 41.5 6.5t37.5 19t27.5 31t10.5 41.5q0 17 -7 27t-17.5 15.5t-24.5 8t-27 3.5q-78 5 -120 41t-42 99q0 42 15 69 t26 41q-9 11 -15 32.5t-6 48.5q0 45 20.5 84t54.5 68t77 46t87 17q40 0 68.5 -11t48.5 -27.5t33 -36.5t21 -38l-94 -40q-8 28 -33.5 41.5t-57.5 13.5q-21 0 -41 -7t-36 -20t-25.5 -32t-9.5 -42q0 -34 22 -46t56 -13q31 -1 61.5 -8t54.5 -23t39 -41t15 -62q0 -19 -4.5 -36.5 t-11 -32.5t-14.5 -27t-15 -19zM176 309q0 -28 15.5 -40.5t37 -17.5t44.5 -6.5t37 -8.5q14 11 24 30t10 39q0 18 -7 30t-18.5 19.5t-25.5 10.5t-27 3q-17 0 -33.5 3t-25.5 8q-11 -11 -21 -29.5t-10 -40.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dieresis",
    unicode: "\xA8",
    horizAdvX: 400,
    d: "M73 615l24 110h91l-23 -110h-92zM245 615l23 110h91l-23 -110h-91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "copyright",
    unicode: "\xA9",
    horizAdvX: 852,
    d: "M435 -7q-80 0 -148.5 27.5t-118 76t-77.5 114.5t-28 144q0 77 28 143t77.5 114t118 75.5t148.5 27.5q81 0 150 -27.5t119.5 -75.5t79 -114t28.5 -143q0 -78 -28.5 -144t-79 -114.5t-119.5 -76t-150 -27.5zM435 37q69 0 129.5 23t104.5 65t69.5 100t25.5 128q0 68 -25 126 t-69 101t-104 67t-131 24q-70 0 -129.5 -24t-103 -67t-68 -101t-24.5 -125t24.5 -125t68 -100.5t103 -67t129.5 -24.5zM443 119q-52 0 -97 17.5t-78 49t-51.5 75t-18.5 94.5q0 44 15 86.5t45 76t75.5 54t105.5 20.5q75 0 130 -32.5t81 -89.5l-106 -34q-9 18 -21.5 30 t-26.5 18.5t-29 9.5t-28 3q-31 0 -55 -12t-40.5 -31.5t-25 -45.5t-8.5 -53q0 -34 12 -60.5t30.5 -44.5t42 -27.5t46.5 -9.5q32 0 62.5 16.5t44.5 46.5l107 -32q-10 -23 -29 -45.5t-46 -40t-61.5 -28.5t-75.5 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordfeminine",
    unicode: "\xAA",
    horizAdvX: 421,
    d: "M163 342q-42 0 -67.5 26t-25.5 65q0 30 13.5 55t36.5 43t53.5 28t65.5 10q47 0 81 -16l5 22q3 12 3 22q0 56 -63 56q-27 0 -55 -10t-60 -30l-14 53q76 46 148 46q60 0 93 -27t33 -78q0 -17 -5 -42l-25 -118q-1 -4 -1 -10q0 -15 18 -16l-16 -73q-10 -2 -18.5 -3t-15.5 -1 q-49 0 -49 36q0 8 4 27q-30 -32 -66 -48.5t-73 -16.5zM200 404q15 0 31.5 5t31 13t25 18.5t12.5 22.5l9 43q-13 8 -31 11t-35 3q-38 0 -65 -19t-27 -50q0 -20 13.5 -33.5t35.5 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotleft",
    unicode: "\xAB",
    horizAdvX: 601,
    d: "M35 284l286 185l-20 -91l-184 -119l134 -115l-19 -90l-209 175zM292 284l286 185l-19 -91l-184 -119l135 -115l-20 -90l-209 175z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "logicalnot",
    unicode: "\xAC",
    horizAdvX: 580,
    d: "M531 387l-58 -274h-94l37 175h-357l21 99h451z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00AD",
    unicode: "\xAD",
    horizAdvX: 571,
    d: "M43 224l21 99h452l-22 -99h-451z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "registered",
    unicode: "\xAE",
    horizAdvX: 852,
    d: "M436 -7q-81 0 -149 27.5t-118 76t-78 114.5t-28 144q0 77 28 143t78 114t118 75.5t149 27.5t149.5 -27.5t119 -75.5t79 -114t28.5 -143q0 -78 -28.5 -144t-79 -114.5t-119 -76t-149.5 -27.5zM436 36q69 0 128.5 23t104 65t69.5 100.5t25 129.5q0 67 -24.5 125 t-68.5 100.5t-104 67t-130 24.5q-71 0 -130 -24.5t-102.5 -67t-67.5 -100t-24 -124.5q0 -68 24 -126t67.5 -101t102.5 -67.5t130 -24.5zM278 577h193q30 0 55.5 -12.5t43.5 -33t28.5 -46.5t10.5 -53q0 -45 -24.5 -81t-63.5 -49l106 -169h-89l-98 155h-83v-155h-79v444z M466 357q31 0 48 20.5t17 54.5q0 35 -19.5 54.5t-48.5 19.5h-106v-149h109z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "macron",
    unicode: "\xAF",
    horizAdvX: 393,
    d: "M76 642l14 70h283l-15 -70h-282z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "degree",
    unicode: "\xB0",
    horizAdvX: 271,
    d: "M182 533q-33 0 -53.5 21t-20.5 54q0 22 9 42.5t24.5 37t36.5 26.5t45 10q35 0 55 -22t20 -54q0 -24 -9.5 -45t-25 -36.5t-36.5 -24.5t-45 -9zM194 589q17 0 32 14t15 33q0 15 -8 23.5t-22 8.5q-17 0 -32 -14t-15 -32q0 -15 8 -24t22 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plusminus",
    unicode: "\xB1",
    horizAdvX: 497,
    d: "M65 40v89h343v-89h-343zM408 417v-89h-122v-132h-99v132h-121v89h121v131h99v-131h122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twosuperior",
    unicode: "\xB2",
    horizAdvX: 392,
    d: "M53 395q8 40 21 70t32.5 52.5t47 39.5t63.5 31q26 10 52.5 19.5t48 21.5t35 28t13.5 40q0 23 -18.5 37t-55.5 14q-44 0 -76.5 -17t-52.5 -34l-32 48q8 8 24.5 20t40 22.5t54 18t65.5 7.5q64 0 96 -27.5t32 -74.5q0 -33 -11.5 -57t-32 -42t-50 -31.5t-65.5 -25.5 q-56 -18 -80.5 -44t-29.5 -51h208l-14 -65h-315z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threesuperior",
    unicode: "\xB3",
    horizAdvX: 385,
    d: "M204 389q-57 0 -91.5 22t-47.5 60l47 48q1 -9 7 -20t19 -20.5t32.5 -16t46.5 -6.5q21 0 41 4.5t35.5 13t25 20.5t9.5 27q0 29 -34 42.5t-94 13.5h-23l13 61h22q63 0 102 16t39 48q0 25 -23 37t-53 12q-37 0 -67 -14t-52 -37l-31 52q13 15 31.5 26t40 19t45 12t46.5 4 q62 0 99 -27.5t37 -72.5q0 -39 -29.5 -65.5t-80.5 -36.5q38 -6 58.5 -30t20.5 -59q0 -33 -17 -57.5t-44.5 -41.5t-61.5 -25.5t-68 -8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acute",
    unicode: "\xB4",
    horizAdvX: 233,
    d: "M96 602l-70 18l76 110h105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "mu",
    unicode: "\xB5",
    horizAdvX: 619,
    d: "M121 523h110l-64 -298q-8 -35 -8 -60q0 -81 72 -81q42 0 86.5 29t78.5 84l69 326h110l-83 -393q-1 -5 -1.5 -8t-0.5 -7q0 -20 26 -21l-21 -94q-15 -2 -27 -3.5t-21 -1.5q-30 0 -47 13t-17 36q0 8 1.5 21t8.5 41q-14 -21 -35.5 -42t-46.5 -37.5t-52.5 -26.5t-53.5 -10 q-38 0 -57.5 19.5t-22.5 48.5l-51 -270h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "paragraph",
    unicode: "\xB6",
    horizAdvX: 614,
    d: "M63 404q0 69 23 125.5t65.5 96.5t103.5 62t137 22h266l-18 -84h-67l-150 -706h-94l63 296h-54l-64 -296h-94l64 296q-87 2 -134 52.5t-47 135.5zM158 419q0 -57 29 -86.5t74 -32.5l70 326q-39 -1 -71 -17.5t-54.5 -44.5t-35 -65.5t-12.5 -79.5zM479 626h-54l-70 -326h54z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "periodcentered",
    unicode: "\xB7",
    horizAdvX: 211,
    d: "M47 243l29 137h91l-29 -137h-91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cedilla",
    unicode: "\xB8",
    horizAdvX: 297,
    d: "M17 -126q10 -7 32 -13.5t47 -6.5q29 0 46 9.5t17 31.5q0 15 -12 21t-31 6q-20 0 -43 -4t-36 -8l81 114l42 -15l-45 -54q8 2 16.5 3t15.5 1q29 0 47.5 -13t18.5 -40q0 -41 -33.5 -68t-100.5 -27q-30 0 -54 6t-41 14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onesuperior",
    unicode: "\xB9",
    horizAdvX: 278,
    d: "M292 461l-14 -66h-211l15 66h75l59 279q-6 -7 -18.5 -15.5t-27 -16t-29 -13t-26.5 -5.5l14 67q15 0 32.5 8.5t33 18.5t26 19t10.5 10h68l-75 -352h68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordmasculine",
    unicode: "\xBA",
    horizAdvX: 429,
    d: "M222 342q-35 0 -61 12t-44 32t-27 47t-9 57q0 43 17 83t46.5 71t69.5 49.5t87 18.5q34 0 60 -12t44 -32t27 -47t9 -58q0 -42 -16.5 -82t-46 -70.5t-69.5 -49.5t-87 -19zM237 414q22 0 43.5 11t38.5 30t27 44t10 53q0 38 -19.5 62.5t-51.5 24.5q-23 0 -44 -11t-37.5 -29.5 t-26.5 -44t-10 -53.5q0 -38 19 -62.5t51 -24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotright",
    unicode: "\xBB",
    horizAdvX: 601,
    d: "M547 229l-283 -175l19 90l183 115l-134 119l20 91l207 -185zM289 229l-284 -175l20 90l183 115l-133 119l18 91l208 -185z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onequarter",
    unicode: "\xBC",
    horizAdvX: 827,
    d: "M625 97h-212l14 64l286 253h46l-54 -252h58l-14 -65h-57l-21 -97h-66zM642 162l35 167l-184 -167h149zM88 40l338 333l323 343l42 -45l-332 -329l-329 -348zM282 379l-14 -66h-211l15 66h75l59 279q-7 -7 -19.5 -15.5t-26.5 -16t-29 -13t-26 -5.5l14 66q15 0 32.5 8.5 t33 19t26 19.5t10.5 10h68l-76 -352h69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onehalf",
    unicode: "\xBD",
    horizAdvX: 857,
    d: "M442 0q8 40 20.5 70t31 52.5t45 39.5t61.5 31q25 10 51 19t46.5 21t33.5 28.5t13 40.5q0 23 -18 37t-53 14q-42 0 -74 -17.5t-51 -34.5l-31 49q8 8 24 20t39 22.5t52 18t64 7.5q61 0 91.5 -27.5t30.5 -74.5q0 -32 -10 -56t-29.5 -42t-47.5 -32t-65 -26q-55 -18 -78.5 -44 t-28.5 -51h211l-15 -65h-313zM54 40l338 333l323 343l42 -45l-332 -329l-329 -348zM283 379l-14 -66h-211l15 66h75l59 279q-7 -7 -19.5 -15.5t-26.5 -16t-29 -13t-26 -5.5l14 66q15 0 32.5 8.5t33 19t26 19.5t10.5 10h68l-76 -352h69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threequarters",
    unicode: "\xBE",
    horizAdvX: 837,
    d: "M190 306q-60 0 -96 22t-39 61l47 48q0 -9 6.5 -19.5t19 -20.5t31.5 -16.5t45 -6.5q22 0 43 4.5t36.5 13t25 21t9.5 27.5q0 27 -34.5 41t-94.5 14h-22l12 61h22q64 0 103 16t39 49q0 23 -23.5 35.5t-52.5 12.5q-38 0 -68 -14.5t-51 -37.5l-32 53q13 15 31.5 26t40.5 19 t45.5 12t46.5 4q61 0 98.5 -28t37.5 -70q0 -41 -29.5 -67.5t-81.5 -36.5q38 -6 59 -30.5t21 -57.5t-17 -58.5t-44.5 -42.5t-62.5 -25.5t-71 -8.5zM633 97h-212l14 64l286 253h46l-54 -252h58l-14 -65h-57l-21 -97h-66zM650 162l35 167l-184 -167h149zM119 40l338 333 l323 343l42 -45l-332 -329l-329 -348z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "questiondown",
    unicode: "\xBF",
    horizAdvX: 461,
    d: "M334 285q-11 -52 -35.5 -92t-77.5 -69q-26 -14 -54 -28.5t-51 -33.5t-38.5 -44t-15.5 -60q0 -39 24 -60t58 -21q22 0 42.5 7.5t38.5 20t33 28t27 32.5l62 -49q-19 -31 -44.5 -55t-55 -40.5t-62 -25t-64.5 -8.5q-31 0 -60 9t-51 28t-35 48t-13 69q0 46 12 79t32.5 57 t48 42t58.5 34q21 11 41.5 22.5t38 26.5t30.5 35t19 48h92zM379 506l-27 -126h-91l26 126h92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Agrave",
    unicode: "\xC0",
    horizAdvX: 649,
    d: "M365 710h99l114 -710h-118l-28 193h-255l-109 -193h-118zM428 276l-40 305l-174 -305h214zM332 917h104l30 -110l-76 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aacute",
    unicode: "\xC1",
    horizAdvX: 649,
    d: "M365 710h99l114 -710h-118l-28 193h-255l-109 -193h-118zM428 276l-40 305l-174 -305h214zM438 788l-70 18l76 110h105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Acircumflex",
    unicode: "\xC2",
    horizAdvX: 649,
    d: "M365 710h99l114 -710h-118l-28 193h-255l-109 -193h-118zM428 276l-40 305l-174 -305h214zM300 821l119 95h80l78 -95l-64 -28l-67 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Atilde",
    unicode: "\xC3",
    horizAdvX: 649,
    d: "M365 710h99l114 -710h-118l-28 193h-255l-109 -193h-118zM428 276l-40 305l-174 -305h214zM492 801q-21 0 -36 6.5t-27 15t-24 15t-28 6.5t-26.5 -7t-17 -15.5t-9 -16.5t-2.5 -9h-63q2 8 11 27t25.5 38.5t39.5 34.5t53 15q21 0 35 -7t26 -15t24 -15t29 -7q18 0 29.5 7 t19 16t11 16.5t3.5 9.5h62q-2 -6 -11 -25t-26 -39t-41.5 -35.5t-56.5 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Adieresis",
    unicode: "\xC4",
    horizAdvX: 649,
    d: "M365 710h99l114 -710h-118l-28 193h-255l-109 -193h-118zM428 276l-40 305l-174 -305h214zM291 802l24 110h91l-23 -110h-92zM463 802l23 110h91l-23 -110h-91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aring",
    unicode: "\xC5",
    horizAdvX: 649,
    d: "M365 710h99l114 -710h-118l-28 193h-255l-109 -193h-118zM428 276l-40 305l-174 -305h214zM352 829q0 40 30 63.5t74 23.5q35 0 53.5 -15.5t18.5 -43.5q0 -39 -29 -63t-74 -24q-34 0 -53.5 16t-19.5 43zM448 880q-18 0 -32 -12t-14 -31q0 -13 8.5 -22t22.5 -9 q17 0 32 12.5t15 31.5q0 14 -9 22t-23 8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AE",
    unicode: "\xC6",
    horizAdvX: 926,
    d: "M495 710h475l-22 -99h-332l-42 -200h281l-21 -99h-281l-46 -213h341l-21 -99h-453l42 193h-225l-150 -193h-121zM428 293l62 288l-229 -288h167z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccedilla",
    unicode: "\xC7",
    horizAdvX: 652,
    d: "M182 -126q10 -7 32 -13.5t47 -6.5q29 0 46 9.5t17 31.5q0 15 -12 21t-31 6q-20 0 -43 -4t-36 -8l61 86q-54 6 -96 33t-70.5 68t-43.5 92.5t-15 105.5q0 73 31 147.5t86 135t130.5 98.5t164.5 38q92 0 149 -43t75 -112l-100 -59q-7 32 -22 54t-35.5 35t-44.5 18.5t-48 5.5 q-61 0 -111 -29t-85.5 -74.5t-55 -100.5t-19.5 -107q0 -42 11 -79.5t32 -66t51.5 -45t69.5 -16.5q24 0 51.5 6.5t54 21t51 36.5t44.5 53l82 -53q-23 -37 -56 -66.5t-71 -50t-79.5 -32.5t-80.5 -15l-33 -40q8 2 16.5 3t15.5 1q29 0 47.5 -13t18.5 -40q0 -41 -33.5 -68 t-100.5 -27q-30 0 -54 6t-41 14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Egrave",
    unicode: "\xC8",
    horizAdvX: 579,
    d: "M166 710h455l-21 -99h-342l-43 -202h296l-19 -93h-297l-46 -217h351l-21 -99h-464zM338 917h104l30 -110l-76 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eacute",
    unicode: "\xC9",
    horizAdvX: 579,
    d: "M432 788l-70 18l76 110h105zM166 710h455l-21 -99h-342l-43 -202h296l-19 -93h-297l-46 -217h351l-21 -99h-464z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecircumflex",
    unicode: "\xCA",
    horizAdvX: 579,
    d: "M285 821l119 95h80l78 -95l-64 -28l-67 63l-94 -63zM166 710h455l-21 -99h-342l-43 -202h296l-19 -93h-297l-46 -217h351l-21 -99h-464z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edieresis",
    unicode: "\xCB",
    horizAdvX: 579,
    d: "M282 802l24 110h91l-23 -110h-92zM454 802l23 110h91l-23 -110h-91zM166 710h455l-21 -99h-342l-43 -202h296l-19 -93h-297l-46 -217h351l-21 -99h-464z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Igrave",
    unicode: "\xCC",
    horizAdvX: 271,
    d: "M166 709h113l-151 -709h-113zM162 917h104l30 -110l-76 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iacute",
    unicode: "\xCD",
    horizAdvX: 271,
    d: "M166 709h113l-151 -709h-113zM242 788l-70 18l76 110h105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Icircumflex",
    unicode: "\xCE",
    horizAdvX: 271,
    d: "M166 709h113l-151 -709h-113zM106 821l119 95h80l78 -95l-64 -28l-67 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idieresis",
    unicode: "\xCF",
    horizAdvX: 271,
    d: "M166 709h113l-151 -709h-113zM110 802l24 110h91l-23 -110h-92zM282 802l23 110h91l-23 -110h-91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eth",
    unicode: "\xD0",
    horizAdvX: 698,
    d: "M57 399h49l66 311h241q68 0 118 -21t82.5 -58t48.5 -87t16 -108q0 -94 -31.5 -174t-87 -138t-132 -91t-165.5 -33h-241l67 315h-49zM283 99q64 0 115.5 26t88 70.5t56 102.5t19.5 121q0 42 -11 77t-32 60.5t-53 40t-74 14.5h-128l-45 -212h140l-17 -84h-141l-46 -216h128 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ntilde",
    unicode: "\xD1",
    horizAdvX: 736,
    d: "M166 710h88l269 -512l108 511h113l-151 -709h-92l-267 500l-106 -500h-113zM535 801q-21 0 -36 6.5t-27 15t-24 15t-28 6.5t-26.5 -7t-17 -15.5t-9 -16.5t-2.5 -9h-63q2 8 11 27t25.5 38.5t39.5 34.5t53 15q21 0 35 -7t26 -15t24 -15t29 -7q18 0 29.5 7t19 16t11 16.5 t3.5 9.5h62q-2 -6 -11 -25t-26 -39t-41.5 -35.5t-56.5 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ograve",
    unicode: "\xD2",
    horizAdvX: 725,
    d: "M297 -5q-62 0 -109.5 24.5t-80 65t-49.5 93.5t-17 111q0 81 34.5 157.5t91.5 136.5t131 96t154 36q62 0 109.5 -25t79.5 -66t48.5 -94.5t16.5 -110.5q0 -80 -34 -156.5t-90.5 -136t-130.5 -95.5t-154 -36zM319 96q58 0 108 28.5t86.5 74t57 101.5t20.5 111q0 40 -10.5 77 t-31 64.5t-50.5 44t-70 16.5q-59 0 -108.5 -28.5t-86.5 -73.5t-57.5 -101.5t-20.5 -111.5q0 -41 10.5 -77.5t30.5 -64t50.5 -44t71.5 -16.5zM408 917h104l30 -110l-76 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oacute",
    unicode: "\xD3",
    horizAdvX: 725,
    d: "M484 788l-70 18l76 110h105zM297 -5q-62 0 -109.5 24.5t-80 65t-49.5 93.5t-17 111q0 81 34.5 157.5t91.5 136.5t131 96t154 36q62 0 109.5 -25t79.5 -66t48.5 -94.5t16.5 -110.5q0 -80 -34 -156.5t-90.5 -136t-130.5 -95.5t-154 -36zM319 96q58 0 108 28.5t86.5 74 t57 101.5t20.5 111q0 40 -10.5 77t-31 64.5t-50.5 44t-70 16.5q-59 0 -108.5 -28.5t-86.5 -73.5t-57.5 -101.5t-20.5 -111.5q0 -41 10.5 -77.5t30.5 -64t50.5 -44t71.5 -16.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ocircumflex",
    unicode: "\xD4",
    horizAdvX: 725,
    d: "M341 821l119 95h80l78 -95l-64 -28l-67 63l-94 -63zM297 -5q-62 0 -109.5 24.5t-80 65t-49.5 93.5t-17 111q0 81 34.5 157.5t91.5 136.5t131 96t154 36q62 0 109.5 -25t79.5 -66t48.5 -94.5t16.5 -110.5q0 -80 -34 -156.5t-90.5 -136t-130.5 -95.5t-154 -36zM319 96 q58 0 108 28.5t86.5 74t57 101.5t20.5 111q0 40 -10.5 77t-31 64.5t-50.5 44t-70 16.5q-59 0 -108.5 -28.5t-86.5 -73.5t-57.5 -101.5t-20.5 -111.5q0 -41 10.5 -77.5t30.5 -64t50.5 -44t71.5 -16.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Otilde",
    unicode: "\xD5",
    horizAdvX: 725,
    d: "M297 -5q-62 0 -109.5 24.5t-80 65t-49.5 93.5t-17 111q0 81 34.5 157.5t91.5 136.5t131 96t154 36q62 0 109.5 -25t79.5 -66t48.5 -94.5t16.5 -110.5q0 -80 -34 -156.5t-90.5 -136t-130.5 -95.5t-154 -36zM319 96q58 0 108 28.5t86.5 74t57 101.5t20.5 111q0 40 -10.5 77 t-31 64.5t-50.5 44t-70 16.5q-59 0 -108.5 -28.5t-86.5 -73.5t-57.5 -101.5t-20.5 -111.5q0 -41 10.5 -77.5t30.5 -64t50.5 -44t71.5 -16.5zM533 801q-21 0 -36 6.5t-27 15t-24 15t-28 6.5t-26.5 -7t-17 -15.5t-9 -16.5t-2.5 -9h-63q2 8 11 27t25.5 38.5t39.5 34.5t53 15 q21 0 35 -7t26 -15t24 -15t29 -7q18 0 29.5 7t19 16t11 16.5t3.5 9.5h62q-2 -6 -11 -25t-26 -39t-41.5 -35.5t-56.5 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odieresis",
    unicode: "\xD6",
    horizAdvX: 725,
    d: "M339 802l24 110h91l-23 -110h-92zM511 802l23 110h91l-23 -110h-91zM297 -5q-62 0 -109.5 24.5t-80 65t-49.5 93.5t-17 111q0 81 34.5 157.5t91.5 136.5t131 96t154 36q62 0 109.5 -25t79.5 -66t48.5 -94.5t16.5 -110.5q0 -80 -34 -156.5t-90.5 -136t-130.5 -95.5 t-154 -36zM319 96q58 0 108 28.5t86.5 74t57 101.5t20.5 111q0 40 -10.5 77t-31 64.5t-50.5 44t-70 16.5q-59 0 -108.5 -28.5t-86.5 -73.5t-57.5 -101.5t-20.5 -111.5q0 -41 10.5 -77.5t30.5 -64t50.5 -44t71.5 -16.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "multiply",
    unicode: "\xD7",
    horizAdvX: 479,
    d: "M411 164l-70 -68l-110 109l-109 -109l-69 69l109 109l-106 107l70 68l106 -106l106 107l69 -69l-106 -107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oslash",
    unicode: "\xD8",
    horizAdvX: 725,
    d: "M745 710l-91 -105q26 -40 39 -87.5t13 -98.5q0 -80 -34 -156.5t-90.5 -136t-130.5 -95.5t-154 -36q-41 0 -75 10.5t-62 29.5l-30 -35h-122l87 100q-27 39 -40.5 87.5t-13.5 101.5q0 81 34.5 157.5t91.5 136.5t131 96t154 36q41 0 75.5 -11.5t62.5 -31.5l33 38h122z M156 298q0 -29 4.5 -55.5t14.5 -49.5l341 393q-38 27 -87 27q-59 0 -108.5 -28.5t-86.5 -73.5t-57.5 -101.5t-20.5 -111.5zM319 96q58 0 108 28.5t86.5 74t57 101.5t20.5 111q0 27 -5 52t-14 48l-338 -391q17 -11 38 -17.5t47 -6.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ugrave",
    unicode: "\xD9",
    horizAdvX: 721,
    d: "M296 -5q-63 0 -107 18.5t-71 50.5t-39.5 75.5t-12.5 93.5q0 55 14 117l76 360h113l-77 -360q-11 -53 -11 -97q0 -33 7 -62t23 -50t42 -33t64 -12q52 0 91 22t67.5 57.5t47 81t28.5 93.5l76 360h113l-77 -360q-15 -73 -45 -137.5t-75.5 -113t-107 -76.5t-139.5 -28z M390 917h104l30 -110l-76 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uacute",
    unicode: "\xDA",
    horizAdvX: 721,
    d: "M472 788l-70 18l76 110h105zM296 -5q-63 0 -107 18.5t-71 50.5t-39.5 75.5t-12.5 93.5q0 55 14 117l76 360h113l-77 -360q-11 -53 -11 -97q0 -33 7 -62t23 -50t42 -33t64 -12q52 0 91 22t67.5 57.5t47 81t28.5 93.5l76 360h113l-77 -360q-15 -73 -45 -137.5t-75.5 -113 t-107 -76.5t-139.5 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ucircumflex",
    unicode: "\xDB",
    horizAdvX: 721,
    d: "M327 821l119 95h80l78 -95l-64 -28l-67 63l-94 -63zM296 -5q-63 0 -107 18.5t-71 50.5t-39.5 75.5t-12.5 93.5q0 55 14 117l76 360h113l-77 -360q-11 -53 -11 -97q0 -33 7 -62t23 -50t42 -33t64 -12q52 0 91 22t67.5 57.5t47 81t28.5 93.5l76 360h113l-77 -360 q-15 -73 -45 -137.5t-75.5 -113t-107 -76.5t-139.5 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udieresis",
    unicode: "\xDC",
    horizAdvX: 721,
    d: "M329 802l24 110h91l-23 -110h-92zM501 802l23 110h91l-23 -110h-91zM296 -5q-63 0 -107 18.5t-71 50.5t-39.5 75.5t-12.5 93.5q0 55 14 117l76 360h113l-77 -360q-11 -53 -11 -97q0 -33 7 -62t23 -50t42 -33t64 -12q52 0 91 22t67.5 57.5t47 81t28.5 93.5l76 360h113 l-77 -360q-15 -73 -45 -137.5t-75.5 -113t-107 -76.5t-139.5 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Yacute",
    unicode: "\xDD",
    d: "M237 256l-152 454h123l106 -356l260 356h122l-347 -456l-54 -254h-113zM413 788l-70 18l76 110h105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Thorn",
    unicode: "\xDE",
    horizAdvX: 582,
    d: "M166 710h113l-28 -133h154q39 0 70 -16t52.5 -43t33 -61.5t11.5 -70.5q0 -50 -21 -98.5t-56.5 -87t-82.5 -62.5t-100 -24h-160l-24 -114h-113zM328 214q26 0 49.5 14t41 36.5t28 51t10.5 58.5q0 45 -22 74.5t-57 29.5h-149l-56 -264h155z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "germandbls",
    unicode: "\xDF",
    horizAdvX: 535,
    d: "M192 95q38 1 71 10t57.5 28t38.5 47t14 66q0 47 -27 73t-71 26h-20l21 100h19q23 0 42.5 8.5t33.5 23t22 34t8 42.5q0 34 -21 50.5t-50 16.5q-24 0 -44 -9.5t-34.5 -26t-24.5 -38t-15 -45.5l-107 -501h-105l111 520q9 42 32 78t56 61.5t73.5 40t85.5 14.5q69 0 111 -36 t42 -98q0 -30 -11 -59t-28.5 -53t-40 -41.5t-44.5 -24.5q50 -13 75 -54.5t25 -96.5q0 -65 -26 -112.5t-69.5 -79t-101 -47.5t-120.5 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "agrave",
    unicode: "\xE0",
    d: "M205 -10q-44 0 -78.5 17t-58.5 46t-36.5 68.5t-12.5 84.5q0 64 23.5 123t63.5 104t92 72t109 27t95.5 -30.5t54.5 -77.5l21 98h111l-84 -392q-1 -5 -1.5 -8.5t-0.5 -6.5q0 -20 23 -21l-20 -94q-14 -2 -25.5 -3.5t-19.5 -1.5q-65 0 -65 52q0 16 7 48q-38 -51 -92 -78 t-106 -27zM253 84q20 0 42.5 8t44 22t39.5 33t29 41l28 137q-3 24 -13.5 44.5t-26.5 36t-35 24t-40 8.5q-38 0 -71.5 -19t-59 -49t-40.5 -68.5t-15 -77.5q0 -30 8 -55.5t23.5 -44t37.5 -29.5t49 -11zM250 730h104l30 -110l-76 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aacute",
    unicode: "\xE1",
    d: "M205 -10q-44 0 -78.5 17t-58.5 46t-36.5 68.5t-12.5 84.5q0 64 23.5 123t63.5 104t92 72t109 27t95.5 -30.5t54.5 -77.5l21 98h111l-84 -392q-1 -5 -1.5 -8.5t-0.5 -6.5q0 -20 23 -21l-20 -94q-14 -2 -25.5 -3.5t-19.5 -1.5q-65 0 -65 52q0 16 7 48q-38 -51 -92 -78 t-106 -27zM253 84q20 0 42.5 8t44 22t39.5 33t29 41l28 137q-3 24 -13.5 44.5t-26.5 36t-35 24t-40 8.5q-38 0 -71.5 -19t-59 -49t-40.5 -68.5t-15 -77.5q0 -30 8 -55.5t23.5 -44t37.5 -29.5t49 -11zM358 602l-70 18l76 110h105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acircumflex",
    unicode: "\xE2",
    d: "M205 -10q-44 0 -78.5 17t-58.5 46t-36.5 68.5t-12.5 84.5q0 64 23.5 123t63.5 104t92 72t109 27t95.5 -30.5t54.5 -77.5l21 98h111l-84 -392q-1 -5 -1.5 -8.5t-0.5 -6.5q0 -20 23 -21l-20 -94q-14 -2 -25.5 -3.5t-19.5 -1.5q-65 0 -65 52q0 16 7 48q-38 -51 -92 -78 t-106 -27zM253 84q20 0 42.5 8t44 22t39.5 33t29 41l28 137q-3 24 -13.5 44.5t-26.5 36t-35 24t-40 8.5q-38 0 -71.5 -19t-59 -49t-40.5 -68.5t-15 -77.5q0 -30 8 -55.5t23.5 -44t37.5 -29.5t49 -11zM208 635l119 95h80l78 -95l-64 -28l-67 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "atilde",
    unicode: "\xE3",
    d: "M205 -10q-44 0 -78.5 17t-58.5 46t-36.5 68.5t-12.5 84.5q0 64 23.5 123t63.5 104t92 72t109 27t95.5 -30.5t54.5 -77.5l21 98h111l-84 -392q-1 -5 -1.5 -8.5t-0.5 -6.5q0 -20 23 -21l-20 -94q-14 -2 -25.5 -3.5t-19.5 -1.5q-65 0 -65 52q0 16 7 48q-38 -51 -92 -78 t-106 -27zM253 84q20 0 42.5 8t44 22t39.5 33t29 41l28 137q-3 24 -13.5 44.5t-26.5 36t-35 24t-40 8.5q-38 0 -71.5 -19t-59 -49t-40.5 -68.5t-15 -77.5q0 -30 8 -55.5t23.5 -44t37.5 -29.5t49 -11zM398 615q-21 0 -36 6.5t-27 15t-24 15t-28 6.5t-26.5 -7t-17 -15.5 t-9 -16.5t-2.5 -9h-63q2 8 11 27t25.5 38.5t39.5 34.5t53 15q21 0 35 -7t26 -15t24 -15t29 -7q18 0 29.5 7t19 16t11 16.5t3.5 9.5h62q-2 -6 -11 -25t-26 -39t-41.5 -35.5t-56.5 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adieresis",
    unicode: "\xE4",
    d: "M205 -10q-44 0 -78.5 17t-58.5 46t-36.5 68.5t-12.5 84.5q0 64 23.5 123t63.5 104t92 72t109 27t95.5 -30.5t54.5 -77.5l21 98h111l-84 -392q-1 -5 -1.5 -8.5t-0.5 -6.5q0 -20 23 -21l-20 -94q-14 -2 -25.5 -3.5t-19.5 -1.5q-65 0 -65 52q0 16 7 48q-38 -51 -92 -78 t-106 -27zM253 84q20 0 42.5 8t44 22t39.5 33t29 41l28 137q-3 24 -13.5 44.5t-26.5 36t-35 24t-40 8.5q-38 0 -71.5 -19t-59 -49t-40.5 -68.5t-15 -77.5q0 -30 8 -55.5t23.5 -44t37.5 -29.5t49 -11zM211 615l24 110h91l-23 -110h-92zM383 615l23 110h91l-23 -110h-91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aring",
    unicode: "\xE5",
    d: "M205 -10q-44 0 -78.5 17t-58.5 46t-36.5 68.5t-12.5 84.5q0 64 23.5 123t63.5 104t92 72t109 27t95.5 -30.5t54.5 -77.5l21 98h111l-84 -392q-1 -5 -1.5 -8.5t-0.5 -6.5q0 -20 23 -21l-20 -94q-14 -2 -25.5 -3.5t-19.5 -1.5q-65 0 -65 52q0 16 7 48q-38 -51 -92 -78 t-106 -27zM253 84q20 0 42.5 8t44 22t39.5 33t29 41l28 137q-3 24 -13.5 44.5t-26.5 36t-35 24t-40 8.5q-38 0 -71.5 -19t-59 -49t-40.5 -68.5t-15 -77.5q0 -30 8 -55.5t23.5 -44t37.5 -29.5t49 -11zM260 643q0 40 30 63.5t74 23.5q35 0 53.5 -15.5t18.5 -43.5 q0 -39 -29 -63t-74 -24q-34 0 -53.5 16t-19.5 43zM356 694q-18 0 -32 -12t-14 -31q0 -13 8.5 -22t22.5 -9q17 0 32 12.5t15 31.5q0 14 -9 22t-23 8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ae",
    unicode: "\xE6",
    horizAdvX: 891,
    d: "M132 -10q-66 0 -103 38.5t-37 96.5q0 42 19.5 78t53 61.5t79 40t97.5 14.5q32 0 61 -5t52 -15q6 23 14 40t8 37q0 34 -24.5 56t-72.5 22q-39 0 -80 -15.5t-89 -44.5l-19 70q112 68 216 68q60 0 98.5 -22t55.5 -63q40 38 91 61.5t109 23.5q50 0 88 -17t64 -47t39.5 -70 t13.5 -85q0 -36 -6.5 -57.5t-10.5 -30.5h-401q-3 -14 -3 -27q0 -58 34.5 -92.5t87.5 -34.5q21 0 42 5.5t40 16t35 25.5t27 33l89 -27q-19 -29 -46 -53.5t-60 -42.5t-70.5 -28t-76.5 -10q-70 0 -117.5 30t-70.5 81q-23 -30 -52.5 -51t-60.5 -34.5t-60.5 -19.5t-53.5 -6z M180 71q21 0 45.5 7t47 18.5t40.5 27t26 32.5q-3 12 -3 29q0 13 1.5 27t3.5 26q-21 8 -46.5 13t-48.5 5q-31 0 -58 -8t-46.5 -22.5t-30.5 -34.5t-11 -44q0 -32 20 -54t60 -22zM755 295q3 15 3 29q0 57 -31.5 92t-85.5 35q-30 0 -58.5 -11.5t-52.5 -32.5t-42 -49.5t-28 -62.5 h295z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccedilla",
    unicode: "\xE7",
    horizAdvX: 536,
    d: "M119 -126q10 -7 32 -13.5t47 -6.5q29 0 46 9.5t17 31.5q0 15 -12 21t-31 6q-20 0 -43 -4t-36 -8l58 82q-43 5 -76.5 24t-56 48t-34 66.5t-11.5 79.5q0 63 24.5 121t68 102.5t102 71.5t127.5 27q78 0 126 -35.5t64 -94.5l-114 -34q-11 33 -36.5 51.5t-61.5 18.5 t-69.5 -16.5t-59.5 -46t-41.5 -68.5t-15.5 -84q0 -30 8 -55.5t23 -44t35.5 -29t45.5 -10.5q19 0 38 5.5t36.5 15.5t31.5 23t23 28l101 -32q-35 -55 -95 -91.5t-133 -41.5l-30 -36q8 2 16.5 3t15.5 1q29 0 47.5 -13t18.5 -40q0 -41 -33.5 -68t-100.5 -27q-30 0 -54 6t-41 14z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "egrave",
    unicode: "\xE8",
    horizAdvX: 545,
    d: "M229 -10q-50 0 -88.5 17t-65.5 46.5t-41 70t-14 87.5q0 64 24.5 122t68 102t103 70.5t128.5 26.5q81 0 129.5 -36.5t48.5 -107.5q0 -164 -293 -164q-43 0 -97 3v-18q0 -29 7 -54t21 -44t36 -29.5t52 -10.5q43 0 83 21.5t63 58.5l87 -27q-19 -30 -46.5 -54.5t-60.5 -42 t-70 -27.5t-75 -10zM330 451q-36 0 -66 -12.5t-53 -33.5t-39 -48.5t-26 -57.5q46 -3 85 -3q53 0 89 6.5t58.5 18t32 28t9.5 36.5q0 34 -24 50t-66 16zM276 730h104l30 -110l-76 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eacute",
    unicode: "\xE9",
    horizAdvX: 545,
    d: "M357 602l-70 18l76 110h105zM229 -10q-50 0 -88.5 17t-65.5 46.5t-41 70t-14 87.5q0 64 24.5 122t68 102t103 70.5t128.5 26.5q81 0 129.5 -36.5t48.5 -107.5q0 -164 -293 -164q-43 0 -97 3v-18q0 -29 7 -54t21 -44t36 -29.5t52 -10.5q43 0 83 21.5t63 58.5l87 -27 q-19 -30 -46.5 -54.5t-60.5 -42t-70 -27.5t-75 -10zM330 451q-36 0 -66 -12.5t-53 -33.5t-39 -48.5t-26 -57.5q46 -3 85 -3q53 0 89 6.5t58.5 18t32 28t9.5 36.5q0 34 -24 50t-66 16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecircumflex",
    unicode: "\xEA",
    horizAdvX: 545,
    d: "M227 635l119 95h80l78 -95l-64 -28l-67 63l-94 -63zM229 -10q-50 0 -88.5 17t-65.5 46.5t-41 70t-14 87.5q0 64 24.5 122t68 102t103 70.5t128.5 26.5q81 0 129.5 -36.5t48.5 -107.5q0 -164 -293 -164q-43 0 -97 3v-18q0 -29 7 -54t21 -44t36 -29.5t52 -10.5 q43 0 83 21.5t63 58.5l87 -27q-19 -30 -46.5 -54.5t-60.5 -42t-70 -27.5t-75 -10zM330 451q-36 0 -66 -12.5t-53 -33.5t-39 -48.5t-26 -57.5q46 -3 85 -3q53 0 89 6.5t58.5 18t32 28t9.5 36.5q0 34 -24 50t-66 16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edieresis",
    unicode: "\xEB",
    horizAdvX: 545,
    d: "M223 615l24 110h91l-23 -110h-92zM395 615l23 110h91l-23 -110h-91zM229 -10q-50 0 -88.5 17t-65.5 46.5t-41 70t-14 87.5q0 64 24.5 122t68 102t103 70.5t128.5 26.5q81 0 129.5 -36.5t48.5 -107.5q0 -164 -293 -164q-43 0 -97 3v-18q0 -29 7 -54t21 -44t36 -29.5 t52 -10.5q43 0 83 21.5t63 58.5l87 -27q-19 -30 -46.5 -54.5t-60.5 -42t-70 -27.5t-75 -10zM330 451q-36 0 -66 -12.5t-53 -33.5t-39 -48.5t-26 -57.5q46 -3 85 -3q53 0 89 6.5t58.5 18t32 28t9.5 36.5q0 34 -24 50t-66 16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "igrave",
    unicode: "\xEC",
    horizAdvX: 239,
    d: "M112 523h110l-112 -523h-110zM98 730h104l30 -110l-76 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iacute",
    unicode: "\xED",
    horizAdvX: 239,
    d: "M196 602l-70 18l76 110h105zM112 523h110l-112 -523h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "icircumflex",
    unicode: "\xEE",
    horizAdvX: 239,
    d: "M56 635l119 95h80l78 -95l-64 -28l-67 63l-94 -63zM112 523h110l-112 -523h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idieresis",
    unicode: "\xEF",
    horizAdvX: 239,
    d: "M51 615l24 110h91l-23 -110h-92zM223 615l23 110h91l-23 -110h-91zM112 523h110l-112 -523h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eth",
    unicode: "\xF0",
    horizAdvX: 587,
    d: "M572 668l-83 -44q36 -58 52 -124t16 -126q0 -88 -28 -159t-74.5 -121t-107 -77t-126.5 -27q-46 0 -84 15.5t-65 42.5t-42 63.5t-15 79.5q0 56 24.5 107t64.5 90t91.5 62t106.5 23q54 0 93.5 -25.5t56.5 -67.5q0 17 -1 33t-4 31q-5 36 -17 70.5t-33 68.5l-102 -56l-23 45 l95 51q-45 55 -123 107h145q42 -29 71 -66l89 49zM129 205q0 -26 8.5 -48t23.5 -38t36 -25.5t47 -9.5q36 0 68.5 15t57.5 40t40 57.5t15 68.5q0 51 -31 85t-84 34q-35 0 -68 -14.5t-58 -39t-40 -57t-15 -68.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ntilde",
    unicode: "\xF1",
    horizAdvX: 574,
    d: "M112 523h99l-22 -105q39 53 99 83.5t126 30.5q33 0 55 -9t35.5 -25.5t19.5 -38.5t6 -49q0 -21 -3.5 -44t-8.5 -47l-67 -319h-110l62 293q4 19 6 34.5t2 29.5q0 77 -64 77q-22 0 -46 -9t-47 -25.5t-43.5 -39t-33.5 -49.5l-67 -311h-110zM395 615q-21 0 -36 6.5t-27 15 t-24 15t-28 6.5t-26.5 -7t-17 -15.5t-9 -16.5t-2.5 -9h-63q2 8 11 27t25.5 38.5t39.5 34.5t53 15q21 0 35 -7t26 -15t24 -15t29 -7q18 0 29.5 7t19 16t11 16.5t3.5 9.5h62q-2 -6 -11 -25t-26 -39t-41.5 -35.5t-56.5 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ograve",
    unicode: "\xF2",
    horizAdvX: 582,
    d: "M224 -10q-50 0 -88 17.5t-64 47t-39.5 69t-13.5 84.5q0 63 25 121.5t68 103.5t101.5 72t125.5 27q50 0 88.5 -17.5t65 -47t40 -69.5t13.5 -85q0 -62 -25 -120t-68.5 -103t-102 -72.5t-126.5 -27.5zM245 84q35 0 68.5 17t59.5 46.5t42 68.5t16 83q0 60 -30.5 99.5 t-81.5 39.5q-35 0 -68 -17.5t-59.5 -47t-42.5 -68.5t-16 -83q0 -60 30.5 -99t81.5 -39zM275 730h104l30 -110l-76 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oacute",
    unicode: "\xF3",
    horizAdvX: 582,
    d: "M363 602l-70 18l76 110h105zM224 -10q-50 0 -88 17.5t-64 47t-39.5 69t-13.5 84.5q0 63 25 121.5t68 103.5t101.5 72t125.5 27q50 0 88.5 -17.5t65 -47t40 -69.5t13.5 -85q0 -62 -25 -120t-68.5 -103t-102 -72.5t-126.5 -27.5zM245 84q35 0 68.5 17t59.5 46.5t42 68.5 t16 83q0 60 -30.5 99.5t-81.5 39.5q-35 0 -68 -17.5t-59.5 -47t-42.5 -68.5t-16 -83q0 -60 30.5 -99t81.5 -39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ocircumflex",
    unicode: "\xF4",
    horizAdvX: 582,
    d: "M223 635l119 95h80l78 -95l-64 -28l-67 63l-94 -63zM224 -10q-50 0 -88 17.5t-64 47t-39.5 69t-13.5 84.5q0 63 25 121.5t68 103.5t101.5 72t125.5 27q50 0 88.5 -17.5t65 -47t40 -69.5t13.5 -85q0 -62 -25 -120t-68.5 -103t-102 -72.5t-126.5 -27.5zM245 84 q35 0 68.5 17t59.5 46.5t42 68.5t16 83q0 60 -30.5 99.5t-81.5 39.5q-35 0 -68 -17.5t-59.5 -47t-42.5 -68.5t-16 -83q0 -60 30.5 -99t81.5 -39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "otilde",
    unicode: "\xF5",
    horizAdvX: 582,
    d: "M224 -10q-50 0 -88 17.5t-64 47t-39.5 69t-13.5 84.5q0 63 25 121.5t68 103.5t101.5 72t125.5 27q50 0 88.5 -17.5t65 -47t40 -69.5t13.5 -85q0 -62 -25 -120t-68.5 -103t-102 -72.5t-126.5 -27.5zM245 84q35 0 68.5 17t59.5 46.5t42 68.5t16 83q0 60 -30.5 99.5 t-81.5 39.5q-35 0 -68 -17.5t-59.5 -47t-42.5 -68.5t-16 -83q0 -60 30.5 -99t81.5 -39zM413 615q-21 0 -36 6.5t-27 15t-24 15t-28 6.5t-26.5 -7t-17 -15.5t-9 -16.5t-2.5 -9h-63q2 8 11 27t25.5 38.5t39.5 34.5t53 15q21 0 35 -7t26 -15t24 -15t29 -7q18 0 29.5 7t19 16 t11 16.5t3.5 9.5h62q-2 -6 -11 -25t-26 -39t-41.5 -35.5t-56.5 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odieresis",
    unicode: "\xF6",
    horizAdvX: 582,
    d: "M227 615l24 110h91l-23 -110h-92zM399 615l23 110h91l-23 -110h-91zM224 -10q-50 0 -88 17.5t-64 47t-39.5 69t-13.5 84.5q0 63 25 121.5t68 103.5t101.5 72t125.5 27q50 0 88.5 -17.5t65 -47t40 -69.5t13.5 -85q0 -62 -25 -120t-68.5 -103t-102 -72.5t-126.5 -27.5z M245 84q35 0 68.5 17t59.5 46.5t42 68.5t16 83q0 60 -30.5 99.5t-81.5 39.5q-35 0 -68 -17.5t-59.5 -47t-42.5 -68.5t-16 -83q0 -60 30.5 -99t81.5 -39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "divide",
    unicode: "\xF7",
    horizAdvX: 527,
    d: "M214 411v115h94v-115h-94zM214 58v114h94v-114h-94zM59 248v88h403v-88h-403z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oslash",
    unicode: "\xF8",
    horizAdvX: 582,
    d: "M66 62q-23 29 -35 66.5t-12 79.5q0 63 25 121.5t68.5 103.5t102 72t125.5 27q38 0 69 -10.5t56 -28.5l33 33h65l-66 -64q24 -29 36.5 -67.5t12.5 -81.5q0 -62 -24.5 -120t-68 -103t-102 -72.5t-126.5 -27.5q-39 0 -71 10.5t-57 30.5l-34 -34h-64zM245 84q35 0 68.5 17 t60 46.5t42.5 68.5t16 83q0 23 -5 42.5t-13 36.5l-240 -267q29 -27 71 -27zM133 222q0 -44 17 -78l238 267q-29 27 -69 27q-35 0 -68 -17.5t-59.5 -47t-42.5 -68.5t-16 -83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ugrave",
    unicode: "\xF9",
    horizAdvX: 586,
    d: "M150 -10q-122 0 -122 130q0 37 10 83l69 320h109l-64 -298q-7 -32 -7 -60q0 -81 69 -81q44 0 88.5 29t78.5 84l69 326h110l-83 -393q-3 -9 -3 -15q0 -19 23 -21l-19 -94q-15 -2 -26 -3.5t-20 -1.5q-30 0 -47 12.5t-17 37.5q0 8 2 21t7 40q-45 -57 -104 -86.5t-123 -29.5z M265 730h104l30 -110l-76 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uacute",
    unicode: "\xFA",
    horizAdvX: 586,
    d: "M346 602l-70 18l76 110h105zM150 -10q-122 0 -122 130q0 37 10 83l69 320h109l-64 -298q-7 -32 -7 -60q0 -81 69 -81q44 0 88.5 29t78.5 84l69 326h110l-83 -393q-3 -9 -3 -15q0 -19 23 -21l-19 -94q-15 -2 -26 -3.5t-20 -1.5q-30 0 -47 12.5t-17 37.5q0 8 2 21t7 40 q-45 -57 -104 -86.5t-123 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ucircumflex",
    unicode: "\xFB",
    horizAdvX: 586,
    d: "M222 635l119 95h80l78 -95l-64 -28l-67 63l-94 -63zM150 -10q-122 0 -122 130q0 37 10 83l69 320h109l-64 -298q-7 -32 -7 -60q0 -81 69 -81q44 0 88.5 29t78.5 84l69 326h110l-83 -393q-3 -9 -3 -15q0 -19 23 -21l-19 -94q-15 -2 -26 -3.5t-20 -1.5q-30 0 -47 12.5 t-17 37.5q0 8 2 21t7 40q-45 -57 -104 -86.5t-123 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udieresis",
    unicode: "\xFC",
    horizAdvX: 586,
    d: "M216 615l24 110h91l-23 -110h-92zM388 615l23 110h91l-23 -110h-91zM150 -10q-122 0 -122 130q0 37 10 83l69 320h109l-64 -298q-7 -32 -7 -60q0 -81 69 -81q44 0 88.5 29t78.5 84l69 326h110l-83 -393q-3 -9 -3 -15q0 -19 23 -21l-19 -94q-15 -2 -26 -3.5t-20 -1.5 q-30 0 -47 12.5t-17 37.5q0 8 2 21t7 40q-45 -57 -104 -86.5t-123 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yacute",
    unicode: "\xFD",
    horizAdvX: 510,
    d: "M-40 -140q31 3 53 8.5t39 15t31.5 25t30.5 38.5l29 42l-94 534h113l59 -426l34 56q37 60 63.5 108.5t45.5 91.5t32.5 84t24.5 86h108q-14 -48 -29 -90t-38 -88.5t-56.5 -104t-82.5 -137.5l-80 -129q-35 -56 -66 -94t-62.5 -61.5t-65.5 -34t-74 -10.5zM312 602l-70 18 l76 110h105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "thorn",
    unicode: "\xFE",
    horizAdvX: 577,
    d: "M151 710h113q-2 -8 -5 -22.5t-7 -33t-8.5 -40t-8.5 -42.5q-11 -49 -23 -107q25 29 59.5 50t84.5 21q46 0 81.5 -18t59 -48t35.5 -69t12 -80q0 -57 -22.5 -117.5t-63.5 -110.5t-97.5 -82t-123.5 -32q-54 0 -79.5 20t-35.5 45q-13 -62 -24 -114q-5 -22 -9.5 -44.5t-8.5 -42 t-7.5 -34.5t-4.5 -22h-113zM256 79q37 0 69 19t55.5 49.5t36.5 70t13 81.5q0 28 -6.5 53.5t-19.5 44t-32.5 29.5t-44.5 11q-42 0 -78 -28.5t-64 -68.5l-35 -166q-1 -3 -1.5 -5.5t-0.5 -7.5q0 -15 8 -29.5t22.5 -26.5t34 -19t43.5 -7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ydieresis",
    unicode: "\xFF",
    horizAdvX: 510,
    d: "M-40 -140q31 3 53 8.5t39 15t31.5 25t30.5 38.5l29 42l-94 534h113l59 -426l34 56q37 60 63.5 108.5t45.5 91.5t32.5 84t24.5 86h108q-14 -48 -29 -90t-38 -88.5t-56.5 -104t-82.5 -137.5l-80 -129q-35 -56 -66 -94t-62.5 -61.5t-65.5 -34t-74 -10.5zM171 615l24 110h91 l-23 -110h-92zM343 615l23 110h91l-23 -110h-91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Amacron",
    unicode: "\u0100",
    horizAdvX: 649,
    d: "M365 710h99l114 -710h-118l-28 193h-255l-109 -193h-118zM428 276l-40 305l-174 -305h214zM295 828l14 70h283l-15 -70h-282z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "amacron",
    unicode: "\u0101",
    d: "M205 -10q-44 0 -78.5 17t-58.5 46t-36.5 68.5t-12.5 84.5q0 64 23.5 123t63.5 104t92 72t109 27t95.5 -30.5t54.5 -77.5l21 98h111l-84 -392q-1 -5 -1.5 -8.5t-0.5 -6.5q0 -20 23 -21l-20 -94q-14 -2 -25.5 -3.5t-19.5 -1.5q-65 0 -65 52q0 16 7 48q-38 -51 -92 -78 t-106 -27zM253 84q20 0 42.5 8t44 22t39.5 33t29 41l28 137q-3 24 -13.5 44.5t-26.5 36t-35 24t-40 8.5q-38 0 -71.5 -19t-59 -49t-40.5 -68.5t-15 -77.5q0 -30 8 -55.5t23.5 -44t37.5 -29.5t49 -11zM216 642l14 70h283l-15 -70h-282z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Abreve",
    unicode: "\u0102",
    horizAdvX: 649,
    d: "M365 710h99l114 -710h-118l-28 193h-255l-109 -193h-118zM428 276l-40 305l-174 -305h214zM435 845q21 0 41 20t29 51h61q-6 -26 -19.5 -48.5t-32.5 -39t-42 -25.5t-48 -9q-43 0 -68.5 25.5t-25.5 67.5q0 8 1 15t3 14h61q-1 -5 -1.5 -9t-0.5 -9q0 -22 11.5 -37.5 t30.5 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "abreve",
    unicode: "\u0103",
    d: "M205 -10q-44 0 -78.5 17t-58.5 46t-36.5 68.5t-12.5 84.5q0 64 23.5 123t63.5 104t92 72t109 27t95.5 -30.5t54.5 -77.5l21 98h111l-84 -392q-1 -5 -1.5 -8.5t-0.5 -6.5q0 -20 23 -21l-20 -94q-14 -2 -25.5 -3.5t-19.5 -1.5q-65 0 -65 52q0 16 7 48q-38 -51 -92 -78 t-106 -27zM253 84q20 0 42.5 8t44 22t39.5 33t29 41l28 137q-3 24 -13.5 44.5t-26.5 36t-35 24t-40 8.5q-38 0 -71.5 -19t-59 -49t-40.5 -68.5t-15 -77.5q0 -30 8 -55.5t23.5 -44t37.5 -29.5t49 -11zM344 659q21 0 41 20t29 51h61q-6 -26 -19.5 -48.5t-32.5 -39t-42 -25.5 t-48 -9q-43 0 -68.5 25.5t-25.5 67.5q0 8 1 15t3 14h61q-1 -5 -1.5 -9t-0.5 -9q0 -22 11.5 -37.5t30.5 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aogonek",
    unicode: "\u0104",
    horizAdvX: 649,
    d: "M495 -188q-42 7 -62 26t-20 44q0 29 24 58.5t75 59.5h-52l-28 193h-255l-109 -193h-118l415 710h99l114 -710q-51 -29 -73 -51.5t-22 -43.5q0 -32 48 -35zM428 276l-40 305l-174 -305h214z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aogonek",
    unicode: "\u0105",
    d: "M423 -188q-42 7 -62 26t-20 44q0 29 23 58t72 58q-40 9 -40 49q0 16 7 48q-38 -51 -92 -78t-106 -27q-44 0 -78.5 17t-58.5 46t-36.5 68.5t-12.5 84.5q0 64 23.5 123t63.5 104t92 72t109 27t95.5 -30.5t54.5 -77.5l21 98h111l-84 -392q-1 -5 -1.5 -8.5t-0.5 -6.5 q0 -20 23 -21l-20 -94q-51 -29 -73 -51.5t-22 -43.5q0 -32 48 -35zM253 84q20 0 42.5 8t44 22t39.5 33t29 41l28 137q-3 24 -13.5 44.5t-26.5 36t-35 24t-40 8.5q-38 0 -71.5 -19t-59 -49t-40.5 -68.5t-15 -77.5q0 -30 8 -55.5t23.5 -44t37.5 -29.5t49 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cacute",
    unicode: "\u0106",
    horizAdvX: 655,
    d: "M484 788l-70 18l76 110h105zM294 -6q-60 0 -107.5 25.5t-79.5 67.5t-49 96t-17 112q0 73 31 147.5t86 135t130.5 98.5t164.5 38q92 0 149 -43t75 -112l-100 -59q-7 32 -22 54t-35.5 35t-44.5 18.5t-48 5.5q-61 0 -111 -29t-85.5 -74.5t-55 -100.5t-19.5 -107 q0 -42 11 -79.5t32 -66t51.5 -45t69.5 -16.5q24 0 51.5 6.5t54 21t51 36.5t44.5 53l82 -53q-24 -40 -60 -70.5t-78 -51.5t-86.5 -32t-84.5 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cacute",
    unicode: "\u0107",
    horizAdvX: 536,
    d: "M355 602l-70 18l76 110h105zM227 -10q-50 0 -89 17.5t-65.5 47.5t-40 70t-13.5 85q0 63 24.5 121t68 102.5t102 71.5t127.5 27q78 0 126 -35.5t64 -94.5l-114 -34q-11 33 -36.5 51.5t-61.5 18.5t-69.5 -16.5t-59.5 -46t-41.5 -68.5t-15.5 -84q0 -30 8 -55.5t23 -44 t35.5 -29t45.5 -10.5q19 0 38 5.5t36.5 15.5t31.5 23t23 28l101 -32q-18 -29 -44.5 -53.5t-58.5 -42.5t-69 -28t-76 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccircumflex",
    unicode: "\u0108",
    horizAdvX: 655,
    d: "M345 821l119 95h80l78 -95l-64 -28l-67 63l-94 -63zM294 -6q-60 0 -107.5 25.5t-79.5 67.5t-49 96t-17 112q0 73 31 147.5t86 135t130.5 98.5t164.5 38q92 0 149 -43t75 -112l-100 -59q-7 32 -22 54t-35.5 35t-44.5 18.5t-48 5.5q-61 0 -111 -29t-85.5 -74.5t-55 -100.5 t-19.5 -107q0 -42 11 -79.5t32 -66t51.5 -45t69.5 -16.5q24 0 51.5 6.5t54 21t51 36.5t44.5 53l82 -53q-24 -40 -60 -70.5t-78 -51.5t-86.5 -32t-84.5 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccircumflex",
    unicode: "\u0109",
    horizAdvX: 536,
    d: "M224 635l119 95h80l78 -95l-64 -28l-67 63l-94 -63zM227 -10q-50 0 -89 17.5t-65.5 47.5t-40 70t-13.5 85q0 63 24.5 121t68 102.5t102 71.5t127.5 27q78 0 126 -35.5t64 -94.5l-114 -34q-11 33 -36.5 51.5t-61.5 18.5t-69.5 -16.5t-59.5 -46t-41.5 -68.5t-15.5 -84 q0 -30 8 -55.5t23 -44t35.5 -29t45.5 -10.5q19 0 38 5.5t36.5 15.5t31.5 23t23 28l101 -32q-18 -29 -44.5 -53.5t-58.5 -42.5t-69 -28t-76 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cdotaccent",
    unicode: "\u010A",
    horizAdvX: 655,
    d: "M294 -6q-60 0 -107.5 25.5t-79.5 67.5t-49 96t-17 112q0 73 31 147.5t86 135t130.5 98.5t164.5 38q92 0 149 -43t75 -112l-100 -59q-7 32 -22 54t-35.5 35t-44.5 18.5t-48 5.5q-61 0 -111 -29t-85.5 -74.5t-55 -100.5t-19.5 -107q0 -42 11 -79.5t32 -66t51.5 -45 t69.5 -16.5q24 0 51.5 6.5t54 21t51 36.5t44.5 53l82 -53q-24 -40 -60 -70.5t-78 -51.5t-86.5 -32t-84.5 -11zM429 801l25 115h98l-24 -115h-99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cdotaccent",
    unicode: "\u010B",
    horizAdvX: 536,
    d: "M227 -10q-50 0 -89 17.5t-65.5 47.5t-40 70t-13.5 85q0 63 24.5 121t68 102.5t102 71.5t127.5 27q78 0 126 -35.5t64 -94.5l-114 -34q-11 33 -36.5 51.5t-61.5 18.5t-69.5 -16.5t-59.5 -46t-41.5 -68.5t-15.5 -84q0 -30 8 -55.5t23 -44t35.5 -29t45.5 -10.5q19 0 38 5.5 t36.5 15.5t31.5 23t23 28l101 -32q-18 -29 -44.5 -53.5t-58.5 -42.5t-69 -28t-76 -10zM307 615l25 115h98l-24 -115h-99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccaron",
    unicode: "\u010C",
    horizAdvX: 655,
    d: "M355 888l64 28l67 -63l94 63l52 -28l-119 -95h-80zM294 -6q-60 0 -107.5 25.5t-79.5 67.5t-49 96t-17 112q0 73 31 147.5t86 135t130.5 98.5t164.5 38q92 0 149 -43t75 -112l-100 -59q-7 32 -22 54t-35.5 35t-44.5 18.5t-48 5.5q-61 0 -111 -29t-85.5 -74.5t-55 -100.5 t-19.5 -107q0 -42 11 -79.5t32 -66t51.5 -45t69.5 -16.5q24 0 51.5 6.5t54 21t51 36.5t44.5 53l82 -53q-24 -40 -60 -70.5t-78 -51.5t-86.5 -32t-84.5 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccaron",
    unicode: "\u010D",
    horizAdvX: 536,
    d: "M233 702l64 28l67 -63l94 63l52 -28l-119 -95h-80zM227 -10q-50 0 -89 17.5t-65.5 47.5t-40 70t-13.5 85q0 63 24.5 121t68 102.5t102 71.5t127.5 27q78 0 126 -35.5t64 -94.5l-114 -34q-11 33 -36.5 51.5t-61.5 18.5t-69.5 -16.5t-59.5 -46t-41.5 -68.5t-15.5 -84 q0 -30 8 -55.5t23 -44t35.5 -29t45.5 -10.5q19 0 38 5.5t36.5 15.5t31.5 23t23 28l101 -32q-18 -29 -44.5 -53.5t-58.5 -42.5t-69 -28t-76 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcaron",
    unicode: "\u010E",
    horizAdvX: 692,
    d: "M297 888l64 28l67 -63l94 63l52 -28l-119 -95h-80zM166 710h241q68 0 118 -21t82.5 -58t48.5 -87t16 -108q0 -94 -31.5 -174t-87 -138t-132 -91t-165.5 -33h-241zM277 99q64 0 115.5 26t88 70.5t56 102.5t19.5 121q0 42 -11 77t-32 60.5t-53 40t-74 14.5h-128l-109 -512 h128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcaron",
    unicode: "\u010F",
    horizAdvX: 614,
    d: "M654 620l76 110h104l-114 -132zM205 -10q-44 0 -78.5 17t-58.5 46t-36.5 68.5t-12.5 84.5q0 64 23.5 123t63.5 104t92 72t109 27t95.5 -30.5t54.5 -77.5l65 306h111l-128 -600q-1 -5 -1.5 -8.5t-0.5 -6.5q0 -20 23 -21l-20 -94q-14 -2 -25.5 -3.5t-19.5 -1.5 q-31 0 -48.5 13.5t-17.5 37.5q0 8 1.5 19t6.5 30q-38 -51 -92 -78t-106 -27zM253 84q20 0 42.5 8t44 22t39.5 33t29 41l28 137q-3 24 -13.5 44.5t-26.5 36t-35 24t-40 8.5q-38 0 -71.5 -19t-59 -49t-40.5 -68.5t-15 -77.5q0 -30 8 -55.5t23.5 -44t37.5 -29.5t49 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcroat",
    unicode: "\u0110",
    horizAdvX: 698,
    d: "M57 399h49l66 311h241q68 0 118 -21t82.5 -58t48.5 -87t16 -108q0 -94 -31.5 -174t-87 -138t-132 -91t-165.5 -33h-241l67 315h-49zM283 99q64 0 115.5 26t88 70.5t56 102.5t19.5 121q0 42 -11 77t-32 60.5t-53 40t-74 14.5h-128l-45 -212h140l-17 -84h-141l-46 -216h128 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcroat",
    unicode: "\u0111",
    horizAdvX: 614,
    d: "M421 664h87l14 66h111l-14 -66h73l-14 -68h-74l-99 -466q-1 -5 -1.5 -8.5t-0.5 -6.5q0 -20 23 -21l-20 -94q-14 -2 -25.5 -3.5t-19.5 -1.5q-32 0 -48.5 14t-16.5 37q0 6 1 18.5t6 30.5q-38 -51 -92 -78t-106 -27q-44 0 -78.5 17t-58.5 46t-36.5 68.5t-12.5 84.5 q0 64 23.5 123t63.5 104t92 72t109 27t95.5 -30.5t54.5 -77.5l36 172h-86zM253 84q20 0 42.5 8t44 22t39.5 33t29 41l28 137q-3 24 -13.5 44.5t-26.5 36t-35 24t-40 8.5q-38 0 -71.5 -19t-59 -49t-40.5 -68.5t-15 -77.5q0 -30 8 -55.5t23.5 -44t37.5 -29.5t49 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Emacron",
    unicode: "\u0112",
    horizAdvX: 579,
    d: "M166 710h455l-21 -99h-342l-43 -202h296l-19 -93h-297l-46 -217h351l-21 -99h-464zM277 828l14 70h283l-15 -70h-282z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emacron",
    unicode: "\u0113",
    horizAdvX: 545,
    d: "M229 -10q-50 0 -88.5 17t-65.5 46.5t-41 70t-14 87.5q0 64 24.5 122t68 102t103 70.5t128.5 26.5q81 0 129.5 -36.5t48.5 -107.5q0 -164 -293 -164q-43 0 -97 3v-18q0 -29 7 -54t21 -44t36 -29.5t52 -10.5q43 0 83 21.5t63 58.5l87 -27q-19 -30 -46.5 -54.5t-60.5 -42 t-70 -27.5t-75 -10zM330 451q-36 0 -66 -12.5t-53 -33.5t-39 -48.5t-26 -57.5q46 -3 85 -3q53 0 89 6.5t58.5 18t32 28t9.5 36.5q0 34 -24 50t-66 16zM217 642l14 70h283l-15 -70h-282z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ebreve",
    unicode: "\u0114",
    horizAdvX: 579,
    d: "M166 710h455l-21 -99h-342l-43 -202h296l-19 -93h-297l-46 -217h351l-21 -99h-464zM413 845q21 0 41 20t29 51h61q-6 -26 -19.5 -48.5t-32.5 -39t-42 -25.5t-48 -9q-43 0 -68.5 25.5t-25.5 67.5q0 8 1 15t3 14h61q-1 -5 -1.5 -9t-0.5 -9q0 -22 11.5 -37.5t30.5 -15.5z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ebreve",
    unicode: "\u0115",
    horizAdvX: 545,
    d: "M229 -10q-50 0 -88.5 17t-65.5 46.5t-41 70t-14 87.5q0 64 24.5 122t68 102t103 70.5t128.5 26.5q81 0 129.5 -36.5t48.5 -107.5q0 -164 -293 -164q-43 0 -97 3v-18q0 -29 7 -54t21 -44t36 -29.5t52 -10.5q43 0 83 21.5t63 58.5l87 -27q-19 -30 -46.5 -54.5t-60.5 -42 t-70 -27.5t-75 -10zM330 451q-36 0 -66 -12.5t-53 -33.5t-39 -48.5t-26 -57.5q46 -3 85 -3q53 0 89 6.5t58.5 18t32 28t9.5 36.5q0 34 -24 50t-66 16zM357 659q21 0 41 20t29 51h61q-6 -26 -19.5 -48.5t-32.5 -39t-42 -25.5t-48 -9q-43 0 -68.5 25.5t-25.5 67.5q0 8 1 15 t3 14h61q-1 -5 -1.5 -9t-0.5 -9q0 -22 11.5 -37.5t30.5 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edotaccent",
    unicode: "\u0116",
    horizAdvX: 579,
    d: "M166 710h455l-21 -99h-342l-43 -202h296l-19 -93h-297l-46 -217h351l-21 -99h-464zM364 801l25 115h98l-24 -115h-99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edotaccent",
    unicode: "\u0117",
    horizAdvX: 545,
    d: "M229 -10q-50 0 -88.5 17t-65.5 46.5t-41 70t-14 87.5q0 64 24.5 122t68 102t103 70.5t128.5 26.5q81 0 129.5 -36.5t48.5 -107.5q0 -164 -293 -164q-43 0 -97 3v-18q0 -29 7 -54t21 -44t36 -29.5t52 -10.5q43 0 83 21.5t63 58.5l87 -27q-19 -30 -46.5 -54.5t-60.5 -42 t-70 -27.5t-75 -10zM330 451q-36 0 -66 -12.5t-53 -33.5t-39 -48.5t-26 -57.5q46 -3 85 -3q53 0 89 6.5t58.5 18t32 28t9.5 36.5q0 34 -24 50t-66 16zM308 615l25 115h98l-24 -115h-99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eogonek",
    unicode: "\u0118",
    horizAdvX: 579,
    d: "M166 710h455l-21 -99h-342l-43 -202h296l-19 -93h-297l-46 -217h351l-21 -99h-193q-51 -29 -73 -51.5t-22 -43.5q0 -32 48 -35l-36 -58q-42 7 -62 26t-20 44q0 29 24 58.5t75 59.5h-205z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eogonek",
    unicode: "\u0119",
    horizAdvX: 545,
    d: "M198 -193q-42 7 -62 26t-20 44q0 28 22 56.5t70 57.5q-45 3 -80 21t-59 47.5t-36.5 68t-12.5 83.5q0 64 24.5 122t68 102t103 70.5t128.5 26.5q81 0 129.5 -36.5t48.5 -107.5q0 -164 -293 -164q-43 0 -97 3v-18q0 -29 7 -54t21 -44t36 -29.5t52 -10.5q43 0 83 21.5 t63 58.5l87 -27q-32 -50 -85 -84t-115 -45q-51 -29 -73 -51.5t-22 -43.5q0 -32 48 -35zM330 451q-36 0 -66 -12.5t-53 -33.5t-39 -48.5t-26 -57.5q46 -3 85 -3q53 0 89 6.5t58.5 18t32 28t9.5 36.5q0 34 -24 50t-66 16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecaron",
    unicode: "\u011A",
    horizAdvX: 579,
    d: "M288 888l64 28l67 -63l94 63l52 -28l-119 -95h-80zM166 710h455l-21 -99h-342l-43 -202h296l-19 -93h-297l-46 -217h351l-21 -99h-464z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecaron",
    unicode: "\u011B",
    horizAdvX: 545,
    d: "M234 702l64 28l67 -63l94 63l52 -28l-119 -95h-80zM229 -10q-50 0 -88.5 17t-65.5 46.5t-41 70t-14 87.5q0 64 24.5 122t68 102t103 70.5t128.5 26.5q81 0 129.5 -36.5t48.5 -107.5q0 -164 -293 -164q-43 0 -97 3v-18q0 -29 7 -54t21 -44t36 -29.5t52 -10.5q43 0 83 21.5 t63 58.5l87 -27q-19 -30 -46.5 -54.5t-60.5 -42t-70 -27.5t-75 -10zM330 451q-36 0 -66 -12.5t-53 -33.5t-39 -48.5t-26 -57.5q46 -3 85 -3q53 0 89 6.5t58.5 18t32 28t9.5 36.5q0 34 -24 50t-66 16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gcircumflex",
    unicode: "\u011C",
    horizAdvX: 691,
    d: "M333 821l119 95h80l78 -95l-64 -28l-67 63l-94 -63zM505 87q-104 -92 -213 -92q-57 0 -103.5 23.5t-79.5 63.5t-50.5 94t-17.5 114q0 83 34 160t91 136t130.5 94t152.5 35q97 0 153.5 -42.5t76.5 -112.5l-98 -62q-16 58 -57.5 87t-99.5 29q-54 0 -103 -27t-85.5 -71.5 t-58 -101t-21.5 -115.5q0 -42 11.5 -79t33 -64.5t52.5 -43.5t69 -16q104 0 208 105l16 75h-140l18 83h233l-76 -359h-94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gcircumflex",
    unicode: "\u011D",
    horizAdvX: 605,
    d: "M214 635l119 95h80l78 -95l-64 -28l-67 63l-94 -63zM163 -223q-83 0 -131.5 29.5t-75.5 82.5l74 58q20 -42 59.5 -64t90.5 -22q32 0 62.5 9t56.5 28t44.5 48t26.5 69l16 80q-35 -48 -87 -74t-103 -26q-42 0 -75 17t-55.5 46t-34.5 67t-12 81q0 64 24 123t64.5 104t94 72 t113.5 27t97.5 -30t57.5 -78l21 99h97l-108 -508q-12 -57 -42 -101t-72 -74.5t-94 -46.5t-109 -16zM251 84q23 0 46 8.5t44 23t38 33t27 39.5l30 137q-8 50 -41 81.5t-76 31.5q-38 0 -72 -19.5t-59.5 -50t-40 -69t-14.5 -75.5q0 -29 8.5 -54.5t24 -44.5t37 -30t48.5 -11z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gbreve",
    unicode: "\u011E",
    horizAdvX: 691,
    d: "M505 87q-104 -92 -213 -92q-57 0 -103.5 23.5t-79.5 63.5t-50.5 94t-17.5 114q0 83 34 160t91 136t130.5 94t152.5 35q97 0 153.5 -42.5t76.5 -112.5l-98 -62q-16 58 -57.5 87t-99.5 29q-54 0 -103 -27t-85.5 -71.5t-58 -101t-21.5 -115.5q0 -42 11.5 -79t33 -64.5 t52.5 -43.5t69 -16q104 0 208 105l16 75h-140l18 83h233l-76 -359h-94zM470 845q21 0 41 20t29 51h61q-6 -26 -19.5 -48.5t-32.5 -39t-42 -25.5t-48 -9q-43 0 -68.5 25.5t-25.5 67.5q0 8 1 15t3 14h61q-1 -5 -1.5 -9t-0.5 -9q0 -22 11.5 -37.5t30.5 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gbreve",
    unicode: "\u011F",
    horizAdvX: 605,
    d: "M163 -223q-83 0 -131.5 29.5t-75.5 82.5l74 58q20 -42 59.5 -64t90.5 -22q32 0 62.5 9t56.5 28t44.5 48t26.5 69l16 80q-35 -48 -87 -74t-103 -26q-42 0 -75 17t-55.5 46t-34.5 67t-12 81q0 64 24 123t64.5 104t94 72t113.5 27t97.5 -30t57.5 -78l21 99h97l-108 -508 q-12 -57 -42 -101t-72 -74.5t-94 -46.5t-109 -16zM251 84q23 0 46 8.5t44 23t38 33t27 39.5l30 137q-8 50 -41 81.5t-76 31.5q-38 0 -72 -19.5t-59.5 -50t-40 -69t-14.5 -75.5q0 -29 8.5 -54.5t24 -44.5t37 -30t48.5 -11zM347 659q21 0 41 20t29 51h61q-6 -26 -19.5 -48.5 t-32.5 -39t-42 -25.5t-48 -9q-43 0 -68.5 25.5t-25.5 67.5q0 8 1 15t3 14h61q-1 -5 -1.5 -9t-0.5 -9q0 -22 11.5 -37.5t30.5 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gdotaccent",
    unicode: "\u0120",
    horizAdvX: 691,
    d: "M505 87q-104 -92 -213 -92q-57 0 -103.5 23.5t-79.5 63.5t-50.5 94t-17.5 114q0 83 34 160t91 136t130.5 94t152.5 35q97 0 153.5 -42.5t76.5 -112.5l-98 -62q-16 58 -57.5 87t-99.5 29q-54 0 -103 -27t-85.5 -71.5t-58 -101t-21.5 -115.5q0 -42 11.5 -79t33 -64.5 t52.5 -43.5t69 -16q104 0 208 105l16 75h-140l18 83h233l-76 -359h-94zM422 801l25 115h98l-24 -115h-99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gdotaccent",
    unicode: "\u0121",
    horizAdvX: 605,
    d: "M163 -223q-83 0 -131.5 29.5t-75.5 82.5l74 58q20 -42 59.5 -64t90.5 -22q32 0 62.5 9t56.5 28t44.5 48t26.5 69l16 80q-35 -48 -87 -74t-103 -26q-42 0 -75 17t-55.5 46t-34.5 67t-12 81q0 64 24 123t64.5 104t94 72t113.5 27t97.5 -30t57.5 -78l21 99h97l-108 -508 q-12 -57 -42 -101t-72 -74.5t-94 -46.5t-109 -16zM251 84q23 0 46 8.5t44 23t38 33t27 39.5l30 137q-8 50 -41 81.5t-76 31.5q-38 0 -72 -19.5t-59.5 -50t-40 -69t-14.5 -75.5q0 -29 8.5 -54.5t24 -44.5t37 -30t48.5 -11zM293 615l25 115h98l-24 -115h-99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gcommaaccent",
    unicode: "\u0122",
    horizAdvX: 691,
    d: "M215 -213l39 77h-32l19 88h94l-19 -88l-50 -77h-51zM505 87q-104 -92 -213 -92q-57 0 -103.5 23.5t-79.5 63.5t-50.5 94t-17.5 114q0 83 34 160t91 136t130.5 94t152.5 35q97 0 153.5 -42.5t76.5 -112.5l-98 -62q-16 58 -57.5 87t-99.5 29q-54 0 -103 -27t-85.5 -71.5 t-58 -101t-21.5 -115.5q0 -42 11.5 -79t33 -64.5t52.5 -43.5t69 -16q104 0 208 105l16 75h-140l18 83h233l-76 -359h-94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gcommaaccent",
    unicode: "\u0123",
    horizAdvX: 605,
    d: "M412 745l-39 -77h32l-19 -88h-94l19 88l50 77h51zM163 -223q-83 0 -131.5 29.5t-75.5 82.5l74 58q20 -42 59.5 -64t90.5 -22q32 0 62.5 9t56.5 28t44.5 48t26.5 69l16 80q-35 -48 -87 -74t-103 -26q-42 0 -75 17t-55.5 46t-34.5 67t-12 81q0 64 24 123t64.5 104t94 72 t113.5 27t97.5 -30t57.5 -78l21 99h97l-108 -508q-12 -57 -42 -101t-72 -74.5t-94 -46.5t-109 -16zM251 84q23 0 46 8.5t44 23t38 33t27 39.5l30 137q-8 50 -41 81.5t-76 31.5q-38 0 -72 -19.5t-59.5 -50t-40 -69t-14.5 -75.5q0 -29 8.5 -54.5t24 -44.5t37 -30t48.5 -11z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hcircumflex",
    unicode: "\u0124",
    horizAdvX: 715,
    d: "M327 821l119 95h80l78 -95l-64 -28l-67 63l-94 -63zM166 710h113l-63 -297h332l63 297h112l-151 -710h-112l67 313h-332l-67 -313h-113z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hcircumflex",
    unicode: "\u0125",
    horizAdvX: 574,
    d: "M285 635l111 94h74l72 -94l-59 -28l-62 62l-88 -62zM155 730h110l-66 -312q40 54 95 84t113 30q68 0 94.5 -36t26.5 -91q0 -20 -2.5 -41.5t-7.5 -44.5l-67 -319h-110l62 293q7 32 7 59q0 42 -18 62t-51 20q-20 0 -43.5 -9t-46 -25.5t-42 -39t-32.5 -49.5l-67 -311h-110z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hbar",
    unicode: "\u0126",
    horizAdvX: 724,
    d: "M101 602h47l23 108h113l-23 -108h332l23 108h113l-23 -108h47l-12 -56h-47l-116 -546h-113l67 313h-332l-67 -313h-113l116 546h-47zM553 413l28 133h-332l-28 -133h332z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hbar",
    unicode: "\u0127",
    horizAdvX: 574,
    d: "M77 664h64l14 66h110l-14 -66h97l-15 -68h-97l-37 -178q40 54 95 84t113 30q68 0 94.5 -36t26.5 -91q0 -20 -2.5 -41.5t-7.5 -44.5l-67 -319h-110l62 293q7 32 7 59q0 42 -18 62t-51 20q-20 0 -43.5 -9t-46 -25.5t-42 -39t-32.5 -49.5l-67 -311h-110l126 596h-63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Itilde",
    unicode: "\u0128",
    horizAdvX: 271,
    d: "M166 709h113l-151 -709h-113zM305 801q-21 0 -36 6.5t-27 15t-24 15t-28 6.5t-26.5 -7t-17 -15.5t-9 -16.5t-2.5 -9h-63q2 8 11 27t25.5 38.5t39.5 34.5t53 15q21 0 35 -7t26 -15t24 -15t29 -7q18 0 29.5 7t19 16t11 16.5t3.5 9.5h62q-2 -6 -11 -25t-26 -39t-41.5 -35.5 t-56.5 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "itilde",
    unicode: "\u0129",
    horizAdvX: 239,
    d: "M112 523h110l-112 -523h-110zM244 615q-21 0 -36 6.5t-27 15t-24 15t-28 6.5t-26.5 -7t-17 -15.5t-9 -16.5t-2.5 -9h-63q2 8 11 27t25.5 38.5t39.5 34.5t53 15q21 0 35 -7t26 -15t24 -15t29 -7q18 0 29.5 7t19 16t11 16.5t3.5 9.5h62q-2 -6 -11 -25t-26 -39t-41.5 -35.5 t-56.5 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Imacron",
    unicode: "\u012A",
    horizAdvX: 271,
    d: "M166 709h113l-151 -709h-113zM107 828l14 70h283l-15 -70h-282z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "imacron",
    unicode: "\u012B",
    horizAdvX: 239,
    d: "M112 523h110l-112 -523h-110zM45 642l14 70h283l-15 -70h-282z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ibreve",
    unicode: "\u012C",
    horizAdvX: 271,
    d: "M166 709h113l-151 -709h-113zM241 845q21 0 41 20t29 51h61q-6 -26 -19.5 -48.5t-32.5 -39t-42 -25.5t-48 -9q-43 0 -68.5 25.5t-25.5 67.5q0 8 1 15t3 14h61q-1 -5 -1.5 -9t-0.5 -9q0 -22 11.5 -37.5t30.5 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ibreve",
    unicode: "\u012D",
    horizAdvX: 239,
    d: "M112 523h110l-112 -523h-110zM185 659q21 0 41 20t29 51h61q-6 -26 -19.5 -48.5t-32.5 -39t-42 -25.5t-48 -9q-43 0 -68.5 25.5t-25.5 67.5q0 8 1 15t3 14h61q-1 -5 -1.5 -9t-0.5 -9q0 -22 11.5 -37.5t30.5 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iogonek",
    unicode: "\u012E",
    horizAdvX: 271,
    d: "M166 709h113l-151 -709q-51 -29 -73.5 -51.5t-22.5 -43.5q0 -32 48 -35l-36 -58q-42 7 -62 26t-20 44q0 59 99 118h-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iogonek",
    unicode: "\u012F",
    horizAdvX: 239,
    d: "M112 523h110l-112 -523q-51 -29 -73 -51.5t-22 -43.5q0 -32 48 -35l-36 -58q-42 7 -62 26t-20 44q0 59 99 118h-44zM155 730h110l-25 -121h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idotaccent",
    unicode: "\u0130",
    horizAdvX: 271,
    d: "M166 709h113l-151 -709h-113zM192 801l25 115h98l-24 -115h-99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessi",
    unicode: "\u0131",
    horizAdvX: 239,
    d: "M112 523h110l-112 -523h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "IJ",
    unicode: "\u0132",
    horizAdvX: 746,
    d: "M166 709h113l-151 -709h-113zM367 -11q-85 0 -137 44l46 92q13 -12 42 -23.5t70 -11.5q43 0 72 16.5t49.5 49t35 81t28.5 112.5l77 360h112l-77 -360q-17 -81 -38.5 -147.5t-57 -113.5t-88.5 -73t-134 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ij",
    unicode: "\u0133",
    horizAdvX: 483,
    d: "M112 523h110l-112 -523h-110zM155 730h110l-25 -121h-110zM149 -191q-35 0 -63.5 11t-48.5 34l64 74q10 -12 24.5 -17.5t30.5 -5.5q27 0 52.5 21.5t32.5 54.5l115 542h110l-113 -534q-9 -40 -29 -73t-48 -57t-60.5 -37t-66.5 -13zM400 730h110l-26 -121h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Jcircumflex",
    unicode: "\u0134",
    horizAdvX: 475,
    d: "M319 821l119 95h80l78 -95l-64 -28l-67 63l-94 -63zM96 -11q-85 0 -137 44l46 92q13 -12 42 -23.5t70 -11.5q43 0 72 16.5t49.5 49t35 81t28.5 112.5l77 360h112l-77 -360q-17 -81 -38.5 -147.5t-57 -113.5t-88.5 -73t-134 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "jcircumflex",
    unicode: "\u0135",
    horizAdvX: 239,
    d: "M-96 -191q-35 0 -63.5 11t-48.5 34l65 74q9 -12 23.5 -17.5t31.5 -5.5q27 0 52 21.5t32 54.5l115 542h111l-114 -534q-9 -40 -29 -73t-47.5 -57t-60.5 -37t-67 -13zM49 635l119 95h80l78 -95l-64 -28l-67 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Kcommaaccent",
    unicode: "\u0136",
    horizAdvX: 634,
    d: "M200 -213l39 77h-32l19 88h94l-19 -88l-50 -77h-51zM166 709h113l-78 -365l386 366h125l-331 -314l195 -396h-126l-154 327l-123 -113l-45 -214h-113z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "kcommaaccent",
    unicode: "\u0137",
    horizAdvX: 551,
    d: "M145 -213l39 77h-32l19 88h94l-19 -88l-50 -77h-51zM155 730h110l-73 -343q22 31 47.5 57t53.5 45.5t59 30.5t65 11q54 0 80.5 -29.5t26.5 -79.5q0 -65 -41 -119.5t-119 -89.5l107 -213h-118l-113 246q90 20 137 61.5t47 87.5q0 24 -13 34.5t-33 10.5q-30 0 -61.5 -16.5 t-61 -44.5t-54.5 -65.5t-41 -79.5l-50 -234h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "kgreenlandic",
    unicode: "\u0138",
    horizAdvX: 528,
    d: "M112 523h110l-55 -256l276 255h118l-237 -219l139 -303h-118l-104 241l-97 -82l-34 -159h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lacute",
    unicode: "\u0139",
    horizAdvX: 560,
    d: "M255 788l-70 18l76 110h105zM166 710h113l-130 -611h357l-21 -99h-470z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lacute",
    unicode: "\u013A",
    horizAdvX: 294,
    d: "M231 763l-70 18l76 110h105zM116 -8q-46 0 -70.5 22t-24.5 63q0 8 1 16.5t3 17.5l131 619h109l-122 -579q-3 -11 -3 -20q0 -20 11.5 -31t31.5 -11q11 0 26 4t29 9l-4 -86q-26 -11 -59 -17.5t-59 -6.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lcommaaccent",
    unicode: "\u013B",
    horizAdvX: 560,
    d: "M172 -213l39 77h-32l19 88h94l-19 -88l-50 -77h-51zM166 710h113l-130 -611h357l-21 -99h-470z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lcommaaccent",
    unicode: "\u013C",
    horizAdvX: 294,
    d: "M26 -213l39 77h-32l19 88h94l-19 -88l-50 -77h-51zM116 -8q-46 0 -70.5 22t-24.5 63q0 8 1 16.5t3 17.5l131 619h109l-122 -579q-3 -11 -3 -20q0 -20 11.5 -31t31.5 -11q11 0 26 4t29 9l-4 -86q-26 -11 -59 -17.5t-59 -6.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lcaron",
    unicode: "\u013D",
    horizAdvX: 560,
    d: "M330 620l76 110h104l-114 -132zM166 710h113l-130 -611h357l-21 -99h-470z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lcaron",
    unicode: "\u013E",
    horizAdvX: 287,
    d: "M294 620l76 110h104l-114 -132zM116 -8q-46 0 -70.5 22t-24.5 63q0 8 1 16.5t3 17.5l131 619h109l-122 -579q-3 -11 -3 -20q0 -20 11.5 -31t31.5 -11q11 0 26 4t29 9l-4 -86q-26 -11 -59 -17.5t-59 -6.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ldot",
    unicode: "\u013F",
    horizAdvX: 560,
    d: "M166 710h113l-130 -611h357l-21 -99h-470zM331 341l29 137h91l-29 -137h-91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ldot",
    unicode: "\u0140",
    horizAdvX: 357,
    d: "M116 -8q-46 0 -70.5 22t-24.5 63q0 8 1 16.5t3 17.5l131 619h109l-122 -579q-3 -11 -3 -20q0 -20 11.5 -31t31.5 -11q11 0 26 4t29 9l-4 -86q-26 -11 -59 -17.5t-59 -6.5zM245 267l29 137h91l-29 -137h-91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lslash",
    unicode: "\u0141",
    horizAdvX: 567,
    d: "M6 298l93 59l75 353h112l-58 -271l135 85l16 -60l-168 -107l-55 -258h357l-21 -99h-469l58 275l-59 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lslash",
    unicode: "\u0142",
    horizAdvX: 321,
    d: "M13 337l97 58l71 335h110l-55 -260l89 53l17 -60l-123 -74l-47 -222q-2 -11 -4 -20t-2 -16q0 -20 11 -31t32 -11q11 0 26 4t29 9l-4 -86q-26 -11 -59 -17.5t-59 -6.5q-46 0 -71 22t-25 63q0 8 1 16.5t3 17.5l43 203l-64 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Nacute",
    unicode: "\u0143",
    horizAdvX: 736,
    d: "M485 788l-70 18l76 110h105zM166 710h88l269 -512l108 511h113l-151 -709h-92l-267 500l-106 -500h-113z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nacute",
    unicode: "\u0144",
    horizAdvX: 574,
    d: "M386 602l-70 18l76 110h105zM112 523h99l-22 -105q39 53 99 83.5t126 30.5q33 0 55 -9t35.5 -25.5t19.5 -38.5t6 -49q0 -21 -3.5 -44t-8.5 -47l-67 -319h-110l62 293q4 19 6 34.5t2 29.5q0 77 -64 77q-22 0 -46 -9t-47 -25.5t-43.5 -39t-33.5 -49.5l-67 -311h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ncommaaccent",
    unicode: "\u0145",
    horizAdvX: 736,
    d: "M224 -213l39 77h-32l19 88h94l-19 -88l-50 -77h-51zM166 710h88l269 -512l108 511h113l-151 -709h-92l-267 500l-106 -500h-113z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ncommaaccent",
    unicode: "\u0146",
    horizAdvX: 574,
    d: "M138 -213l39 77h-32l19 88h94l-19 -88l-50 -77h-51zM112 523h99l-22 -105q39 53 99 83.5t126 30.5q33 0 55 -9t35.5 -25.5t19.5 -38.5t6 -49q0 -21 -3.5 -44t-8.5 -47l-67 -319h-110l62 293q4 19 6 34.5t2 29.5q0 77 -64 77q-22 0 -46 -9t-47 -25.5t-43.5 -39 t-33.5 -49.5l-67 -311h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ncaron",
    unicode: "\u0147",
    horizAdvX: 736,
    d: "M344 888l64 28l67 -63l94 63l52 -28l-119 -95h-80zM166 710h88l269 -512l108 511h113l-151 -709h-92l-267 500l-106 -500h-113z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ncaron",
    unicode: "\u0148",
    horizAdvX: 574,
    d: "M228 702l64 28l67 -63l94 63l52 -28l-119 -95h-80zM112 523h99l-22 -105q39 53 99 83.5t126 30.5q33 0 55 -9t35.5 -25.5t19.5 -38.5t6 -49q0 -21 -3.5 -44t-8.5 -47l-67 -319h-110l62 293q4 19 6 34.5t2 29.5q0 77 -64 77q-22 0 -46 -9t-47 -25.5t-43.5 -39t-33.5 -49.5 l-67 -311h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "napostrophe",
    unicode: "\u0149",
    horizAdvX: 574,
    d: "M-29 620l48 68l4 42h129l-115 -132zM112 523h99l-22 -105q39 53 99 83.5t126 30.5q33 0 55 -9t35.5 -25.5t19.5 -38.5t6 -49q0 -21 -3.5 -44t-8.5 -47l-67 -319h-110l62 293q4 19 6 34.5t2 29.5q0 77 -64 77q-22 0 -46 -9t-47 -25.5t-43.5 -39t-33.5 -49.5l-67 -311h-110 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eng",
    unicode: "\u014A",
    horizAdvX: 726,
    d: "M376 -191q-34 0 -62.5 11t-48.5 34l64 74q9 -12 23.5 -17.5t30.5 -5.5q28 0 53 21.5t32 54.5l9 40l-243 477l-106 -498h-113l151 710h87l260 -506l108 505h112l-154 -724q-8 -39 -28.5 -71.5t-48.5 -56t-60.5 -36t-65.5 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eng",
    unicode: "\u014B",
    horizAdvX: 574,
    d: "M244 -191q-35 0 -63.5 11t-48.5 34l65 74q9 -12 23.5 -17.5t31.5 -5.5q13 0 26.5 5.5t25.5 15.5t20.5 24t12.5 31l66 312q4 19 6 34.5t2 29.5q0 77 -64 77q-22 0 -46 -9t-47 -25.5t-43.5 -39t-33.5 -49.5l-67 -311h-110l112 523h99l-22 -105q39 53 99 83.5t126 30.5 q33 0 55 -9t35.5 -25.5t19.5 -38.5t6 -49q0 -21 -3.5 -43.5t-8.5 -47.5l-70 -330q-9 -40 -29 -73t-48 -57t-60.5 -37t-66.5 -13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omacron",
    unicode: "\u014C",
    horizAdvX: 725,
    d: "M337 828l14 70h283l-15 -70h-282zM297 -5q-62 0 -109.5 24.5t-80 65t-49.5 93.5t-17 111q0 81 34.5 157.5t91.5 136.5t131 96t154 36q62 0 109.5 -25t79.5 -66t48.5 -94.5t16.5 -110.5q0 -80 -34 -156.5t-90.5 -136t-130.5 -95.5t-154 -36zM319 96q58 0 108 28.5t86.5 74 t57 101.5t20.5 111q0 40 -10.5 77t-31 64.5t-50.5 44t-70 16.5q-59 0 -108.5 -28.5t-86.5 -73.5t-57.5 -101.5t-20.5 -111.5q0 -41 10.5 -77.5t30.5 -64t50.5 -44t71.5 -16.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "omacron",
    unicode: "\u014D",
    horizAdvX: 582,
    d: "M221 642l14 70h283l-15 -70h-282zM224 -10q-50 0 -88 17.5t-64 47t-39.5 69t-13.5 84.5q0 63 25 121.5t68 103.5t101.5 72t125.5 27q50 0 88.5 -17.5t65 -47t40 -69.5t13.5 -85q0 -62 -25 -120t-68.5 -103t-102 -72.5t-126.5 -27.5zM245 84q35 0 68.5 17t59.5 46.5 t42 68.5t16 83q0 60 -30.5 99.5t-81.5 39.5q-35 0 -68 -17.5t-59.5 -47t-42.5 -68.5t-16 -83q0 -60 30.5 -99t81.5 -39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Obreve",
    unicode: "\u014E",
    horizAdvX: 725,
    d: "M297 -5q-62 0 -109.5 24.5t-80 65t-49.5 93.5t-17 111q0 81 34.5 157.5t91.5 136.5t131 96t154 36q62 0 109.5 -25t79.5 -66t48.5 -94.5t16.5 -110.5q0 -80 -34 -156.5t-90.5 -136t-130.5 -95.5t-154 -36zM319 96q58 0 108 28.5t86.5 74t57 101.5t20.5 111q0 40 -10.5 77 t-31 64.5t-50.5 44t-70 16.5q-59 0 -108.5 -28.5t-86.5 -73.5t-57.5 -101.5t-20.5 -111.5q0 -41 10.5 -77.5t30.5 -64t50.5 -44t71.5 -16.5zM475 845q21 0 41 20t29 51h61q-6 -26 -19.5 -48.5t-32.5 -39t-42 -25.5t-48 -9q-43 0 -68.5 25.5t-25.5 67.5q0 8 1 15t3 14h61 q-1 -5 -1.5 -9t-0.5 -9q0 -22 11.5 -37.5t30.5 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "obreve",
    unicode: "\u014F",
    horizAdvX: 582,
    d: "M224 -10q-50 0 -88 17.5t-64 47t-39.5 69t-13.5 84.5q0 63 25 121.5t68 103.5t101.5 72t125.5 27q50 0 88.5 -17.5t65 -47t40 -69.5t13.5 -85q0 -62 -25 -120t-68.5 -103t-102 -72.5t-126.5 -27.5zM245 84q35 0 68.5 17t59.5 46.5t42 68.5t16 83q0 60 -30.5 99.5 t-81.5 39.5q-35 0 -68 -17.5t-59.5 -47t-42.5 -68.5t-16 -83q0 -60 30.5 -99t81.5 -39zM362 659q21 0 41 20t29 51h61q-6 -26 -19.5 -48.5t-32.5 -39t-42 -25.5t-48 -9q-43 0 -68.5 25.5t-25.5 67.5q0 8 1 15t3 14h61q-1 -5 -1.5 -9t-0.5 -9q0 -22 11.5 -37.5t30.5 -15.5z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ohungarumlaut",
    unicode: "\u0150",
    horizAdvX: 725,
    d: "M405 785l-54 17l71 110h89zM548 785l-53 17l70 110h89zM297 -5q-62 0 -109.5 24.5t-80 65t-49.5 93.5t-17 111q0 81 34.5 157.5t91.5 136.5t131 96t154 36q62 0 109.5 -25t79.5 -66t48.5 -94.5t16.5 -110.5q0 -80 -34 -156.5t-90.5 -136t-130.5 -95.5t-154 -36zM319 96 q58 0 108 28.5t86.5 74t57 101.5t20.5 111q0 40 -10.5 77t-31 64.5t-50.5 44t-70 16.5q-59 0 -108.5 -28.5t-86.5 -73.5t-57.5 -101.5t-20.5 -111.5q0 -41 10.5 -77.5t30.5 -64t50.5 -44t71.5 -16.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ohungarumlaut",
    unicode: "\u0151",
    horizAdvX: 582,
    d: "M286 603l-54 17l71 110h89zM429 603l-53 17l70 110h89zM224 -10q-50 0 -88 17.5t-64 47t-39.5 69t-13.5 84.5q0 63 25 121.5t68 103.5t101.5 72t125.5 27q50 0 88.5 -17.5t65 -47t40 -69.5t13.5 -85q0 -62 -25 -120t-68.5 -103t-102 -72.5t-126.5 -27.5zM245 84 q35 0 68.5 17t59.5 46.5t42 68.5t16 83q0 60 -30.5 99.5t-81.5 39.5q-35 0 -68 -17.5t-59.5 -47t-42.5 -68.5t-16 -83q0 -60 30.5 -99t81.5 -39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "OE",
    unicode: "\u0152",
    horizAdvX: 1055,
    d: "M292 -5q-60 0 -107 24.5t-79 65t-48.5 93.5t-16.5 110q0 81 34 158t90 137t129.5 96t152.5 36q34 0 63 -10.5t51.5 -29t38.5 -43.5t26 -54l27 132h446l-21 -99h-333l-42 -200h281l-21 -99h-281l-46 -213h341l-21 -99h-454l29 132q-23 -29 -50.5 -54t-58 -43.5t-63.5 -29 t-67 -10.5zM314 96q57 0 106 29t85 74.5t56.5 102t20.5 111.5q0 40 -10.5 76.5t-30.5 64t-49.5 44t-67.5 16.5q-57 0 -106 -28.5t-85 -74.5t-56.5 -102.5t-20.5 -111.5q0 -41 10 -77t30 -64t49.5 -44t68.5 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oe",
    unicode: "\u0153",
    horizAdvX: 972,
    d: "M224 -10q-47 0 -85 16.5t-64.5 45.5t-41 68.5t-14.5 86.5q0 67 26.5 126t70.5 103.5t102 70t121 25.5q66 0 110 -36t61 -102q48 68 106.5 103t126.5 35q48 0 85.5 -16t63.5 -45t40 -69.5t14 -89.5q0 -36 -5.5 -57t-10.5 -30h-394q-2 -7 -2 -13.5v-13.5q0 -56 32.5 -92.5 t86.5 -36.5q22 0 44 6t41.5 17t35.5 26t26 33l86 -27q-20 -30 -48.5 -55t-61.5 -42.5t-69.5 -27t-73.5 -9.5q-63 0 -108 35.5t-71 98.5q-54 -66 -110.5 -100t-119.5 -34zM245 84q36 0 69.5 17.5t59.5 47t41.5 68.5t15.5 83q0 30 -8 55t-22 43.5t-35 29t-46 10.5 q-36 0 -69.5 -17.5t-59.5 -47.5t-42 -69.5t-16 -83.5q0 -29 8 -54t22.5 -43t35 -28.5t46.5 -10.5zM837 295q1 7 1.5 14t0.5 14q0 58 -32 93t-84 35q-29 0 -57 -11.5t-51 -32.5t-40.5 -49.5t-26.5 -62.5h289z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Racute",
    unicode: "\u0154",
    horizAdvX: 637,
    d: "M422 790l-70 18l76 110h105zM15 0l151 710h295q39 0 70 -16t52.5 -43t32.5 -61.5t11 -71.5q0 -40 -14 -79t-38 -72.5t-56.5 -59t-70.5 -37.5l100 -270h-127l-92 247h-149l-52 -247h-113zM382 346q25 0 48.5 13.5t41.5 36t28.5 51.5t10.5 59q0 45 -22 75t-56 30h-175 l-57 -265h181z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "racute",
    unicode: "\u0155",
    horizAdvX: 366,
    d: "M278 602l-70 18l76 110h105zM112 523h102l-26 -117q38 54 86 87t95 33q10 0 15.5 -0.5t10.5 -1.5l-21 -96q-60 -2 -112 -29.5t-84 -78.5l-68 -320h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rcommaaccent",
    unicode: "\u0156",
    horizAdvX: 637,
    d: "M174 -213l39 77h-32l19 88h94l-19 -88l-50 -77h-51zM15 0l151 710h295q39 0 70 -16t52.5 -43t32.5 -61.5t11 -71.5q0 -40 -14 -79t-38 -72.5t-56.5 -59t-70.5 -37.5l100 -270h-127l-92 247h-149l-52 -247h-113zM382 346q25 0 48.5 13.5t41.5 36t28.5 51.5t10.5 59 q0 45 -22 75t-56 30h-175l-57 -265h181z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rcommaaccent",
    unicode: "\u0157",
    horizAdvX: 366,
    d: "M-32 -213l39 77h-32l19 88h94l-19 -88l-50 -77h-51zM112 523h102l-26 -117q38 54 86 87t95 33q10 0 15.5 -0.5t10.5 -1.5l-21 -96q-60 -2 -112 -29.5t-84 -78.5l-68 -320h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rcaron",
    unicode: "\u0158",
    horizAdvX: 637,
    d: "M296 890l64 28l67 -63l94 63l52 -28l-119 -95h-80zM15 0l151 710h295q39 0 70 -16t52.5 -43t32.5 -61.5t11 -71.5q0 -40 -14 -79t-38 -72.5t-56.5 -59t-70.5 -37.5l100 -270h-127l-92 247h-149l-52 -247h-113zM382 346q25 0 48.5 13.5t41.5 36t28.5 51.5t10.5 59 q0 45 -22 75t-56 30h-175l-57 -265h181z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rcaron",
    unicode: "\u0159",
    horizAdvX: 366,
    d: "M141 702l64 28l67 -63l94 63l52 -28l-119 -95h-80zM112 523h102l-26 -117q38 54 86 87t95 33q10 0 15.5 -0.5t10.5 -1.5l-21 -96q-60 -2 -112 -29.5t-84 -78.5l-68 -320h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Sacute",
    unicode: "\u015A",
    horizAdvX: 590,
    d: "M422 802l-70 18l76 110h105zM243 -7q-77 0 -144.5 24.5t-115.5 71.5l73 96q8 -13 27.5 -29t47 -29.5t62 -23t73.5 -9.5q72 0 110 28.5t38 79.5q0 22 -11.5 37.5t-32 27.5t-50 21.5t-65.5 20.5q-80 23 -121.5 56.5t-41.5 95.5q0 60 24 107t64.5 80t94 50t113.5 17 q69 0 123 -23t90 -57l-70 -92q-6 11 -22 23.5t-38 23.5t-49.5 18t-57.5 7q-76 0 -112.5 -32.5t-36.5 -83.5q0 -20 9 -34t27 -24.5t44.5 -19.5t61.5 -18q42 -11 75.5 -25t57.5 -33t37 -45.5t13 -63.5q0 -63 -24.5 -109t-66 -76t-95 -44t-111.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sacute",
    unicode: "\u015B",
    horizAdvX: 477,
    d: "M305 602l-70 18l76 110h105zM181 -10q-61 0 -116 20.5t-90 58.5l59 70q75 -69 161 -69q51 0 82 23t31 61q0 27 -25.5 41t-79.5 29q-38 11 -66 21.5t-46 24t-27 30.5t-9 40q0 44 19 79.5t51 60.5t74 38.5t89 13.5q56 0 100 -18t76 -52l-61 -66q-29 29 -63 43.5t-71 14.5 q-44 0 -75 -21t-31 -64q0 -25 21 -37.5t70 -25.5q42 -11 73 -23t51.5 -26.5t30.5 -33.5t10 -44q0 -42 -17.5 -76.5t-49 -59.5t-75.5 -39t-96 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scircumflex",
    unicode: "\u015C",
    horizAdvX: 590,
    d: "M277 835l119 95h80l78 -95l-64 -28l-67 63l-94 -63zM243 -7q-77 0 -144.5 24.5t-115.5 71.5l73 96q8 -13 27.5 -29t47 -29.5t62 -23t73.5 -9.5q72 0 110 28.5t38 79.5q0 22 -11.5 37.5t-32 27.5t-50 21.5t-65.5 20.5q-80 23 -121.5 56.5t-41.5 95.5q0 60 24 107t64.5 80 t94 50t113.5 17q69 0 123 -23t90 -57l-70 -92q-6 11 -22 23.5t-38 23.5t-49.5 18t-57.5 7q-76 0 -112.5 -32.5t-36.5 -83.5q0 -20 9 -34t27 -24.5t44.5 -19.5t61.5 -18q42 -11 75.5 -25t57.5 -33t37 -45.5t13 -63.5q0 -63 -24.5 -109t-66 -76t-95 -44t-111.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scircumflex",
    unicode: "\u015D",
    horizAdvX: 477,
    d: "M180 635l119 95h80l78 -95l-64 -28l-67 63l-94 -63zM181 -10q-61 0 -116 20.5t-90 58.5l59 70q75 -69 161 -69q51 0 82 23t31 61q0 27 -25.5 41t-79.5 29q-38 11 -66 21.5t-46 24t-27 30.5t-9 40q0 44 19 79.5t51 60.5t74 38.5t89 13.5q56 0 100 -18t76 -52l-61 -66 q-29 29 -63 43.5t-71 14.5q-44 0 -75 -21t-31 -64q0 -25 21 -37.5t70 -25.5q42 -11 73 -23t51.5 -26.5t30.5 -33.5t10 -44q0 -42 -17.5 -76.5t-49 -59.5t-75.5 -39t-96 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni015E",
    unicode: "\u015E",
    horizAdvX: 590,
    d: "M144 -126q10 -7 32 -13.5t47 -6.5q29 0 46 9.5t17 31.5q0 15 -12 21t-31 6q-20 0 -43 -4t-36 -8l59 84q-71 3 -133 27t-107 68l73 96q8 -13 27.5 -29t47 -29.5t62 -23t73.5 -9.5q72 0 110 28.5t38 79.5q0 22 -11.5 37.5t-32 27.5t-50 21.5t-65.5 20.5q-80 23 -121.5 56.5 t-41.5 95.5q0 60 24 107t64.5 80t94 50t113.5 17q69 0 123 -23t90 -57l-70 -92q-6 11 -22 23.5t-38 23.5t-49.5 18t-57.5 7q-76 0 -112.5 -32.5t-36.5 -83.5q0 -20 9 -34t27 -24.5t44.5 -19.5t61.5 -18q42 -11 75.5 -25t57.5 -33t37 -45.5t13 -63.5q0 -59 -21.5 -103 t-58 -74t-85 -46t-101.5 -19l-32 -39q8 2 16.5 3t15.5 1q29 0 47.5 -13t18.5 -40q0 -41 -33.5 -68t-100.5 -27q-30 0 -54 6t-41 14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni015F",
    unicode: "\u015F",
    horizAdvX: 477,
    d: "M76 -126q10 -7 32 -13.5t47 -6.5q29 0 46 9.5t17 31.5q0 15 -12 21t-31 6q-20 0 -43 -4t-36 -8l57 82q-54 4 -101 23.5t-77 53.5l59 70q75 -69 161 -69q51 0 82 23t31 61q0 27 -25.5 41t-79.5 29q-38 11 -66 21.5t-46 24t-27 30.5t-9 40q0 44 19 79.5t51 60.5t74 38.5 t89 13.5q56 0 100 -18t76 -52l-61 -66q-29 29 -63 43.5t-71 14.5q-44 0 -75 -21t-31 -64q0 -25 21 -37.5t70 -25.5q42 -11 73 -23t51.5 -26.5t30.5 -33.5t10 -44q0 -39 -15.5 -72.5t-44 -58t-68 -39.5t-87.5 -18l-30 -36q8 2 16.5 3t15.5 1q29 0 47.5 -13t18.5 -40 q0 -41 -33.5 -68t-100.5 -27q-30 0 -54 6t-41 14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scaron",
    unicode: "\u0160",
    horizAdvX: 590,
    d: "M283 902l64 28l67 -63l94 63l52 -28l-119 -95h-80zM243 -7q-77 0 -144.5 24.5t-115.5 71.5l73 96q8 -13 27.5 -29t47 -29.5t62 -23t73.5 -9.5q72 0 110 28.5t38 79.5q0 22 -11.5 37.5t-32 27.5t-50 21.5t-65.5 20.5q-80 23 -121.5 56.5t-41.5 95.5q0 60 24 107t64.5 80 t94 50t113.5 17q69 0 123 -23t90 -57l-70 -92q-6 11 -22 23.5t-38 23.5t-49.5 18t-57.5 7q-76 0 -112.5 -32.5t-36.5 -83.5q0 -20 9 -34t27 -24.5t44.5 -19.5t61.5 -18q42 -11 75.5 -25t57.5 -33t37 -45.5t13 -63.5q0 -63 -24.5 -109t-66 -76t-95 -44t-111.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scaron",
    unicode: "\u0161",
    horizAdvX: 477,
    d: "M181 702l64 28l67 -63l94 63l52 -28l-119 -95h-80zM181 -10q-61 0 -116 20.5t-90 58.5l59 70q75 -69 161 -69q51 0 82 23t31 61q0 27 -25.5 41t-79.5 29q-38 11 -66 21.5t-46 24t-27 30.5t-9 40q0 44 19 79.5t51 60.5t74 38.5t89 13.5q56 0 100 -18t76 -52l-61 -66 q-29 29 -63 43.5t-71 14.5q-44 0 -75 -21t-31 -64q0 -25 21 -37.5t70 -25.5q42 -11 73 -23t51.5 -26.5t30.5 -33.5t10 -44q0 -42 -17.5 -76.5t-49 -59.5t-75.5 -39t-96 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0162",
    unicode: "\u0162",
    horizAdvX: 588,
    d: "M302 611h-222l21 99h557l-21 -99h-222l-130 -611h-25l-37 -45q8 2 16.5 3t15.5 1q29 0 47.5 -13t18.5 -40q0 -41 -33.5 -68t-100.5 -27q-30 0 -54 6t-41 14l33 43q10 -7 32 -13.5t47 -6.5q29 0 46 9.5t17 31.5q0 15 -12 21t-31 6q-20 0 -43 -4t-36 -8l64 90h-36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0163",
    unicode: "\u0163",
    horizAdvX: 355,
    d: "M41 -126q10 -7 32 -13.5t47 -6.5q29 0 46 9.5t17 31.5q0 15 -12 21t-31 6q-20 0 -43 -4t-36 -8l60 84q-33 5 -53.5 25.5t-20.5 58.5q0 17 4 33l70 327h-67l19 85h65l37 172h110l-37 -172h108l-18 -85h-107l-62 -292q-2 -10 -2 -15q0 -20 12 -29t29 -9q23 0 44 8t32 13 l4 -87q-20 -13 -51.5 -22t-66.5 -12l-31 -38q8 2 16.5 3t15.5 1q29 0 47.5 -13t18.5 -40q0 -41 -33.5 -68t-100.5 -27q-30 0 -54 6t-41 14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tcaron",
    unicode: "\u0164",
    horizAdvX: 589,
    d: "M275 888l64 28l67 -63l94 63l52 -28l-119 -95h-80zM303 611h-222l21 99h557l-21 -99h-222l-130 -611h-112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tcaron",
    unicode: "\u0165",
    horizAdvX: 355,
    d: "M322 620l76 110h104l-114 -132zM148 -8q-43 0 -72 20.5t-29 65.5q0 17 4 33l70 327h-67l19 85h65l37 172h110l-37 -172h108l-18 -85h-107l-62 -292q-2 -10 -2 -15q0 -20 12 -29t29 -9q23 0 44 8t32 13l4 -87q-23 -14 -61 -24.5t-79 -10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tbar",
    unicode: "\u0166",
    horizAdvX: 618,
    d: "M81 388h188l48 223h-222l21 99h557l-21 -99h-222l-48 -223h189l-12 -56h-189l-70 -332h-113l70 332h-188z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tbar",
    unicode: "\u0167",
    horizAdvX: 355,
    d: "M36 347h65l20 91h-66l18 85h66l37 172h110l-37 -172h107l-17 -85h-108l-20 -91h109l-15 -67h-108l-26 -121q-2 -10 -2.5 -15.5t-0.5 -10.5q0 -21 11.5 -30.5t29.5 -9.5q22 0 43 8t32 13l5 -87q-24 -14 -62 -24.5t-78 -10.5q-44 0 -72.5 20.5t-28.5 65.5q0 15 3 33l36 169 h-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Utilde",
    unicode: "\u0168",
    horizAdvX: 721,
    d: "M296 -5q-63 0 -107 18.5t-71 50.5t-39.5 75.5t-12.5 93.5q0 55 14 117l76 360h113l-77 -360q-11 -53 -11 -97q0 -33 7 -62t23 -50t42 -33t64 -12q52 0 91 22t67.5 57.5t47 81t28.5 93.5l76 360h113l-77 -360q-15 -73 -45 -137.5t-75.5 -113t-107 -76.5t-139.5 -28z M521 801q-21 0 -36 6.5t-27 15t-24 15t-28 6.5t-26.5 -7t-17 -15.5t-9 -16.5t-2.5 -9h-63q2 8 11 27t25.5 38.5t39.5 34.5t53 15q21 0 35 -7t26 -15t24 -15t29 -7q18 0 29.5 7t19 16t11 16.5t3.5 9.5h62q-2 -6 -11 -25t-26 -39t-41.5 -35.5t-56.5 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "utilde",
    unicode: "\u0169",
    horizAdvX: 586,
    d: "M150 -10q-122 0 -122 130q0 37 10 83l69 320h109l-64 -298q-7 -32 -7 -60q0 -81 69 -81q44 0 88.5 29t78.5 84l69 326h110l-83 -393q-3 -9 -3 -15q0 -19 23 -21l-19 -94q-15 -2 -26 -3.5t-20 -1.5q-30 0 -47 12.5t-17 37.5q0 8 2 21t7 40q-45 -57 -104 -86.5t-123 -29.5z M404 615q-21 0 -36 6.5t-27 15t-24 15t-28 6.5t-26.5 -7t-17 -15.5t-9 -16.5t-2.5 -9h-63q2 8 11 27t25.5 38.5t39.5 34.5t53 15q21 0 35 -7t26 -15t24 -15t29 -7q18 0 29.5 7t19 16t11 16.5t3.5 9.5h62q-2 -6 -11 -25t-26 -39t-41.5 -35.5t-56.5 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Umacron",
    unicode: "\u016A",
    horizAdvX: 721,
    d: "M296 -5q-63 0 -107 18.5t-71 50.5t-39.5 75.5t-12.5 93.5q0 55 14 117l76 360h113l-77 -360q-11 -53 -11 -97q0 -33 7 -62t23 -50t42 -33t64 -12q52 0 91 22t67.5 57.5t47 81t28.5 93.5l76 360h113l-77 -360q-15 -73 -45 -137.5t-75.5 -113t-107 -76.5t-139.5 -28z M326 828l14 70h283l-15 -70h-282z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "umacron",
    unicode: "\u016B",
    horizAdvX: 586,
    d: "M150 -10q-122 0 -122 130q0 37 10 83l69 320h109l-64 -298q-7 -32 -7 -60q0 -81 69 -81q44 0 88.5 29t78.5 84l69 326h110l-83 -393q-3 -9 -3 -15q0 -19 23 -21l-19 -94q-15 -2 -26 -3.5t-20 -1.5q-30 0 -47 12.5t-17 37.5q0 8 2 21t7 40q-45 -57 -104 -86.5t-123 -29.5z M208 642l14 70h283l-15 -70h-282z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ubreve",
    unicode: "\u016C",
    horizAdvX: 721,
    d: "M296 -5q-63 0 -107 18.5t-71 50.5t-39.5 75.5t-12.5 93.5q0 55 14 117l76 360h113l-77 -360q-11 -53 -11 -97q0 -33 7 -62t23 -50t42 -33t64 -12q52 0 91 22t67.5 57.5t47 81t28.5 93.5l76 360h113l-77 -360q-15 -73 -45 -137.5t-75.5 -113t-107 -76.5t-139.5 -28z M462 845q21 0 41 20t29 51h61q-6 -26 -19.5 -48.5t-32.5 -39t-42 -25.5t-48 -9q-43 0 -68.5 25.5t-25.5 67.5q0 8 1 15t3 14h61q-1 -5 -1.5 -9t-0.5 -9q0 -22 11.5 -37.5t30.5 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ubreve",
    unicode: "\u016D",
    horizAdvX: 586,
    d: "M150 -10q-122 0 -122 130q0 37 10 83l69 320h109l-64 -298q-7 -32 -7 -60q0 -81 69 -81q44 0 88.5 29t78.5 84l69 326h110l-83 -393q-3 -9 -3 -15q0 -19 23 -21l-19 -94q-15 -2 -26 -3.5t-20 -1.5q-30 0 -47 12.5t-17 37.5q0 8 2 21t7 40q-45 -57 -104 -86.5t-123 -29.5z M349 659q21 0 41 20t29 51h61q-6 -26 -19.5 -48.5t-32.5 -39t-42 -25.5t-48 -9q-43 0 -68.5 25.5t-25.5 67.5q0 8 1 15t3 14h61q-1 -5 -1.5 -9t-0.5 -9q0 -22 11.5 -37.5t30.5 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uring",
    unicode: "\u016E",
    horizAdvX: 721,
    d: "M384 829q0 40 30 63.5t74 23.5q35 0 53.5 -15.5t18.5 -43.5q0 -39 -29 -63t-74 -24q-34 0 -53.5 16t-19.5 43zM480 880q-18 0 -32 -12t-14 -31q0 -13 8.5 -22t22.5 -9q17 0 32 12.5t15 31.5q0 14 -9 22t-23 8zM296 -5q-63 0 -107 18.5t-71 50.5t-39.5 75.5t-12.5 93.5 q0 55 14 117l76 360h113l-77 -360q-11 -53 -11 -97q0 -33 7 -62t23 -50t42 -33t64 -12q52 0 91 22t67.5 57.5t47 81t28.5 93.5l76 360h113l-77 -360q-15 -73 -45 -137.5t-75.5 -113t-107 -76.5t-139.5 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uring",
    unicode: "\u016F",
    horizAdvX: 586,
    d: "M263 643q0 40 30 63.5t74 23.5q35 0 53.5 -15.5t18.5 -43.5q0 -39 -29 -63t-74 -24q-34 0 -53.5 16t-19.5 43zM359 694q-18 0 -32 -12t-14 -31q0 -13 8.5 -22t22.5 -9q17 0 32 12.5t15 31.5q0 14 -9 22t-23 8zM150 -10q-122 0 -122 130q0 37 10 83l69 320h109l-64 -298 q-7 -32 -7 -60q0 -81 69 -81q44 0 88.5 29t78.5 84l69 326h110l-83 -393q-3 -9 -3 -15q0 -19 23 -21l-19 -94q-15 -2 -26 -3.5t-20 -1.5q-30 0 -47 12.5t-17 37.5q0 8 2 21t7 40q-45 -57 -104 -86.5t-123 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uhungarumlaut",
    unicode: "\u0170",
    horizAdvX: 721,
    d: "M296 -5q-63 0 -107 18.5t-71 50.5t-39.5 75.5t-12.5 93.5q0 55 14 117l76 360h113l-77 -360q-11 -53 -11 -97q0 -33 7 -62t23 -50t42 -33t64 -12q52 0 91 22t67.5 57.5t47 81t28.5 93.5l76 360h113l-77 -360q-15 -73 -45 -137.5t-75.5 -113t-107 -76.5t-139.5 -28z M384 790l-54 17l71 110h89zM527 790l-53 17l70 110h89z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uhungarumlaut",
    unicode: "\u0171",
    horizAdvX: 586,
    d: "M150 -10q-122 0 -122 130q0 37 10 83l69 320h109l-64 -298q-7 -32 -7 -60q0 -81 69 -81q44 0 88.5 29t78.5 84l69 326h110l-83 -393q-3 -9 -3 -15q0 -19 23 -21l-19 -94q-15 -2 -26 -3.5t-20 -1.5q-30 0 -47 12.5t-17 37.5q0 8 2 21t7 40q-45 -57 -104 -86.5t-123 -29.5z M263 603l-54 17l71 110h89zM406 603l-53 17l70 110h89z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uogonek",
    unicode: "\u0172",
    horizAdvX: 721,
    d: "M250 -188q-42 7 -62 26t-20 44q0 29 22.5 57.5t70.5 57.5q-53 5 -90.5 25t-60.5 51.5t-33.5 72t-10.5 87.5q0 55 14 117l76 360h113l-77 -360q-11 -53 -11 -97q0 -33 7 -62t23 -50t42 -33t64 -12q52 0 91 22t67.5 57.5t47 81t28.5 93.5l76 360h113l-77 -360 q-15 -69 -42.5 -131t-69.5 -110t-98.5 -78t-127.5 -35q-46 -27 -66.5 -49t-20.5 -42q0 -32 48 -35l-36 -58v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uogonek",
    unicode: "\u0173",
    horizAdvX: 586,
    d: "M150 -10q-122 0 -122 130q0 37 10 83l69 320h109l-64 -298q-7 -32 -7 -60q0 -81 69 -81q44 0 88.5 29t78.5 84l69 326h110l-83 -393q-3 -9 -3 -15q0 -19 23 -21l-19 -94q-51 -29 -73 -51.5t-22 -43.5q0 -32 48 -35l-36 -58q-42 7 -62 26t-20 44q0 29 23 58t72 58 q-40 8 -40 47q0 8 2 21t7 40q-45 -57 -104 -86.5t-123 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wcircumflex",
    unicode: "\u0174",
    horizAdvX: 1002,
    d: "M466 821l119 95h80l78 -95l-64 -28l-67 63l-94 -63zM88 710h121l83 -580l153 261l-48 316h105l30 -241l133 241h105l-182 -316l41 -261l329 580h123l-429 -710h-95l-56 318l-192 -318h-95z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wcircumflex",
    unicode: "\u0175",
    horizAdvX: 778,
    d: "M305 635l119 95h80l78 -95l-64 -28l-67 63l-94 -63zM46 523h110l73 -425q12 16 26 36t27.5 40.5t26 40.5l22.5 36l-64 272h104l33 -166q8 16 18 38t19.5 45t17.5 44.5t13 38.5h96q-43 -138 -125 -269l34 -145q40 55 73 106t59.5 101t47.5 101t38 106h102 q-40 -131 -116 -261.5t-182 -261.5h-98l-33 158q-10 -14 -24 -35.5t-29.5 -44t-30 -43.5t-26.5 -35h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ycircumflex",
    unicode: "\u0176",
    d: "M237 256l-152 454h123l106 -356l260 356h122l-347 -456l-54 -254h-113zM266 821l119 95h80l78 -95l-64 -28l-67 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ycircumflex",
    unicode: "\u0177",
    horizAdvX: 510,
    d: "M-40 -140q31 3 53 8.5t39 15t31.5 25t30.5 38.5l29 42l-94 534h113l59 -426l34 56q37 60 63.5 108.5t45.5 91.5t32.5 84t24.5 86h108q-14 -48 -29 -90t-38 -88.5t-56.5 -104t-82.5 -137.5l-80 -129q-35 -56 -66 -94t-62.5 -61.5t-65.5 -34t-74 -10.5zM174 635l119 95h80 l78 -95l-64 -28l-67 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ydieresis",
    unicode: "\u0178",
    d: "M237 256l-152 454h123l106 -356l260 356h122l-347 -456l-54 -254h-113zM275 802l24 110h91l-23 -110h-92zM447 802l23 110h91l-23 -110h-91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zacute",
    unicode: "\u0179",
    horizAdvX: 598,
    d: "M405 788l-70 18l76 110h105zM-16 86l514 525h-392l21 99h523l-18 -86l-504 -525h393l-21 -99h-535z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zacute",
    unicode: "\u017A",
    horizAdvX: 470,
    d: "M291 602l-70 18l76 110h105zM-22 69l369 376h-279l17 78h399l-15 -69l-367 -376h290l-17 -78h-412z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zdotaccent",
    unicode: "\u017B",
    horizAdvX: 598,
    d: "M-16 86l514 525h-392l21 99h523l-18 -86l-504 -525h393l-21 -99h-535zM347 801l25 115h98l-24 -115h-99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zdotaccent",
    unicode: "\u017C",
    horizAdvX: 470,
    d: "M-22 69l369 376h-279l17 78h399l-15 -69l-367 -376h290l-17 -78h-412zM237 615l25 115h98l-24 -115h-99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zcaron",
    unicode: "\u017D",
    horizAdvX: 598,
    d: "M274 888l64 28l67 -63l94 63l52 -28l-119 -95h-80zM-16 86l514 525h-392l21 99h523l-18 -86l-504 -525h393l-21 -99h-535z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zcaron",
    unicode: "\u017E",
    horizAdvX: 470,
    d: "M163 702l64 28l67 -63l94 63l52 -28l-119 -95h-80zM-22 69l369 376h-279l17 78h399l-15 -69l-367 -376h290l-17 -78h-412z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Schwa",
    unicode: "\u018F",
    horizAdvX: 712,
    d: "M285 -5q-61 0 -109.5 23t-82 62.5t-51.5 91.5t-18 110q0 43 8.5 72t14.5 42h523q1 8 1.5 17t0.5 17q0 41 -12 74.5t-33 57.5t-50 37.5t-64 13.5q-29 0 -58.5 -9t-56 -25t-48 -38.5t-34.5 -49.5l-103 43q27 40 64 73.5t79.5 57.5t89.5 37t94 13q60 0 107 -23t79.5 -62.5 t49.5 -92.5t17 -112q0 -84 -33 -161.5t-89 -137.5t-130 -95.5t-156 -35.5zM308 95q40 0 78 15.5t70 43.5t56.5 66.5t37.5 83.5h-408q-4 -20 -4 -45q0 -35 11.5 -64.5t33.5 -52t53.5 -35t71.5 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "florin",
    unicode: "\u0192",
    horizAdvX: 519,
    d: "M47 -191q-34 0 -63 11t-49 34l64 74q10 -12 24.5 -17.5t30.5 -5.5q28 0 53 21.5t32 54.5l84 396h-66l18 85h66l15 69q10 48 29.5 86.5t46 66t59.5 42t69 14.5q30 0 59 -8.5t52 -23.5l-41 -82q-12 9 -30.5 15t-35.5 6q-73 0 -97 -113l-16 -72h126l-18 -85h-126l-84 -393 q-8 -39 -28 -71t-47.5 -55t-60.5 -36t-66 -13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C4",
    unicode: "\u01C4",
    horizAdvX: 1291,
    d: "M966 888l64 28l67 -63l94 63l52 -28l-119 -95h-80zM676 86l514 525h-392l21 99h523l-18 -86l-504 -525h393l-21 -99h-535zM166 710h241q68 0 118 -21t82.5 -58t48.5 -87t16 -108q0 -94 -31.5 -174t-87 -138t-132 -91t-165.5 -33h-241zM277 99q64 0 115.5 26t88 70.5 t56 102.5t19.5 121q0 42 -11 77t-32 60.5t-53 40t-74 14.5h-128l-109 -512h128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C5",
    unicode: "\u01C5",
    horizAdvX: 1163,
    d: "M855 702l64 28l67 -63l94 63l52 -28l-119 -95h-80zM670 69l369 376h-279l17 78h399l-15 -69l-367 -376h290l-17 -78h-412zM166 710h241q68 0 118 -21t82.5 -58t48.5 -87t16 -108q0 -94 -31.5 -174t-87 -138t-132 -91t-165.5 -33h-241zM277 99q64 0 115.5 26t88 70.5 t56 102.5t19.5 121q0 42 -11 77t-32 60.5t-53 40t-74 14.5h-128l-109 -512h128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C6",
    unicode: "\u01C6",
    horizAdvX: 1085,
    d: "M777 702l64 28l67 -63l94 63l52 -28l-119 -95h-80zM592 69l369 376h-279l17 78h399l-15 -69l-367 -376h290l-17 -78h-412zM205 -10q-44 0 -78.5 17t-58.5 46t-36.5 68.5t-12.5 84.5q0 64 23.5 123t63.5 104t92 72t109 27t95.5 -30.5t54.5 -77.5l65 306h111l-128 -600 q-1 -5 -1.5 -8.5t-0.5 -6.5q0 -20 23 -21l-20 -94q-14 -2 -25.5 -3.5t-19.5 -1.5q-31 0 -48.5 13.5t-17.5 37.5q0 8 1.5 19t6.5 30q-38 -51 -92 -78t-106 -27zM253 84q20 0 42.5 8t44 22t39.5 33t29 41l28 137q-3 24 -13.5 44.5t-26.5 36t-35 24t-40 8.5q-38 0 -71.5 -19 t-59 -49t-40.5 -68.5t-15 -77.5q0 -30 8 -55.5t23.5 -44t37.5 -29.5t49 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C7",
    unicode: "\u01C7",
    horizAdvX: 1036,
    d: "M656 -11q-85 0 -137 44l46 92q13 -12 42 -23.5t70 -11.5q43 0 72 16.5t49.5 49t35 81t28.5 112.5l77 360h112l-77 -360q-17 -81 -38.5 -147.5t-57 -113.5t-88.5 -73t-134 -26zM166 710h113l-130 -611h357l-21 -99h-470z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C8",
    unicode: "\u01C8",
    horizAdvX: 805,
    d: "M470 -191q-35 0 -63.5 11t-48.5 34l64 74q10 -12 24.5 -17.5t30.5 -5.5q27 0 52.5 21.5t32.5 54.5l115 542h110l-113 -534q-9 -40 -29 -73t-48 -57t-60.5 -37t-66.5 -13zM721 730h110l-26 -121h-110zM166 710h113l-130 -611h357l-21 -99h-470z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C9",
    unicode: "\u01C9",
    horizAdvX: 539,
    d: "M204 -191q-35 0 -63.5 11t-48.5 34l64 74q10 -12 24.5 -17.5t30.5 -5.5q27 0 52.5 21.5t32.5 54.5l115 542h110l-113 -534q-9 -40 -29 -73t-48 -57t-60.5 -37t-66.5 -13zM455 730h110l-26 -121h-110zM116 -8q-46 0 -70.5 22t-24.5 63q0 8 1 16.5t3 17.5l131 619h109 l-122 -579q-3 -11 -3 -20q0 -20 11.5 -31t31.5 -11q11 0 26 4t29 9l-4 -86q-26 -11 -59 -17.5t-59 -6.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01CA",
    unicode: "\u01CA",
    horizAdvX: 1211,
    d: "M832 -11q-85 0 -137 44l46 92q13 -12 42 -23.5t70 -11.5q43 0 72 16.5t49.5 49t35 81t28.5 112.5l77 360h112l-77 -360q-17 -81 -38.5 -147.5t-57 -113.5t-88.5 -73t-134 -26zM166 710h88l269 -512l108 511h113l-151 -709h-92l-267 500l-106 -500h-113z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01CB",
    unicode: "\u01CB",
    horizAdvX: 980,
    d: "M646 -191q-35 0 -63.5 11t-48.5 34l64 74q10 -12 24.5 -17.5t30.5 -5.5q27 0 52.5 21.5t32.5 54.5l115 542h110l-113 -534q-9 -40 -29 -73t-48 -57t-60.5 -37t-66.5 -13zM897 730h110l-26 -121h-110zM166 710h88l269 -512l108 511h113l-151 -709h-92l-267 500l-106 -500 h-113z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01CC",
    unicode: "\u01CC",
    horizAdvX: 819,
    d: "M484 -191q-35 0 -63.5 11t-48.5 34l64 74q10 -12 24.5 -17.5t30.5 -5.5q27 0 52.5 21.5t32.5 54.5l115 542h110l-113 -534q-9 -40 -29 -73t-48 -57t-60.5 -37t-66.5 -13zM735 730h110l-26 -121h-110zM112 523h99l-22 -105q39 53 99 83.5t126 30.5q33 0 55 -9t35.5 -25.5 t19.5 -38.5t6 -49q0 -21 -3.5 -44t-8.5 -47l-67 -319h-110l62 293q4 19 6 34.5t2 29.5q0 77 -64 77q-22 0 -46 -9t-47 -25.5t-43.5 -39t-33.5 -49.5l-67 -311h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oogonek",
    unicode: "\u01EA",
    horizAdvX: 724,
    d: "M250 -188q-42 7 -62 26t-20 44q0 59 94 116q-54 6 -95 32.5t-69 66t-42.5 89t-14.5 103.5q0 81 34.5 157.5t91.5 136.5t131 96t154 36q62 0 109.5 -25t79.5 -66t48.5 -94.5t16.5 -110.5q0 -77 -31 -150t-83.5 -131.5t-121 -96.5t-144.5 -44q-47 -27 -67.5 -49.5 t-20.5 -42.5q0 -32 48 -35zM319 96q58 0 108 28.5t86.5 74t57 101.5t20.5 111q0 40 -10.5 77t-31 64.5t-50.5 44t-70 16.5q-59 0 -108.5 -28.5t-86.5 -73.5t-57.5 -101.5t-20.5 -111.5q0 -41 10.5 -77.5t30.5 -64t50.5 -44t71.5 -16.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oogonek",
    unicode: "\u01EB",
    horizAdvX: 582,
    d: "M194 -193q-42 7 -62 26t-20 44q0 57 91 114q-45 3 -79.5 21.5t-57.5 48t-35 67.5t-12 80q0 63 25 121.5t68 103.5t101.5 72t125.5 27q50 0 88.5 -17.5t65 -47t40 -69.5t13.5 -85q0 -56 -20.5 -109t-56.5 -96t-86 -73t-108 -40q-50 -29 -71.5 -51.5t-21.5 -43.5 q0 -32 48 -35zM245 84q35 0 68.5 17t59.5 46.5t42 68.5t16 83q0 60 -30.5 99.5t-81.5 39.5q-35 0 -68 -17.5t-59.5 -47t-42.5 -68.5t-16 -83q0 -60 30.5 -99t81.5 -39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F1",
    unicode: "\u01F1",
    horizAdvX: 1280,
    d: "M666 86l514 525h-392l21 99h523l-18 -86l-504 -525h393l-21 -99h-535zM166 710h241q68 0 118 -21t82.5 -58t48.5 -87t16 -108q0 -94 -31.5 -174t-87 -138t-132 -91t-165.5 -33h-241zM277 99q64 0 115.5 26t88 70.5t56 102.5t19.5 121q0 42 -11 77t-32 60.5t-53 40 t-74 14.5h-128l-109 -512h128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F2",
    unicode: "\u01F2",
    horizAdvX: 1161,
    d: "M669 69l369 376h-279l17 78h399l-15 -69l-367 -376h290l-17 -78h-412zM166 710h241q68 0 118 -21t82.5 -58t48.5 -87t16 -108q0 -94 -31.5 -174t-87 -138t-132 -91t-165.5 -33h-241zM277 99q64 0 115.5 26t88 70.5t56 102.5t19.5 121q0 42 -11 77t-32 60.5t-53 40 t-74 14.5h-128l-109 -512h128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F3",
    unicode: "\u01F3",
    horizAdvX: 1085,
    d: "M592 69l369 376h-279l17 78h399l-15 -69l-367 -376h290l-17 -78h-412zM205 -10q-44 0 -78.5 17t-58.5 46t-36.5 68.5t-12.5 84.5q0 64 23.5 123t63.5 104t92 72t109 27t95.5 -30.5t54.5 -77.5l65 306h111l-128 -600q-1 -5 -1.5 -8.5t-0.5 -6.5q0 -20 23 -21l-20 -94 q-14 -2 -25.5 -3.5t-19.5 -1.5q-31 0 -48.5 13.5t-17.5 37.5q0 8 1.5 19t6.5 30q-38 -51 -92 -78t-106 -27zM253 84q20 0 42.5 8t44 22t39.5 33t29 41l28 137q-3 24 -13.5 44.5t-26.5 36t-35 24t-40 8.5q-38 0 -71.5 -19t-59 -49t-40.5 -68.5t-15 -77.5q0 -30 8 -55.5 t23.5 -44t37.5 -29.5t49 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gacute",
    unicode: "\u01F4",
    horizAdvX: 691,
    d: "M470 788l-70 18l76 110h105zM505 87q-104 -92 -213 -92q-57 0 -103.5 23.5t-79.5 63.5t-50.5 94t-17.5 114q0 83 34 160t91 136t130.5 94t152.5 35q97 0 153.5 -42.5t76.5 -112.5l-98 -62q-16 58 -57.5 87t-99.5 29q-54 0 -103 -27t-85.5 -71.5t-58 -101t-21.5 -115.5 q0 -42 11.5 -79t33 -64.5t52.5 -43.5t69 -16q104 0 208 105l16 75h-140l18 83h233l-76 -359h-94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gacute",
    unicode: "\u01F5",
    horizAdvX: 605,
    d: "M337 602l-70 18l76 110h105zM163 -223q-83 0 -131.5 29.5t-75.5 82.5l74 58q20 -42 59.5 -64t90.5 -22q32 0 62.5 9t56.5 28t44.5 48t26.5 69l16 80q-35 -48 -87 -74t-103 -26q-42 0 -75 17t-55.5 46t-34.5 67t-12 81q0 64 24 123t64.5 104t94 72t113.5 27t97.5 -30 t57.5 -78l21 99h97l-108 -508q-12 -57 -42 -101t-72 -74.5t-94 -46.5t-109 -16zM251 84q23 0 46 8.5t44 23t38 33t27 39.5l30 137q-8 50 -41 81.5t-76 31.5q-38 0 -72 -19.5t-59.5 -50t-40 -69t-14.5 -75.5q0 -29 8.5 -54.5t24 -44.5t37 -30t48.5 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aringacute",
    unicode: "\u01FA",
    horizAdvX: 649,
    d: "M484 809q25 -16 25 -48q0 -23 -11 -42t-31 -30l111 -689h-118l-28 193h-255l-109 -193h-118l403 689q-20 17 -20 44q0 32 20 53.5t52 29.5l76 104h105zM428 276l-40 305l-174 -305h214zM429 784q-18 0 -32 -12t-14 -31q0 -13 8.5 -22t22.5 -9q17 0 32 12.5t15 31.5 q0 14 -9 22t-23 8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aringacute",
    unicode: "\u01FB",
    d: "M205 -10q-44 0 -78.5 17t-58.5 46t-36.5 68.5t-12.5 84.5q0 64 23.5 123t63.5 104t92 72t109 27t95.5 -30.5t54.5 -77.5l21 98h111l-84 -392q-1 -5 -1.5 -8.5t-0.5 -6.5q0 -20 23 -21l-20 -94q-14 -2 -25.5 -3.5t-19.5 -1.5q-65 0 -65 52q0 16 7 48q-38 -51 -92 -78 t-106 -27zM253 84q20 0 42.5 8t44 22t39.5 33t29 41l28 137q-3 24 -13.5 44.5t-26.5 36t-35 24t-40 8.5q-38 0 -71.5 -19t-59 -49t-40.5 -68.5t-15 -77.5q0 -30 8 -55.5t23.5 -44t37.5 -29.5t49 -11zM392 758l-70 18l76 110h105zM258 643q0 40 30 63.5t74 23.5 q35 0 53.5 -15.5t18.5 -43.5q0 -39 -29 -63t-74 -24q-34 0 -53.5 16t-19.5 43zM354 694q-18 0 -32 -12t-14 -31q0 -13 8.5 -22t22.5 -9q17 0 32 12.5t15 31.5q0 14 -9 22t-23 8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AEacute",
    unicode: "\u01FC",
    horizAdvX: 926,
    d: "M605 788l-70 18l76 110h105zM495 710h475l-22 -99h-332l-42 -200h281l-21 -99h-281l-46 -213h341l-21 -99h-453l42 193h-225l-150 -193h-121zM428 293l62 288l-229 -288h167z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aeacute",
    unicode: "\u01FD",
    horizAdvX: 889,
    d: "M519 602l-70 18l76 110h105zM130 -10q-66 0 -103 38.5t-37 96.5q0 42 19.5 78t53 61.5t79 40t97.5 14.5q32 0 61 -5t52 -15q6 23 14 40t8 37q0 34 -24.5 56t-72.5 22q-39 0 -80 -15.5t-89 -44.5l-19 70q112 68 216 68q60 0 98.5 -22t55.5 -63q40 38 91 61.5t109 23.5 q50 0 88 -17t64 -47t39.5 -70t13.5 -85q0 -36 -6.5 -57.5t-10.5 -30.5h-401q-3 -14 -3 -27q0 -58 34.5 -92.5t87.5 -34.5q21 0 42 5.5t40 16t35 25.5t27 33l89 -27q-19 -29 -46 -53.5t-60 -42.5t-70.5 -28t-76.5 -10q-70 0 -117.5 30t-70.5 81q-23 -30 -52.5 -51 t-60.5 -34.5t-60.5 -19.5t-53.5 -6zM178 71q21 0 45.5 7t47 18.5t40.5 27t26 32.5q-3 12 -3 29q0 13 1.5 27t3.5 26q-21 8 -46.5 13t-48.5 5q-31 0 -58 -8t-46.5 -22.5t-30.5 -34.5t-11 -44q0 -32 20 -54t60 -22zM753 295q3 15 3 29q0 57 -31.5 92t-85.5 35 q-30 0 -58.5 -11.5t-52.5 -32.5t-42 -49.5t-28 -62.5h295z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oslashacute",
    unicode: "\u01FE",
    horizAdvX: 725,
    d: "M744 710l-90 -104q26 -40 39 -88t13 -99q0 -80 -34 -156.5t-90.5 -136t-130.5 -95.5t-154 -36q-41 0 -75 10.5t-63 29.5l-30 -35h-122l87 101q-26 39 -39.5 87t-13.5 101q0 81 34.5 157.5t91.5 136.5t131 96t154 36q41 0 75 -11t63 -31l32 37h122zM156 298 q0 -28 4.5 -54.5t14.5 -49.5l340 393q-17 12 -38.5 19t-47.5 7q-59 0 -108.5 -28.5t-86.5 -73.5t-57.5 -101.5t-20.5 -111.5zM319 96q58 0 108 28.5t86.5 74t57 101.5t20.5 111q0 27 -4.5 52.5t-14.5 48.5l-339 -391q37 -25 86 -25zM489 788l-70 18l76 110h105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oslashacute",
    unicode: "\u01FF",
    horizAdvX: 582,
    d: "M66 62q-23 29 -35 66.5t-12 79.5q0 63 25 121.5t68.5 103.5t102 72t125.5 27q38 0 69 -10.5t56 -28.5l33 33h65l-66 -64q24 -29 36.5 -67.5t12.5 -81.5q0 -62 -24.5 -120t-68 -103t-102 -72.5t-126.5 -27.5q-39 0 -71 10.5t-57 30.5l-34 -34h-64zM245 84q35 0 68.5 17 t60 46.5t42.5 68.5t16 83q0 23 -5 42.5t-13 36.5l-240 -267q29 -27 71 -27zM133 222q0 -44 17 -78l238 267q-29 27 -69 27q-35 0 -68 -17.5t-59.5 -47t-42.5 -68.5t-16 -83zM362 602l-70 18l76 110h105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Adblgrave",
    unicode: "\u0200",
    horizAdvX: 649,
    d: "M365 710h99l114 -710h-118l-28 193h-255l-109 -193h-118zM428 276l-40 305l-174 -305h214zM434 918h87l25 -110l-60 -19zM290 918h89l24 -110l-61 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adblgrave",
    unicode: "\u0201",
    d: "M205 -10q-44 0 -78.5 17t-58.5 46t-36.5 68.5t-12.5 84.5q0 64 23.5 123t63.5 104t92 72t109 27t95.5 -30.5t54.5 -77.5l21 98h111l-84 -392q-1 -5 -1.5 -8.5t-0.5 -6.5q0 -20 23 -21l-20 -94q-14 -2 -25.5 -3.5t-19.5 -1.5q-65 0 -65 52q0 16 7 48q-38 -51 -92 -78 t-106 -27zM253 84q20 0 42.5 8t44 22t39.5 33t29 41l28 137q-3 24 -13.5 44.5t-26.5 36t-35 24t-40 8.5q-38 0 -71.5 -19t-59 -49t-40.5 -68.5t-15 -77.5q0 -30 8 -55.5t23.5 -44t37.5 -29.5t49 -11zM341 730h87l25 -110l-60 -19zM197 730h89l24 -110l-61 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ainvertedbreve",
    unicode: "\u0202",
    horizAdvX: 649,
    d: "M365 710h99l114 -710h-118l-28 193h-255l-109 -193h-118zM428 276l-40 305l-174 -305h214zM314 794q6 26 19.5 48.5t32 39t41.5 25.5t48 9q43 0 68.5 -27.5t25.5 -67.5q0 -7 -1 -13.5t-3 -13.5h-59q1 8 1.5 14t0.5 13q0 44 -42 44q-30 0 -47 -19t-25 -52h-60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ainvertedbreve",
    unicode: "\u0203",
    d: "M205 -10q-44 0 -78.5 17t-58.5 46t-36.5 68.5t-12.5 84.5q0 64 23.5 123t63.5 104t92 72t109 27t95.5 -30.5t54.5 -77.5l21 98h111l-84 -392q-1 -5 -1.5 -8.5t-0.5 -6.5q0 -20 23 -21l-20 -94q-14 -2 -25.5 -3.5t-19.5 -1.5q-65 0 -65 52q0 16 7 48q-38 -51 -92 -78 t-106 -27zM253 84q20 0 42.5 8t44 22t39.5 33t29 41l28 137q-3 24 -13.5 44.5t-26.5 36t-35 24t-40 8.5q-38 0 -71.5 -19t-59 -49t-40.5 -68.5t-15 -77.5q0 -30 8 -55.5t23.5 -44t37.5 -29.5t49 -11zM226 608q6 26 19.5 48.5t32 39t41.5 25.5t48 9q43 0 68.5 -27.5 t25.5 -67.5q0 -7 -1 -13.5t-3 -13.5h-59q1 8 1.5 14t0.5 13q0 44 -42 44q-30 0 -47 -19t-25 -52h-60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edblgrave",
    unicode: "\u0204",
    horizAdvX: 579,
    d: "M427 918h87l25 -110l-60 -19zM283 918h89l24 -110l-61 -19zM166 710h455l-21 -99h-342l-43 -202h296l-19 -93h-297l-46 -217h351l-21 -99h-464z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edblgrave",
    unicode: "\u0205",
    horizAdvX: 545,
    d: "M361 730h87l25 -110l-60 -19zM217 730h89l24 -110l-61 -19zM229 -10q-50 0 -88.5 17t-65.5 46.5t-41 70t-14 87.5q0 64 24.5 122t68 102t103 70.5t128.5 26.5q81 0 129.5 -36.5t48.5 -107.5q0 -164 -293 -164q-43 0 -97 3v-18q0 -29 7 -54t21 -44t36 -29.5t52 -10.5 q43 0 83 21.5t63 58.5l87 -27q-19 -30 -46.5 -54.5t-60.5 -42t-70 -27.5t-75 -10zM330 451q-36 0 -66 -12.5t-53 -33.5t-39 -48.5t-26 -57.5q46 -3 85 -3q53 0 89 6.5t58.5 18t32 28t9.5 36.5q0 34 -24 50t-66 16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Einvertedbreve",
    unicode: "\u0206",
    horizAdvX: 579,
    d: "M299 794q6 26 19.5 48.5t32 39t41.5 25.5t48 9q43 0 68.5 -27.5t25.5 -67.5q0 -7 -1 -13.5t-3 -13.5h-59q1 8 1.5 14t0.5 13q0 44 -42 44q-30 0 -47 -19t-25 -52h-60zM166 710h455l-21 -99h-342l-43 -202h296l-19 -93h-297l-46 -217h351l-21 -99h-464z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "einvertedbreve",
    unicode: "\u0207",
    horizAdvX: 545,
    d: "M246 608q6 26 19.5 48.5t32 39t41.5 25.5t48 9q43 0 68.5 -27.5t25.5 -67.5q0 -7 -1 -13.5t-3 -13.5h-59q1 8 1.5 14t0.5 13q0 44 -42 44q-30 0 -47 -19t-25 -52h-60zM229 -10q-50 0 -88.5 17t-65.5 46.5t-41 70t-14 87.5q0 64 24.5 122t68 102t103 70.5t128.5 26.5 q81 0 129.5 -36.5t48.5 -107.5q0 -164 -293 -164q-43 0 -97 3v-18q0 -29 7 -54t21 -44t36 -29.5t52 -10.5q43 0 83 21.5t63 58.5l87 -27q-19 -30 -46.5 -54.5t-60.5 -42t-70 -27.5t-75 -10zM330 451q-36 0 -66 -12.5t-53 -33.5t-39 -48.5t-26 -57.5q46 -3 85 -3q53 0 89 6.5 t58.5 18t32 28t9.5 36.5q0 34 -24 50t-66 16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idblgrave",
    unicode: "\u0208",
    horizAdvX: 271,
    d: "M166 709h113l-151 -709h-113zM247 918h87l25 -110l-60 -19zM103 918h89l24 -110l-61 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idblgrave",
    unicode: "\u0209",
    horizAdvX: 239,
    d: "M192 730h87l25 -110l-60 -19zM48 730h89l24 -110l-61 -19zM112 523h110l-112 -523h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iinvertedbreve",
    unicode: "\u020A",
    horizAdvX: 271,
    d: "M166 709h113l-151 -709h-113zM125 794q6 26 19.5 48.5t32 39t41.5 25.5t48 9q43 0 68.5 -27.5t25.5 -67.5q0 -7 -1 -13.5t-3 -13.5h-59q1 8 1.5 14t0.5 13q0 44 -42 44q-30 0 -47 -19t-25 -52h-60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iinvertedbreve",
    unicode: "\u020B",
    horizAdvX: 239,
    d: "M70 608q6 26 19.5 48.5t32 39t41.5 25.5t48 9q43 0 68.5 -27.5t25.5 -67.5q0 -7 -1 -13.5t-3 -13.5h-59q1 8 1.5 14t0.5 13q0 44 -42 44q-30 0 -47 -19t-25 -52h-60zM112 523h110l-112 -523h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odblgrave",
    unicode: "\u020C",
    horizAdvX: 725,
    d: "M498 918h87l25 -110l-60 -19zM354 918h89l24 -110l-61 -19zM297 -5q-62 0 -109.5 24.5t-80 65t-49.5 93.5t-17 111q0 81 34.5 157.5t91.5 136.5t131 96t154 36q62 0 109.5 -25t79.5 -66t48.5 -94.5t16.5 -110.5q0 -80 -34 -156.5t-90.5 -136t-130.5 -95.5t-154 -36z M319 96q58 0 108 28.5t86.5 74t57 101.5t20.5 111q0 40 -10.5 77t-31 64.5t-50.5 44t-70 16.5q-59 0 -108.5 -28.5t-86.5 -73.5t-57.5 -101.5t-20.5 -111.5q0 -41 10.5 -77.5t30.5 -64t50.5 -44t71.5 -16.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odblgrave",
    unicode: "\u020D",
    horizAdvX: 582,
    d: "M359 730h87l25 -110l-60 -19zM215 730h89l24 -110l-61 -19zM224 -10q-50 0 -88 17.5t-64 47t-39.5 69t-13.5 84.5q0 63 25 121.5t68 103.5t101.5 72t125.5 27q50 0 88.5 -17.5t65 -47t40 -69.5t13.5 -85q0 -62 -25 -120t-68.5 -103t-102 -72.5t-126.5 -27.5zM245 84 q35 0 68.5 17t59.5 46.5t42 68.5t16 83q0 60 -30.5 99.5t-81.5 39.5q-35 0 -68 -17.5t-59.5 -47t-42.5 -68.5t-16 -83q0 -60 30.5 -99t81.5 -39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oinvertedbreve",
    unicode: "\u020E",
    horizAdvX: 725,
    d: "M363 794q6 26 19.5 48.5t32 39t41.5 25.5t48 9q43 0 68.5 -27.5t25.5 -67.5q0 -7 -1 -13.5t-3 -13.5h-59q1 8 1.5 14t0.5 13q0 44 -42 44q-30 0 -47 -19t-25 -52h-60zM297 -5q-62 0 -109.5 24.5t-80 65t-49.5 93.5t-17 111q0 81 34.5 157.5t91.5 136.5t131 96t154 36 q62 0 109.5 -25t79.5 -66t48.5 -94.5t16.5 -110.5q0 -80 -34 -156.5t-90.5 -136t-130.5 -95.5t-154 -36zM319 96q58 0 108 28.5t86.5 74t57 101.5t20.5 111q0 40 -10.5 77t-31 64.5t-50.5 44t-70 16.5q-59 0 -108.5 -28.5t-86.5 -73.5t-57.5 -101.5t-20.5 -111.5 q0 -41 10.5 -77.5t30.5 -64t50.5 -44t71.5 -16.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oinvertedbreve",
    unicode: "\u020F",
    horizAdvX: 582,
    d: "M245 608q6 26 19.5 48.5t32 39t41.5 25.5t48 9q43 0 68.5 -27.5t25.5 -67.5q0 -7 -1 -13.5t-3 -13.5h-59q1 8 1.5 14t0.5 13q0 44 -42 44q-30 0 -47 -19t-25 -52h-60zM224 -10q-50 0 -88 17.5t-64 47t-39.5 69t-13.5 84.5q0 63 25 121.5t68 103.5t101.5 72t125.5 27 q50 0 88.5 -17.5t65 -47t40 -69.5t13.5 -85q0 -62 -25 -120t-68.5 -103t-102 -72.5t-126.5 -27.5zM245 84q35 0 68.5 17t59.5 46.5t42 68.5t16 83q0 60 -30.5 99.5t-81.5 39.5q-35 0 -68 -17.5t-59.5 -47t-42.5 -68.5t-16 -83q0 -60 30.5 -99t81.5 -39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rdblgrave",
    unicode: "\u0210",
    horizAdvX: 637,
    d: "M418 918h87l25 -110l-60 -19zM274 918h89l24 -110l-61 -19zM15 0l151 710h295q39 0 70 -16t52.5 -43t32.5 -61.5t11 -71.5q0 -40 -14 -79t-38 -72.5t-56.5 -59t-70.5 -37.5l100 -270h-127l-92 247h-149l-52 -247h-113zM382 346q25 0 48.5 13.5t41.5 36t28.5 51.5t10.5 59 q0 45 -22 75t-56 30h-175l-57 -265h181z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rdblgrave",
    unicode: "\u0211",
    horizAdvX: 366,
    d: "M269 730h87l25 -110l-60 -19zM125 730h89l24 -110l-61 -19zM112 523h102l-26 -117q38 54 86 87t95 33q10 0 15.5 -0.5t10.5 -1.5l-21 -96q-60 -2 -112 -29.5t-84 -78.5l-68 -320h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rinvertedbreve",
    unicode: "\u0212",
    horizAdvX: 637,
    d: "M299 794q6 26 19.5 48.5t32 39t41.5 25.5t48 9q43 0 68.5 -27.5t25.5 -67.5q0 -7 -1 -13.5t-3 -13.5h-59q1 8 1.5 14t0.5 13q0 44 -42 44q-30 0 -47 -19t-25 -52h-60zM15 0l151 710h295q39 0 70 -16t52.5 -43t32.5 -61.5t11 -71.5q0 -40 -14 -79t-38 -72.5t-56.5 -59 t-70.5 -37.5l100 -270h-127l-92 247h-149l-52 -247h-113zM382 346q25 0 48.5 13.5t41.5 36t28.5 51.5t10.5 59q0 45 -22 75t-56 30h-175l-57 -265h181z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rinvertedbreve",
    unicode: "\u0213",
    horizAdvX: 366,
    d: "M146 608q6 26 19.5 48.5t32 39t41.5 25.5t48 9q43 0 68.5 -27.5t25.5 -67.5q0 -7 -1 -13.5t-3 -13.5h-59q1 8 1.5 14t0.5 13q0 44 -42 44q-30 0 -47 -19t-25 -52h-60zM112 523h102l-26 -117q38 54 86 87t95 33q10 0 15.5 -0.5t10.5 -1.5l-21 -96q-60 -2 -112 -29.5 t-84 -78.5l-68 -320h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udblgrave",
    unicode: "\u0214",
    horizAdvX: 721,
    d: "M473 918h87l25 -110l-60 -19zM329 918h89l24 -110l-61 -19zM296 -5q-63 0 -107 18.5t-71 50.5t-39.5 75.5t-12.5 93.5q0 55 14 117l76 360h113l-77 -360q-11 -53 -11 -97q0 -33 7 -62t23 -50t42 -33t64 -12q52 0 91 22t67.5 57.5t47 81t28.5 93.5l76 360h113l-77 -360 q-15 -73 -45 -137.5t-75.5 -113t-107 -76.5t-139.5 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udblgrave",
    unicode: "\u0215",
    horizAdvX: 586,
    d: "M348 730h87l25 -110l-60 -19zM204 730h89l24 -110l-61 -19zM150 -10q-122 0 -122 130q0 37 10 83l69 320h109l-64 -298q-7 -32 -7 -60q0 -81 69 -81q44 0 88.5 29t78.5 84l69 326h110l-83 -393q-3 -9 -3 -15q0 -19 23 -21l-19 -94q-15 -2 -26 -3.5t-20 -1.5 q-30 0 -47 12.5t-17 37.5q0 8 2 21t7 40q-45 -57 -104 -86.5t-123 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uinvertedbreve",
    unicode: "\u0216",
    horizAdvX: 721,
    d: "M351 794q6 26 19.5 48.5t32 39t41.5 25.5t48 9q43 0 68.5 -27.5t25.5 -67.5q0 -7 -1 -13.5t-3 -13.5h-59q1 8 1.5 14t0.5 13q0 44 -42 44q-30 0 -47 -19t-25 -52h-60zM296 -5q-63 0 -107 18.5t-71 50.5t-39.5 75.5t-12.5 93.5q0 55 14 117l76 360h113l-77 -360 q-11 -53 -11 -97q0 -33 7 -62t23 -50t42 -33t64 -12q52 0 91 22t67.5 57.5t47 81t28.5 93.5l76 360h113l-77 -360q-15 -73 -45 -137.5t-75.5 -113t-107 -76.5t-139.5 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uinvertedbreve",
    unicode: "\u0217",
    horizAdvX: 586,
    d: "M228 608q6 26 19.5 48.5t32 39t41.5 25.5t48 9q43 0 68.5 -27.5t25.5 -67.5q0 -7 -1 -13.5t-3 -13.5h-59q1 8 1.5 14t0.5 13q0 44 -42 44q-30 0 -47 -19t-25 -52h-60zM150 -10q-122 0 -122 130q0 37 10 83l69 320h109l-64 -298q-7 -32 -7 -60q0 -81 69 -81q44 0 88.5 29 t78.5 84l69 326h110l-83 -393q-3 -9 -3 -15q0 -19 23 -21l-19 -94q-15 -2 -26 -3.5t-20 -1.5q-30 0 -47 12.5t-17 37.5q0 8 2 21t7 40q-45 -57 -104 -86.5t-123 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0218",
    unicode: "\u0218",
    horizAdvX: 590,
    d: "M158 -213l39 77h-32l19 88h94l-19 -88l-50 -77h-51zM243 -7q-77 0 -144.5 24.5t-115.5 71.5l73 96q8 -13 27.5 -29t47 -29.5t62 -23t73.5 -9.5q72 0 110 28.5t38 79.5q0 22 -11.5 37.5t-32 27.5t-50 21.5t-65.5 20.5q-80 23 -121.5 56.5t-41.5 95.5q0 60 24 107t64.5 80 t94 50t113.5 17q69 0 123 -23t90 -57l-70 -92q-6 11 -22 23.5t-38 23.5t-49.5 18t-57.5 7q-76 0 -112.5 -32.5t-36.5 -83.5q0 -20 9 -34t27 -24.5t44.5 -19.5t61.5 -18q42 -11 75.5 -25t57.5 -33t37 -45.5t13 -63.5q0 -63 -24.5 -109t-66 -76t-95 -44t-111.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0219",
    unicode: "\u0219",
    horizAdvX: 477,
    d: "M94 -213l39 77h-32l19 88h94l-19 -88l-50 -77h-51zM181 -10q-61 0 -116 20.5t-90 58.5l59 70q75 -69 161 -69q51 0 82 23t31 61q0 27 -25.5 41t-79.5 29q-38 11 -66 21.5t-46 24t-27 30.5t-9 40q0 44 19 79.5t51 60.5t74 38.5t89 13.5q56 0 100 -18t76 -52l-61 -66 q-29 29 -63 43.5t-71 14.5q-44 0 -75 -21t-31 -64q0 -25 21 -37.5t70 -25.5q42 -11 73 -23t51.5 -26.5t30.5 -33.5t10 -44q0 -42 -17.5 -76.5t-49 -59.5t-75.5 -39t-96 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni021A",
    unicode: "\u021A",
    horizAdvX: 589,
    d: "M147 -213l39 77h-32l19 88h94l-19 -88l-50 -77h-51zM303 611h-222l21 99h557l-21 -99h-222l-130 -611h-112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni021B",
    unicode: "\u021B",
    horizAdvX: 355,
    d: "M64 -213l39 77h-32l19 88h94l-19 -88l-50 -77h-51zM148 -8q-43 0 -72 20.5t-29 65.5q0 17 4 33l70 327h-67l19 85h65l37 172h110l-37 -172h108l-18 -85h-107l-62 -292q-2 -10 -2 -15q0 -20 12 -29t29 -9q23 0 44 8t32 13l4 -87q-23 -14 -61 -24.5t-79 -10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessj",
    unicode: "\u0237",
    horizAdvX: 239,
    d: "M-96 -191q-35 0 -63.5 11t-48.5 34l65 74q9 -12 23.5 -17.5t31.5 -5.5q27 0 52 21.5t32 54.5l115 542h111l-114 -534q-9 -40 -29 -73t-47.5 -57t-60.5 -37t-67 -13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "schwa",
    unicode: "\u0259",
    horizAdvX: 572,
    d: "M216 -10q-50 0 -89 16t-65.5 43.5t-40 65.5t-13.5 82q0 23 4.5 50t13.5 50h394q1 7 1.5 14t0.5 14q0 57 -32 91t-82 34q-42 0 -82.5 -22t-62.5 -57l-88 27q19 29 46 53.5t60 42.5t71 28t78 10q49 0 88 -17t65 -47t40 -70t14 -85q0 -63 -24.5 -121t-67.5 -103t-102 -72 t-127 -27zM234 71q29 0 56 11.5t50.5 32.5t41 49.5t26.5 62.5h-288q-2 -8 -2 -14.5v-14.5q0 -57 32 -92t84 -35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "apostrophe",
    unicode: "\u02BC",
    horizAdvX: 529,
    d: "M260 620l48 68l4 42h129l-115 -132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "circumflex",
    unicode: "\u02C6",
    horizAdvX: 340,
    d: "M52 635l119 95h80l78 -95l-64 -28l-67 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "caron",
    unicode: "\u02C7",
    horizAdvX: 340,
    d: "M63 702l64 28l67 -63l94 63l52 -28l-119 -95h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni02C9",
    unicode: "\u02C9",
    horizAdvX: 393,
    d: "M90 712h283l-15 -70h-282z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "breve",
    unicode: "\u02D8",
    horizAdvX: 300,
    d: "M160 659q21 0 41 20t29 51h61q-6 -26 -19.5 -48.5t-32.5 -39t-42 -25.5t-48 -9q-43 0 -68.5 25.5t-25.5 67.5q0 8 1 15t3 14h61q-1 -5 -1.5 -9t-0.5 -9q0 -22 11.5 -37.5t30.5 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotaccent",
    unicode: "\u02D9",
    horizAdvX: 194,
    d: "M51 615l25 115h98l-24 -115h-99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ring",
    unicode: "\u02DA",
    horizAdvX: 245,
    d: "M57 643q0 40 30 63.5t74 23.5q35 0 53.5 -15.5t18.5 -43.5q0 -39 -29 -63t-74 -24q-34 0 -53.5 16t-19.5 43zM153 694q-18 0 -32 -12t-14 -31q0 -13 8.5 -22t22.5 -9q17 0 32 12.5t15 31.5q0 14 -9 22t-23 8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ogonek",
    unicode: "\u02DB",
    horizAdvX: 262,
    d: "M117 -188q-42 7 -62 26t-20 44q0 34 33 68.5t103 69.5l29 -20q-51 -29 -73 -51.5t-22 -43.5q0 -32 48 -35l-36 -58v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tilde",
    unicode: "\u02DC",
    horizAdvX: 407,
    d: "M268 615q-21 0 -36 6.5t-27 15t-24 15t-28 6.5t-26.5 -7t-17 -15.5t-9 -16.5t-2.5 -9h-63q2 8 11 27t25.5 38.5t39.5 34.5t53 15q21 0 35 -7t26 -15t24 -15t29 -7q18 0 29.5 7t19 16t11 16.5t3.5 9.5h62q-2 -6 -11 -25t-26 -39t-41.5 -35.5t-56.5 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hungarumlaut",
    unicode: "\u02DD",
    horizAdvX: 337,
    d: "M87 603l-54 17l71 110h89zM230 603l-53 17l70 110h89z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030F",
    unicode: "\u030F",
    horizAdvX: 337,
    d: "M200 730h87l25 -110l-60 -19zM56 730h89l24 -110l-61 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0311",
    unicode: "\u0311",
    horizAdvX: 300,
    d: "M52 608q6 26 19.5 48.5t32 39t41.5 25.5t48 9q43 0 68.5 -27.5t25.5 -67.5q0 -7 -1 -13.5t-3 -13.5h-59q1 8 1.5 14t0.5 13q0 44 -42 44q-30 0 -47 -19t-25 -52h-60v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0394",
    unicode: "\u0394",
    horizAdvX: 631,
    d: "M-17 85l259 625h92l257 -625v-85h-608v85zM474 99l-186 483l-186 -483h372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni03A9",
    unicode: "\u03A9",
    horizAdvX: 808,
    d: "M48 90h172q-75 42 -118.5 114.5t-43.5 162.5q0 69 25 132t69.5 111t105.5 76.5t132 28.5t132 -28.5t105.5 -76.5t70 -111t25.5 -132q0 -90 -44 -162.5t-119 -114.5h173v-90h-298v90q40 14 72.5 42.5t55 66t35 81t12.5 87.5q0 46 -15.5 90t-44 79t-69 56.5t-91.5 21.5 t-92 -21.5t-69.5 -56.5t-43.5 -79t-15 -90q0 -44 12.5 -87.5t35 -81t55 -66t72.5 -42.5v-90h-297v90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni03BC",
    unicode: "\u03BC",
    horizAdvX: 594,
    d: "M111 523h110l-63 -298q-8 -35 -8 -60q0 -81 72 -81q42 0 86.5 29t78.5 84l69 326h110l-83 -393q-1 -5 -1.5 -8t-0.5 -7q0 -20 26 -21l-21 -94q-15 -2 -27 -3.5t-21 -1.5q-30 0 -47 13t-17 36q0 8 1.5 21t8.5 41q-14 -21 -35.5 -42t-46.5 -37.5t-52.5 -26.5t-53.5 -10 q-38 0 -57.5 19.5t-22.5 48.5l-51 -270h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "pi",
    unicode: "\u03C0",
    horizAdvX: 702,
    d: "M515 -8q-55 0 -86.5 31t-31.5 88v314h-158v-425h-107v425h-78v97h554v-97h-104v-274q0 -29 15 -45.5t42 -16.5q11 0 26 4t28 9l16 -86q-25 -11 -57.5 -17.5t-58.5 -6.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ddotbelow",
    unicode: "\u1E0C",
    horizAdvX: 692,
    d: "M175 -189l25 116h99l-24 -116h-100zM166 710h241q68 0 118 -21t82.5 -58t48.5 -87t16 -108q0 -94 -31.5 -174t-87 -138t-132 -91t-165.5 -33h-241zM277 99q64 0 115.5 26t88 70.5t56 102.5t19.5 121q0 42 -11 77t-32 60.5t-53 40t-74 14.5h-128l-109 -512h128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ddotbelow",
    unicode: "\u1E0D",
    horizAdvX: 614,
    d: "M153 -189l25 116h99l-24 -116h-100zM205 -10q-44 0 -78.5 17t-58.5 46t-36.5 68.5t-12.5 84.5q0 64 23.5 123t63.5 104t92 72t109 27t95.5 -30.5t54.5 -77.5l65 306h111l-128 -600q-1 -5 -1.5 -8.5t-0.5 -6.5q0 -20 23 -21l-20 -94q-14 -2 -25.5 -3.5t-19.5 -1.5 q-31 0 -48.5 13.5t-17.5 37.5q0 8 1.5 19t6.5 30q-38 -51 -92 -78t-106 -27zM253 84q20 0 42.5 8t44 22t39.5 33t29 41l28 137q-3 24 -13.5 44.5t-26.5 36t-35 24t-40 8.5q-38 0 -71.5 -19t-59 -49t-40.5 -68.5t-15 -77.5q0 -30 8 -55.5t23.5 -44t37.5 -29.5t49 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hdotbelow",
    unicode: "\u1E24",
    horizAdvX: 715,
    d: "M166 710h113l-63 -297h332l63 297h112l-151 -710h-112l67 313h-332l-67 -313h-113zM204 -189l25 116h99l-24 -116h-100z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hdotbelow",
    unicode: "\u1E25",
    horizAdvX: 574,
    d: "M155 730h110l-66 -312q40 54 95 84t113 30q68 0 94.5 -36t26.5 -91q0 -20 -2.5 -41.5t-7.5 -44.5l-67 -319h-110l62 293q7 32 7 59q0 42 -18 62t-51 20q-20 0 -43.5 -9t-46 -25.5t-42 -39t-32.5 -49.5l-67 -311h-110zM131 -189l25 116h99l-24 -116h-100z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ndotaccent",
    unicode: "\u1E44",
    horizAdvX: 736,
    d: "M420 801l25 115h98l-24 -115h-99zM166 710h88l269 -512l108 511h113l-151 -709h-92l-267 500l-106 -500h-113z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ndotaccent",
    unicode: "\u1E45",
    horizAdvX: 574,
    d: "M291 615l25 115h98l-24 -115h-99zM112 523h99l-22 -105q39 53 99 83.5t126 30.5q33 0 55 -9t35.5 -25.5t19.5 -38.5t6 -49q0 -21 -3.5 -44t-8.5 -47l-67 -319h-110l62 293q4 19 6 34.5t2 29.5q0 77 -64 77q-22 0 -46 -9t-47 -25.5t-43.5 -39t-33.5 -49.5l-67 -311h-110z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rdotbelow",
    unicode: "\u1E5A",
    horizAdvX: 637,
    d: "M15 0l151 710h295q39 0 70 -16t52.5 -43t32.5 -61.5t11 -71.5q0 -40 -14 -79t-38 -72.5t-56.5 -59t-70.5 -37.5l100 -270h-127l-92 247h-149l-52 -247h-113zM382 346q25 0 48.5 13.5t41.5 36t28.5 51.5t10.5 59q0 45 -22 75t-56 30h-175l-57 -265h181zM167 -189l25 116 h99l-24 -116h-100z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rdotbelow",
    unicode: "\u1E5B",
    horizAdvX: 366,
    d: "M112 523h102l-26 -117q38 54 86 87t95 33q10 0 15.5 -0.5t10.5 -1.5l-21 -96q-60 -2 -112 -29.5t-84 -78.5l-68 -320h-110zM-33 -189l25 116h99l-24 -116h-100z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Sdotbelow",
    unicode: "\u1E62",
    horizAdvX: 590,
    d: "M243 -7q-77 0 -144.5 24.5t-115.5 71.5l73 96q8 -13 27.5 -29t47 -29.5t62 -23t73.5 -9.5q72 0 110 28.5t38 79.5q0 22 -11.5 37.5t-32 27.5t-50 21.5t-65.5 20.5q-80 23 -121.5 56.5t-41.5 95.5q0 60 24 107t64.5 80t94 50t113.5 17q69 0 123 -23t90 -57l-70 -92 q-6 11 -22 23.5t-38 23.5t-49.5 18t-57.5 7q-76 0 -112.5 -32.5t-36.5 -83.5q0 -20 9 -34t27 -24.5t44.5 -19.5t61.5 -18q42 -11 75.5 -25t57.5 -33t37 -45.5t13 -63.5q0 -63 -24.5 -109t-66 -76t-95 -44t-111.5 -14zM150 -189l25 116h99l-24 -116h-100z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sdotbelow",
    unicode: "\u1E63",
    horizAdvX: 477,
    d: "M181 -10q-61 0 -116 20.5t-90 58.5l59 70q75 -69 161 -69q51 0 82 23t31 61q0 27 -25.5 41t-79.5 29q-38 11 -66 21.5t-46 24t-27 30.5t-9 40q0 44 19 79.5t51 60.5t74 38.5t89 13.5q56 0 100 -18t76 -52l-61 -66q-29 29 -63 43.5t-71 14.5q-44 0 -75 -21t-31 -64 q0 -25 21 -37.5t70 -25.5q42 -11 73 -23t51.5 -26.5t30.5 -33.5t10 -44q0 -42 -17.5 -76.5t-49 -59.5t-75.5 -39t-96 -14zM84 -189l25 116h99l-24 -116h-100z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tdotbelow",
    unicode: "\u1E6C",
    horizAdvX: 589,
    d: "M139 -189l25 116h99l-24 -116h-100zM303 611h-222l21 99h557l-21 -99h-222l-130 -611h-112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tdotbelow",
    unicode: "\u1E6D",
    horizAdvX: 355,
    d: "M55 -189l25 116h99l-24 -116h-100zM148 -8q-43 0 -72 20.5t-29 65.5q0 17 4 33l70 327h-67l19 85h65l37 172h110l-37 -172h108l-18 -85h-107l-62 -292q-2 -10 -2 -15q0 -20 12 -29t29 -9q23 0 44 8t32 13l4 -87q-23 -14 -61 -24.5t-79 -10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wgrave",
    unicode: "\u1E80",
    horizAdvX: 1002,
    d: "M88 710h121l83 -580l153 261l-48 316h105l30 -241l133 241h105l-182 -316l41 -261l329 580h123l-429 -710h-95l-56 318l-192 -318h-95zM509 917h104l30 -110l-76 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wgrave",
    unicode: "\u1E81",
    horizAdvX: 778,
    d: "M46 523h110l73 -425q12 16 26 36t27.5 40.5t26 40.5l22.5 36l-64 272h104l33 -166q8 16 18 38t19.5 45t17.5 44.5t13 38.5h96q-43 -138 -125 -269l34 -145q40 55 73 106t59.5 101t47.5 101t38 106h102q-40 -131 -116 -261.5t-182 -261.5h-98l-33 158q-10 -14 -24 -35.5 t-29.5 -44t-30 -43.5t-26.5 -35h-108zM363 730h104l30 -110l-76 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wacute",
    unicode: "\u1E82",
    horizAdvX: 1002,
    d: "M602 788l-70 18l76 110h105zM88 710h121l83 -580l153 261l-48 316h105l30 -241l133 241h105l-182 -316l41 -261l329 580h123l-429 -710h-95l-56 318l-192 -318h-95z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wacute",
    unicode: "\u1E83",
    horizAdvX: 778,
    d: "M445 602l-70 18l76 110h105zM46 523h110l73 -425q12 16 26 36t27.5 40.5t26 40.5l22.5 36l-64 272h104l33 -166q8 16 18 38t19.5 45t17.5 44.5t13 38.5h96q-43 -138 -125 -269l34 -145q40 55 73 106t59.5 101t47.5 101t38 106h102q-40 -131 -116 -261.5t-182 -261.5h-98 l-33 158q-10 -14 -24 -35.5t-29.5 -44t-30 -43.5t-26.5 -35h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wdieresis",
    unicode: "\u1E84",
    horizAdvX: 1002,
    d: "M462 802l24 110h91l-23 -110h-92zM634 802l23 110h91l-23 -110h-91zM88 710h121l83 -580l153 261l-48 316h105l30 -241l133 241h105l-182 -316l41 -261l329 580h123l-429 -710h-95l-56 318l-192 -318h-95z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wdieresis",
    unicode: "\u1E85",
    horizAdvX: 778,
    d: "M302 615l24 110h91l-23 -110h-92zM474 615l23 110h91l-23 -110h-91zM46 523h110l73 -425q12 16 26 36t27.5 40.5t26 40.5l22.5 36l-64 272h104l33 -166q8 16 18 38t19.5 45t17.5 44.5t13 38.5h96q-43 -138 -125 -269l34 -145q40 55 73 106t59.5 101t47.5 101t38 106h102 q-40 -131 -116 -261.5t-182 -261.5h-98l-33 158q-10 -14 -24 -35.5t-29.5 -44t-30 -43.5t-26.5 -35h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zdotbelow",
    unicode: "\u1E92",
    horizAdvX: 598,
    d: "M-16 86l514 525h-392l21 99h523l-18 -86l-504 -525h393l-21 -99h-535zM149 -189l25 116h99l-24 -116h-100z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zdotbelow",
    unicode: "\u1E93",
    horizAdvX: 470,
    d: "M-22 69l369 376h-279l17 78h399l-15 -69l-367 -376h290l-17 -78h-412zM80 -189l25 116h99l-24 -116h-100z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edotbelow",
    unicode: "\u1EB8",
    horizAdvX: 579,
    d: "M166 710h455l-21 -99h-342l-43 -202h296l-19 -93h-297l-46 -217h351l-21 -99h-464zM153 -189l25 116h99l-24 -116h-100z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edotbelow",
    unicode: "\u1EB9",
    horizAdvX: 545,
    d: "M229 -10q-50 0 -88.5 17t-65.5 46.5t-41 70t-14 87.5q0 64 24.5 122t68 102t103 70.5t128.5 26.5q81 0 129.5 -36.5t48.5 -107.5q0 -164 -293 -164q-43 0 -97 3v-18q0 -29 7 -54t21 -44t36 -29.5t52 -10.5q43 0 83 21.5t63 58.5l87 -27q-19 -30 -46.5 -54.5t-60.5 -42 t-70 -27.5t-75 -10zM330 451q-36 0 -66 -12.5t-53 -33.5t-39 -48.5t-26 -57.5q46 -3 85 -3q53 0 89 6.5t58.5 18t32 28t9.5 36.5q0 34 -24 50t-66 16zM144 -189l25 116h99l-24 -116h-100z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Etilde",
    unicode: "\u1EBC",
    horizAdvX: 579,
    d: "M166 710h455l-21 -99h-342l-43 -202h296l-19 -93h-297l-46 -217h351l-21 -99h-464zM468 801q-21 0 -36 6.5t-27 15t-24 15t-28 6.5t-26.5 -7t-17 -15.5t-9 -16.5t-2.5 -9h-63q2 8 11 27t25.5 38.5t39.5 34.5t53 15q21 0 35 -7t26 -15t24 -15t29 -7q18 0 29.5 7t19 16 t11 16.5t3.5 9.5h62q-2 -6 -11 -25t-26 -39t-41.5 -35.5t-56.5 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "etilde",
    unicode: "\u1EBD",
    horizAdvX: 545,
    d: "M229 -10q-50 0 -88.5 17t-65.5 46.5t-41 70t-14 87.5q0 64 24.5 122t68 102t103 70.5t128.5 26.5q81 0 129.5 -36.5t48.5 -107.5q0 -164 -293 -164q-43 0 -97 3v-18q0 -29 7 -54t21 -44t36 -29.5t52 -10.5q43 0 83 21.5t63 58.5l87 -27q-19 -30 -46.5 -54.5t-60.5 -42 t-70 -27.5t-75 -10zM330 451q-36 0 -66 -12.5t-53 -33.5t-39 -48.5t-26 -57.5q46 -3 85 -3q53 0 89 6.5t58.5 18t32 28t9.5 36.5q0 34 -24 50t-66 16zM413 615q-21 0 -36 6.5t-27 15t-24 15t-28 6.5t-26.5 -7t-17 -15.5t-9 -16.5t-2.5 -9h-63q2 8 11 27t25.5 38.5t39.5 34.5 t53 15q21 0 35 -7t26 -15t24 -15t29 -7q18 0 29.5 7t19 16t11 16.5t3.5 9.5h62q-2 -6 -11 -25t-26 -39t-41.5 -35.5t-56.5 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idotbelow",
    unicode: "\u1ECA",
    horizAdvX: 271,
    d: "M166 709h113l-151 -709h-113zM-20 -189l25 116h99l-24 -116h-100z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idotbelow",
    unicode: "\u1ECB",
    horizAdvX: 239,
    d: "M112 523h110l-112 -523h-110zM155 730h110l-25 -121h-110zM-35 -189l25 116h99l-24 -116h-100z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odotbelow",
    unicode: "\u1ECC",
    horizAdvX: 725,
    d: "M214 -189l25 116h99l-24 -116h-100zM297 -5q-62 0 -109.5 24.5t-80 65t-49.5 93.5t-17 111q0 81 34.5 157.5t91.5 136.5t131 96t154 36q62 0 109.5 -25t79.5 -66t48.5 -94.5t16.5 -110.5q0 -80 -34 -156.5t-90.5 -136t-130.5 -95.5t-154 -36zM319 96q58 0 108 28.5 t86.5 74t57 101.5t20.5 111q0 40 -10.5 77t-31 64.5t-50.5 44t-70 16.5q-59 0 -108.5 -28.5t-86.5 -73.5t-57.5 -101.5t-20.5 -111.5q0 -41 10.5 -77.5t30.5 -64t50.5 -44t71.5 -16.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odotbelow",
    unicode: "\u1ECD",
    horizAdvX: 582,
    d: "M141 -189l25 116h99l-24 -116h-100zM224 -10q-50 0 -88 17.5t-64 47t-39.5 69t-13.5 84.5q0 63 25 121.5t68 103.5t101.5 72t125.5 27q50 0 88.5 -17.5t65 -47t40 -69.5t13.5 -85q0 -62 -25 -120t-68.5 -103t-102 -72.5t-126.5 -27.5zM245 84q35 0 68.5 17t59.5 46.5 t42 68.5t16 83q0 60 -30.5 99.5t-81.5 39.5q-35 0 -68 -17.5t-59.5 -47t-42.5 -68.5t-16 -83q0 -60 30.5 -99t81.5 -39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udotbelow",
    unicode: "\u1EE4",
    horizAdvX: 721,
    d: "M296 -5q-63 0 -107 18.5t-71 50.5t-39.5 75.5t-12.5 93.5q0 55 14 117l76 360h113l-77 -360q-11 -53 -11 -97q0 -33 7 -62t23 -50t42 -33t64 -12q52 0 91 22t67.5 57.5t47 81t28.5 93.5l76 360h113l-77 -360q-15 -73 -45 -137.5t-75.5 -113t-107 -76.5t-139.5 -28z M202 -189l25 116h99l-24 -116h-100z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udotbelow",
    unicode: "\u1EE5",
    horizAdvX: 586,
    d: "M150 -10q-122 0 -122 130q0 37 10 83l69 320h109l-64 -298q-7 -32 -7 -60q0 -81 69 -81q44 0 88.5 29t78.5 84l69 326h110l-83 -393q-3 -9 -3 -15q0 -19 23 -21l-19 -94q-15 -2 -26 -3.5t-20 -1.5q-30 0 -47 12.5t-17 37.5q0 8 2 21t7 40q-45 -57 -104 -86.5t-123 -29.5z M128 -189l25 116h99l-24 -116h-100z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ygrave",
    unicode: "\u1EF2",
    d: "M237 256l-152 454h123l106 -356l260 356h122l-347 -456l-54 -254h-113zM327 917h104l30 -110l-76 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ygrave",
    unicode: "\u1EF3",
    horizAdvX: 510,
    d: "M-40 -140q31 3 53 8.5t39 15t31.5 25t30.5 38.5l29 42l-94 534h113l59 -426l34 56q37 60 63.5 108.5t45.5 91.5t32.5 84t24.5 86h108q-14 -48 -29 -90t-38 -88.5t-56.5 -104t-82.5 -137.5l-80 -129q-35 -56 -66 -94t-62.5 -61.5t-65.5 -34t-74 -10.5zM223 730h104 l30 -110l-76 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ytilde",
    unicode: "\u1EF8",
    d: "M237 256l-152 454h123l106 -356l260 356h122l-347 -456l-54 -254h-113zM461 801q-21 0 -36 6.5t-27 15t-24 15t-28 6.5t-26.5 -7t-17 -15.5t-9 -16.5t-2.5 -9h-63q2 8 11 27t25.5 38.5t39.5 34.5t53 15q21 0 35 -7t26 -15t24 -15t29 -7q18 0 29.5 7t19 16t11 16.5 t3.5 9.5h62q-2 -6 -11 -25t-26 -39t-41.5 -35.5t-56.5 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ytilde",
    unicode: "\u1EF9",
    horizAdvX: 510,
    d: "M-40 -140q31 3 53 8.5t39 15t31.5 25t30.5 38.5l29 42l-94 534h113l59 -426l34 56q37 60 63.5 108.5t45.5 91.5t32.5 84t24.5 86h108q-14 -48 -29 -90t-38 -88.5t-56.5 -104t-82.5 -137.5l-80 -129q-35 -56 -66 -94t-62.5 -61.5t-65.5 -34t-74 -10.5zM362 615 q-21 0 -36 6.5t-27 15t-24 15t-28 6.5t-26.5 -7t-17 -15.5t-9 -16.5t-2.5 -9h-63q2 8 11 27t25.5 38.5t39.5 34.5t53 15q21 0 35 -7t26 -15t24 -15t29 -7q18 0 29.5 7t19 16t11 16.5t3.5 9.5h62q-2 -6 -11 -25t-26 -39t-41.5 -35.5t-56.5 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "enspace",
    unicode: "\u2002",
    horizAdvX: 566
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emspace",
    unicode: "\u2003",
    horizAdvX: 879
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "endash",
    unicode: "\u2013",
    horizAdvX: 571,
    d: "M43 224l21 99h452l-22 -99h-451z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emdash",
    unicode: "\u2014",
    horizAdvX: 880,
    d: "M43 224l21 99h761l-21 -99h-761z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteleft",
    unicode: "\u2018",
    horizAdvX: 225,
    d: "M243 730l-45 -118h34l-26 -124h-109l27 125l57 117h62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteright",
    unicode: "\u2019",
    horizAdvX: 217,
    d: "M111 501l45 118h-34l26 124h109l-27 -125l-57 -117h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesinglbase",
    unicode: "\u201A",
    horizAdvX: 231,
    d: "M-14 -123l47 123h-35l27 129h109l-28 -130l-57 -122h-63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblleft",
    unicode: "\u201C",
    horizAdvX: 377,
    d: "M243 730l-45 -118h34l-26 -124h-109l27 125l57 117h62zM396 730l-45 -118h33l-26 -124h-108l26 125l57 117h63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblright",
    unicode: "\u201D",
    horizAdvX: 369,
    d: "M263 501l45 118h-34l26 124h109l-27 -125l-57 -117h-62zM110 501l45 118h-33l26 124h108l-26 -125l-57 -117h-63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblbase",
    unicode: "\u201E",
    horizAdvX: 388,
    d: "M-14 -123l47 123h-35l27 129h109l-28 -130l-57 -122h-63zM142 -123l47 123h-34l27 129h109l-28 -130l-57 -122h-64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dagger",
    unicode: "\u2020",
    horizAdvX: 429,
    d: "M71 -130l74 351h-125l21 100h125l97 454h105l-97 -454h125l-21 -100h-125l-74 -351h-105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "daggerdbl",
    unicode: "\u2021",
    horizAdvX: 434,
    d: "M74 -130l53 253h-125l21 99h125l24 112h-125l21 99h125l73 342h105l-73 -342h124l-21 -99h-124l-24 -112h125l-21 -99h-125l-53 -253h-105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bullet",
    unicode: "\u2022",
    horizAdvX: 349,
    d: "M281 365q0 -23 -10 -44t-27 -37t-38.5 -25.5t-43.5 -9.5q-34 0 -55.5 23.5t-21.5 58.5q0 23 10.5 44t27 37t38 25.5t43.5 9.5q35 0 56 -23.5t21 -58.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ellipsis",
    unicode: "\u2026",
    horizAdvX: 541,
    d: "M-3 0l27 128h92l-28 -128h-91zM162 0l27 128h91l-27 -128h-91zM326 0l27 128h92l-28 -128h-91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "perthousand",
    unicode: "\u2030",
    horizAdvX: 1088,
    d: "M223 423q-29 0 -52.5 9.5t-40 26t-25.5 38.5t-9 48q0 36 16 67.5t42 55.5t59.5 38t68.5 14q58 0 92 -35.5t34 -87.5q0 -35 -16 -66.5t-42 -55.5t-59 -38t-68 -14zM234 480q17 0 34 9t30.5 24.5t22 35.5t8.5 42q0 30 -16.5 51t-42.5 21q-17 0 -34 -9.5t-30.5 -25 t-22 -35.5t-8.5 -41q0 -30 16.5 -51t42.5 -21zM484 -10q-58 0 -92 35.5t-34 87.5q0 35 16 66.5t42 55.5t59.5 38t68.5 14q28 0 51.5 -9.5t39.5 -26t25 -39t9 -47.5q0 -36 -15.5 -67.5t-41.5 -55.5t-59.5 -38t-68.5 -14zM495 47q18 0 35 9.5t30.5 25t22 35.5t8.5 41 q0 30 -16.5 51t-42.5 21q-18 0 -35 -9t-30.5 -24.5t-22 -35.5t-8.5 -42q0 -30 16.5 -51t42.5 -21zM839 -10q-58 0 -92.5 35.5t-34.5 87.5q0 35 16 66.5t42.5 55.5t60 38t68.5 14q28 0 51.5 -9.5t39.5 -26t25 -39t9 -47.5q0 -36 -16 -67.5t-42 -55.5t-59 -38t-68 -14zM850 47 q18 0 35 9.5t30.5 25t22 35.5t8.5 41q0 30 -16.5 51t-42.5 21q-18 0 -35 -9t-30.5 -24.5t-22 -35.5t-8.5 -42q0 -30 16.5 -51t42.5 -21zM32 40l338 333l322 343l42 -45l-331 -329l-330 -348z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglleft",
    unicode: "\u2039",
    horizAdvX: 343,
    d: "M35 284l286 185l-20 -91l-184 -119l134 -115l-19 -90l-209 175z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglright",
    unicode: "\u203A",
    horizAdvX: 343,
    d: "M289 229l-284 -175l20 90l183 115l-133 119l18 91l208 -185z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fraction",
    unicode: "\u2044",
    horizAdvX: 184,
    d: "M-248 40l338 333l323 343l42 -45l-332 -329l-329 -348z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zerosuperior",
    unicode: "\u2070",
    horizAdvX: 460,
    d: "M250 394q-41 0 -70.5 15.5t-48.5 40t-28 55.5t-9 61q0 42 19 86t52.5 79.5t78 58t95.5 22.5q41 0 70.5 -16t48 -41t27.5 -56t9 -61q0 -42 -18.5 -85.5t-51.5 -78.5t-77.5 -57.5t-96.5 -22.5zM163 575q0 -21 6 -41.5t18.5 -37t31.5 -26.5t45 -10q38 0 68 17t51 42.5t32 55 t11 55.5q0 21 -6 42t-18.5 37.5t-31.5 26.5t-45 10q-38 0 -68 -17t-51 -42.5t-32 -55.5t-11 -56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "foursuperior",
    unicode: "\u2074",
    horizAdvX: 387,
    d: "M256 400l21 95h-212l14 65l286 252h45l-53 -251h57l-14 -66h-57l-20 -95h-67zM145 561h148l36 167z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fivesuperior",
    unicode: "\u2075",
    horizAdvX: 374,
    d: "M269 665q57 0 92 -30.5t35 -79.5q0 -35 -16 -64.5t-43.5 -51t-64 -33.5t-76.5 -12q-50 0 -85 19.5t-49 53.5l50 43q13 -24 39.5 -38t62.5 -14q22 0 42.5 6t36.5 18t25 29t9 38q0 32 -23.5 48.5t-51.5 16.5q-26 0 -54 -13t-45 -33h-59q10 24 24.5 57.5t30 68.5t29 66.5 t21.5 51.5h225l-14 -66h-176l-47 -103q14 10 35 16t47 6z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sixsuperior",
    unicode: "\u2076",
    horizAdvX: 406,
    d: "M428 555q0 -34 -16.5 -64t-44.5 -52.5t-64.5 -35.5t-76.5 -13q-63 0 -98.5 37.5t-35.5 104.5q0 59 17 110.5t47.5 89t73.5 59t95 21.5q43 0 76 -17.5t48 -49.5l-48 -45q-10 22 -35 35.5t-57 13.5q-50 0 -87.5 -33.5t-51.5 -93.5q19 23 53.5 36t66.5 13q63 0 100.5 -33 t37.5 -83zM241 451q23 0 45 7.5t39 20.5t27.5 29.5t10.5 34.5q0 30 -25 50t-63 20q-24 0 -46 -7.5t-39 -19.5t-27 -28.5t-10 -34.5q0 -30 25 -51t63 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sevensuperior",
    unicode: "\u2077",
    horizAdvX: 365,
    d: "M348 746h-229l13 66h334l-320 -412h-75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eightsuperior",
    unicode: "\u2078",
    horizAdvX: 397,
    d: "M410 534q0 -30 -16.5 -56t-43.5 -44.5t-61.5 -29t-71.5 -10.5q-63 0 -101 31t-38 77q0 24 9 42.5t24 32.5t34 24.5t39 18.5q-21 9 -36 26.5t-15 43.5q0 27 16 49.5t41.5 38.5t56 25t59.5 9q24 0 47 -6.5t41 -19t29 -30t11 -39.5q0 -35 -25.5 -59.5t-61.5 -37.5 q29 -12 46 -34t17 -52zM344 533q0 26 -26 41.5t-59 15.5q-21 0 -41 -5.5t-35.5 -15t-25.5 -23t-10 -29.5q0 -13 7.5 -23.5t19.5 -18t27.5 -11.5t31.5 -4q19 0 39 5.5t36 15t26 23t10 29.5zM199 691q0 -11 6.5 -19.5t16.5 -14t23 -8.5t26 -3q16 0 32.5 4t30.5 11t23 17.5 t9 24.5q0 21 -22 33t-51 12q-18 0 -35 -4t-30 -11.5t-21 -18t-8 -23.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ninesuperior",
    unicode: "\u2079",
    horizAdvX: 406,
    d: "M105 647q0 34 16.5 64t44.5 52.5t64.5 35.5t76.5 13q63 0 98.5 -38t35.5 -104q0 -59 -17 -110.5t-48 -89t-73.5 -59t-94.5 -21.5q-43 0 -76 17.5t-48 49.5l49 45q9 -23 33.5 -36t57.5 -13q51 0 88 33.5t51 93.5q-19 -23 -53.5 -36.5t-67.5 -13.5q-62 0 -99.5 33.5 t-37.5 83.5zM292 751q-23 0 -44.5 -7.5t-38.5 -20.5t-27.5 -30t-10.5 -35q0 -29 24.5 -49t62.5 -20q23 0 45 7.5t39 19.5t27.5 28.5t10.5 34.5q0 29 -25 50.5t-63 21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zeroinferior",
    unicode: "\u2080",
    horizAdvX: 460,
    d: "M148 -87q-41 0 -71 15.5t-49 40t-28 55.5t-9 61q0 42 19 86t52.5 79.5t78.5 58t96 22.5q41 0 70.5 -16t48 -41t27.5 -56t9 -61q0 -42 -19 -85.5t-52 -78.5t-77.5 -57.5t-95.5 -22.5zM60 94q0 -21 6 -41.5t18.5 -37t31.5 -26.5t46 -10q37 0 67 17t51 42.5t32.5 55 t11.5 55.5q0 21 -6 42t-19 37.5t-32 26.5t-45 10q-38 0 -68 -17t-51 -42.5t-32 -55.5t-11 -56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oneinferior",
    unicode: "\u2081",
    horizAdvX: 306,
    d: "M219 -17l-13 -65h-240l14 65h89l60 279q-7 -7 -21 -15.5t-30.5 -16t-34 -13t-30.5 -5.5l15 67q17 0 37.5 8.5t37.5 19t29 19.5t12 10h68l-75 -353h82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twoinferior",
    unicode: "\u2082",
    horizAdvX: 396,
    d: "M-48 -82q8 40 21 70t32.5 52.5t46.5 39.5t64 31q26 10 52.5 19t48 21t35 28.5t13.5 40.5q0 23 -19 37t-55 14q-44 0 -76.5 -17.5t-52.5 -34.5l-33 49q8 8 25 20t40.5 22.5t54 18t65.5 7.5q64 0 95.5 -27.5t31.5 -74.5q0 -32 -11 -56t-31 -42.5t-49.5 -32t-66.5 -25.5 q-56 -18 -80 -44t-30 -51h218l-14 -65h-325z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threeinferior",
    unicode: "\u2083",
    horizAdvX: 386,
    d: "M100 -87q-59 0 -95.5 21t-39.5 61l46 48q0 -9 6.5 -20t19 -20.5t31.5 -16.5t45 -7q23 0 43.5 4.5t36.5 13t25 21t9 27.5q0 28 -34 42t-94 14h-22l12 61h22q63 0 102.5 15.5t39.5 49.5q0 23 -23.5 35.5t-52.5 12.5q-38 0 -68 -14.5t-51 -37.5l-32 53q13 14 31.5 25.5 t40 19t45 11.5t46.5 4q62 0 99 -27.5t37 -70.5q0 -41 -29 -67.5t-81 -36.5q38 -6 59 -30.5t21 -56.5q0 -33 -17 -58.5t-44.5 -42t-62.5 -25t-71 -8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fourinferior",
    unicode: "\u2084",
    horizAdvX: 386,
    d: "M153 -82l20 96h-211l13 65l287 252h45l-54 -251h58l-14 -66h-57l-20 -96h-67zM42 80h148l36 167z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fiveinferior",
    unicode: "\u2085",
    horizAdvX: 375,
    d: "M167 184q57 0 92 -30.5t35 -79.5q0 -35 -16 -64.5t-43.5 -51t-63.5 -33.5t-76 -12q-49 0 -84.5 19.5t-49.5 52.5l50 43q13 -23 39 -37.5t62 -14.5q22 0 43 6.5t36.5 18.5t25 29t9.5 38q0 32 -23.5 48.5t-51.5 16.5q-26 0 -54 -13t-45 -33h-59q10 24 24.5 57.5t30 68.5 t29 66.5t21.5 51.5h225l-14 -66h-177l-47 -103q15 10 35.5 16t46.5 6z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sixinferior",
    unicode: "\u2086",
    horizAdvX: 405,
    d: "M325 77q0 -33 -16.5 -63t-44 -52.5t-64 -35.5t-76.5 -13q-63 0 -98 37t-35 105q0 59 17 110t47.5 88.5t73.5 59t95 21.5q43 0 76 -17t47 -49l-48 -46q-9 23 -34 36t-57 13q-51 0 -88 -33t-51 -94q19 23 53.5 36.5t66.5 13.5q63 0 99.5 -33.5t36.5 -83.5zM140 -27 q23 0 44.5 7.5t38.5 20.5t27 30t10 35q0 29 -24 49.5t-62 20.5q-24 0 -46 -7.5t-39.5 -20t-27.5 -29t-10 -34.5q0 -29 25.5 -50.5t63.5 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seveninferior",
    unicode: "\u2087",
    horizAdvX: 364,
    d: "M246 265h-230l15 66h334l-321 -413h-75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eightinferior",
    unicode: "\u2088",
    horizAdvX: 399,
    d: "M310 53q0 -30 -16.5 -56t-43.5 -44.5t-62 -29t-72 -10.5q-31 0 -57 8.5t-44.5 23t-28.5 34t-10 42.5q0 24 9 42.5t24 33t34.5 25t39.5 18.5q-22 9 -37 26t-15 43q0 27 16 49.5t41.5 38.5t56.5 25t60 9q24 0 47.5 -6.5t41.5 -19t29 -30t11 -39.5q0 -35 -26.5 -59.5 t-61.5 -36.5q28 -13 46 -34.5t18 -52.5zM242 52q0 13 -7 23.5t-19 18t-27 11.5t-31 4q-20 0 -40 -5.5t-36 -15t-26 -23.5t-10 -30q0 -13 7.5 -23t19.5 -17.5t27.5 -11.5t31.5 -4q19 0 39 5.5t35.5 15t25.5 23t10 29.5zM98 209q0 -21 22.5 -33t49.5 -12q15 0 32 4t31 11.5 t23 18t9 24.5q0 21 -22 33t-51 12q-36 0 -65 -15.5t-29 -42.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nineinferior",
    unicode: "\u2089",
    horizAdvX: 406,
    d: "M4 169q0 34 16.5 64t44.5 52.5t64.5 35.5t75.5 13q63 0 99 -37.5t36 -104.5q0 -59 -17 -110t-47.5 -88.5t-73.5 -59t-95 -21.5q-44 0 -77.5 17t-48.5 49l50 46q10 -23 34 -36t58 -13q49 0 87 33t52 93q-20 -23 -54 -36.5t-67 -13.5q-63 0 -100 33.5t-37 83.5zM191 273 q-23 0 -45 -7.5t-39 -20.5t-27.5 -29.5t-10.5 -34.5q0 -29 25 -49.5t63 -20.5q23 0 45 7.5t39 20t27 29t10 34.5q0 29 -24.5 50t-62.5 21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colonmonetary",
    unicode: "\u20A1",
    horizAdvX: 542,
    d: "M146 5q-61 24 -93 80t-32 125q0 52 17.5 101.5t48.5 90.5t74 71.5t95 45.5l26 126h53l-25 -115q8 1 16.5 1.5t16.5 0.5q6 0 12 -0.5t12 -0.5l25 114h53l-27 -124q46 -14 75 -45t41 -74l-114 -34q-11 33 -36.5 51.5t-61.5 18.5t-69.5 -16.5t-60 -46t-42 -68.5t-15.5 -84 q0 -30 8 -55.5t23 -44t35.5 -29t45.5 -10.5q19 0 38.5 5.5t37 15.5t31.5 23t23 28l101 -32q-28 -44 -72.5 -76.5t-98.5 -47.5l-25 -120h-53l24 111q-6 0 -12 -0.5t-12 -0.5q-9 0 -17 0.5t-16 1.5l-24 -112h-52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "franc",
    unicode: "\u20A3",
    horizAdvX: 587,
    d: "M48 0l24 116h-80l17 79h80l110 515h451l-22 -99h-338l-44 -212h282l-20 -93h-282l-24 -111h109l-17 -79h-109l-25 -116h-112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lira",
    unicode: "\u20A4",
    horizAdvX: 497,
    d: "M72 417h66q-6 23 -10 45.5t-4 45.5q0 43 19.5 80.5t51.5 65.5t74 44.5t86 16.5q56 0 100 -28t67 -77l-73 -68q-15 38 -47 60.5t-68 22.5q-22 0 -42.5 -9t-36 -25t-24.5 -37.5t-9 -45.5q0 -22 5 -44.5t12 -46.5h174l-14 -67h-147q3 -18 3 -36v-9t-1 -8h133l-14 -67h-133 q-12 -32 -39.5 -65.5t-76.5 -78.5q21 5 39 8t35 3q36 0 65 -9t62 -9q17 0 35.5 4.5t43.5 12.5l8 -82q-26 -14 -56 -21.5t-57 -7.5q-21 0 -41 4t-40 9.5t-41 9.5t-43 4q-25 0 -57.5 -5.5t-62.5 -14.5l-9 79q56 45 89.5 83t49.5 76h-111l14 67h111q0 17 -1 29.5t-3 23.5h-96z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20A6",
    unicode: "\u20A6",
    horizAdvX: 820,
    d: "M800 388h-82l-17 -83h81l-14 -66h-81l-51 -239h-93l-128 239h-194l-51 -239h-112l51 239h-84l14 66h84l17 83h-83l14 67h84l54 255h88l133 -255h190l54 254h113l-54 -254h81zM235 305h145l-44 83h-83zM509 305h78l18 83h-140zM267 455h34l-24 45zM565 198l8 41h-30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20A9",
    unicode: "\u20A9",
    horizAdvX: 1088,
    d: "M44 328h157l-14 78h-126l14 66h101l-42 238h122l34 -238h188l-35 235h105l30 -241l133 241h105l-136 -235h189l135 238h123l-144 -238h104l-14 -66h-130l-47 -78h160l-14 -67h-186l-157 -261h-96l-56 318l-191 -318h-96l-47 261h-183zM644 328h144l44 78h-190l-8 -15z M488 406h-189l11 -78h144l37 63zM339 130l76 131h-95zM676 130l74 131h-95z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Euro",
    unicode: "\u20AC",
    horizAdvX: 759,
    d: "M149 431q22 56 59 107.5t87 90.5t110.5 62t128.5 23q93 0 150 -43t75 -112l-100 -59q-7 32 -22.5 54t-36 35t-44 18.5t-47.5 5.5q-42 0 -79.5 -14.5t-69 -39.5t-55.5 -58t-40 -70h271l-39 -62h-252q-8 -30 -8 -56h242l-39 -62h-199q6 -33 19.5 -61.5t34 -49.5t47 -33 t59.5 -12q24 0 51.5 6.5t54.5 21t51.5 36.5t44.5 53l82 -53q-24 -40 -60 -70.5t-78 -51.5t-86.5 -32t-84.5 -11q-55 0 -98.5 21t-75.5 56t-51.5 82t-25.5 98h-102l40 62h60q1 14 3 28t5 28h-66l39 62h45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B9",
    unicode: "\u20B9",
    horizAdvX: 497,
    d: "M502 508h-95q-2 -39 -16.5 -77t-39.5 -70t-57.5 -55.5t-70.5 -35.5l108 -270h-128l-135 342h93q25 0 48.5 14t41.5 37.5t29 53t11 61.5h-208l14 67h178q-10 18 -25.5 29t-35.5 11h-109l21 95h419l-14 -67h-162q11 -15 18.5 -32.5t12.5 -35.5h116z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2113",
    unicode: "\u2113",
    horizAdvX: 344,
    d: "M181 -7q-54 0 -84 29t-30 81v507q0 28 10.5 51.5t29.5 41t44 27.5t55 10q59 0 94.5 -36t35.5 -94q0 -40 -15.5 -91.5t-41 -104t-58.5 -100.5t-68 -82v-88q0 -29 17 -45.5t46 -16.5q11 0 26 3.5t28 8.5l16 -80q-22 -9 -52 -15t-53 -6zM257 595q0 32 -13.5 49.5t-36.5 17.5 t-38.5 -17t-15.5 -44v-263q20 27 39 61t33.5 69t23 68t8.5 59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii61352",
    unicode: "\u2116",
    horizAdvX: 1101,
    d: "M234 500l-106 -500h-113l151 710h88l269 -512l108 511h113l-151 -709h-92zM917 342q-35 0 -61 12t-44 32t-27 47t-9 57q0 43 16.5 83t46 71t70 49.5t87.5 18.5q34 0 60.5 -12t44.5 -32t27 -47t9 -58q0 -42 -16.5 -82t-46 -70.5t-70 -49.5t-87.5 -19zM862 501 q0 -38 19 -62.5t51 -24.5q22 0 43.5 11t38.5 30t27 44t10 53q0 38 -19.5 62.5t-50.5 24.5q-23 0 -44.5 -11t-38 -29.5t-26.5 -44t-10 -53.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "servicemark",
    unicode: "\u2120",
    horizAdvX: 736,
    d: "M651 710h107l-63 -294h-72l42 198l-99 -156h-60l-32 156l-43 -198h-72l62 294h106l26 -168zM323 625q-13 12 -32.5 21.5t-44.5 9.5q-51 0 -51 -31q0 -9 11 -16t42 -15q44 -11 67 -28t23 -50q0 -26 -10.5 -46t-29 -33t-44 -19.5t-54.5 -6.5q-35 0 -67 11t-55 30l42 54 q14 -14 39 -24t54 -10q51 0 51 27q0 11 -12.5 18.5t-44.5 16.5q-42 11 -63 27t-21 46q0 25 10.5 45t29 34t43.5 21.5t53 7.5q31 0 56.5 -9t46.5 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "trademark",
    unicode: "\u2122",
    horizAdvX: 765,
    d: "M383 639h-90l-47 -223h-73l47 223h-90l16 73h253zM442 710h106l27 -168l97 168h107l-63 -294h-73l43 198l-100 -156h-58l-34 156l-42 -198h-73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omega",
    unicode: "\u2126",
    horizAdvX: 808,
    d: "M48 90h172q-75 42 -118.5 114.5t-43.5 162.5q0 69 25 132t69.5 111t105.5 76.5t132 28.5t132 -28.5t105.5 -76.5t70 -111t25.5 -132q0 -90 -44 -162.5t-119 -114.5h173v-90h-298v90q40 14 72.5 42.5t55 66t35 81t12.5 87.5q0 46 -15.5 90t-44 79t-69 56.5t-91.5 21.5 t-92 -21.5t-69.5 -56.5t-43.5 -79t-15 -90q0 -44 12.5 -87.5t35 -81t55 -66t72.5 -42.5v-90h-297v90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "estimated",
    unicode: "\u212E",
    horizAdvX: 611,
    d: "M303 31q70 0 116.5 22t75.5 51l28 -31q-36 -35 -89.5 -59t-130.5 -24q-60 0 -110 22t-85 59t-54.5 86t-19.5 103q0 55 19.5 104.5t55 86.5t85 59t109.5 22t109.5 -22t85 -60.5t55 -89.5t19.5 -109h-422v-146q28 -34 67.5 -54t85.5 -20zM303 491q-46 0 -85.5 -21 t-67.5 -57v-118h307v117q-29 37 -68.5 58t-85.5 21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onethird",
    unicode: "\u2153",
    horizAdvX: 856,
    d: "M56 40l338 333l323 343l42 -45l-332 -329l-329 -348zM285 379l-14 -66h-211l15 66h75l59 279q-7 -7 -19.5 -15.5t-26.5 -16t-29 -13t-26 -5.5l14 66q15 0 32.5 8.5t33 19t26 19.5t10.5 10h68l-76 -352h69zM587 -5q-60 0 -96.5 21.5t-39.5 61.5l47 47q0 -9 6.5 -19.5 t19 -20.5t31.5 -16.5t45 -6.5q23 0 43.5 4.5t36.5 13t25 20.5t9 27q0 28 -34 42t-94 14h-23l13 61h22q63 0 102 15.5t39 49.5q0 23 -23 35.5t-52 12.5q-38 0 -68 -14.5t-52 -37.5l-31 53q26 29 71 45t92 16q62 0 99 -28t37 -70t-29 -68t-81 -37q38 -6 58.5 -30.5t20.5 -56.5 q0 -33 -17 -58.5t-44.5 -42t-62 -25t-70.5 -8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twothirds",
    unicode: "\u2154",
    horizAdvX: 871,
    d: "M43 313q8 40 20.5 70t31 52.5t44.5 39t61 30.5q26 10 52 19.5t46.5 21.5t33.5 28.5t13 40.5q0 23 -18.5 37t-53.5 14q-42 0 -73.5 -17t-50.5 -34l-32 48q7 8 23.5 20t39.5 22.5t52.5 18t63.5 7.5q62 0 92 -28t30 -74q0 -32 -10.5 -56t-30 -42.5t-47.5 -32.5t-64 -26 q-55 -18 -78.5 -43.5t-28.5 -50.5h201l-14 -65h-303zM109 40l338 333l323 343l42 -45l-332 -329l-329 -348zM602 -5q-60 0 -96.5 21.5t-39.5 61.5l47 47q0 -9 6.5 -19.5t19 -20.5t31.5 -16.5t45 -6.5q23 0 43.5 4.5t36.5 13t25 20.5t9 27q0 28 -34 42t-94 14h-23l13 61h22 q63 0 102 15.5t39 49.5q0 23 -23 35.5t-52 12.5q-38 0 -68 -14.5t-52 -37.5l-31 53q26 29 71 45t92 16q62 0 99 -28t37 -70t-29 -68t-81 -37q38 -6 58.5 -30.5t20.5 -56.5q0 -33 -17 -58.5t-44.5 -42t-62 -25t-70.5 -8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oneeighth",
    unicode: "\u215B",
    horizAdvX: 857,
    d: "M67 40l338 333l323 343l42 -45l-332 -329l-329 -348zM284 379l-14 -66h-211l15 66h75l59 279q-7 -7 -19.5 -15.5t-26.5 -16t-29 -13t-26 -5.5l14 66q15 0 32.5 8.5t33 19t26 19.5t10.5 10h68l-76 -352h69zM590 -5q-31 0 -56.5 8.5t-44 23t-28.5 34t-10 42.5q0 24 9 42.5 t24 33t34.5 25t39.5 18.5q-22 9 -37 26t-15 43q0 27 16 49.5t41.5 38.5t56 25t59.5 9q25 0 48 -6.5t41 -19t29 -30t11 -39.5q0 -35 -26 -59.5t-62 -36.5q29 -13 46.5 -34.5t17.5 -52.5q0 -30 -16.5 -56t-43.5 -44.5t-62 -29t-72 -10.5zM606 61q19 0 39 5.5t36 15t26 23 t10 29.5q0 27 -26 42t-59 15q-20 0 -40 -5t-36 -15t-26 -23.5t-10 -30.5q0 -13 7.5 -23t19.5 -17.5t27.5 -11.5t31.5 -4zM644 246q16 0 32.5 4t30.5 11.5t23 18t9 24.5q0 21 -22 33t-51 12q-36 0 -65 -15.5t-29 -42.5q0 -11 6.5 -19t16.5 -14t23 -9t26 -3z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threeeighths",
    unicode: "\u215C",
    horizAdvX: 865,
    d: "M191 306q-60 0 -96 22t-39 61l47 48q0 -9 6.5 -19.5t19 -20.5t31.5 -16.5t45 -6.5q22 0 43 4.5t36.5 13t25 21t9.5 27.5q0 27 -34.5 41t-94.5 14h-22l12 61h22q64 0 103 16t39 49q0 23 -23.5 35.5t-52.5 12.5q-38 0 -68 -14.5t-51 -37.5l-32 53q13 15 31.5 26t40.5 19 t45.5 12t46.5 4q61 0 98.5 -28t37.5 -70q0 -41 -29.5 -67.5t-81.5 -36.5q38 -6 59 -30.5t21 -57.5t-17 -58.5t-44.5 -42.5t-62.5 -25.5t-71 -8.5zM94 40l338 333l323 343l42 -45l-332 -329l-329 -348zM596 -5q-31 0 -56.5 8.5t-44 23t-28.5 34t-10 42.5q0 24 9 42.5t24 33 t34.5 25t39.5 18.5q-22 9 -37 26t-15 43q0 27 16 49.5t41.5 38.5t56 25t59.5 9q25 0 48 -6.5t41 -19t29 -30t11 -39.5q0 -35 -26 -59.5t-62 -36.5q29 -13 46.5 -34.5t17.5 -52.5q0 -30 -16.5 -56t-43.5 -44.5t-62 -29t-72 -10.5zM612 61q19 0 39 5.5t36 15t26 23t10 29.5 q0 27 -26 42t-59 15q-20 0 -40 -5t-36 -15t-26 -23.5t-10 -30.5q0 -13 7.5 -23t19.5 -17.5t27.5 -11.5t31.5 -4zM650 246q16 0 32.5 4t30.5 11.5t23 18t9 24.5q0 21 -22 33t-51 12q-36 0 -65 -15.5t-29 -42.5q0 -11 6.5 -19t16.5 -14t23 -9t26 -3z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fiveeighths",
    unicode: "\u215D",
    horizAdvX: 875,
    d: "M258 583q57 0 92.5 -30.5t35.5 -79.5q0 -35 -16 -64.5t-44 -51.5t-64.5 -34t-76.5 -12q-48 0 -84 20t-49 53l50 43q13 -24 39 -37.5t62 -13.5q23 0 43.5 6t36.5 18t25 29t9 38q0 32 -23.5 48.5t-51.5 16.5q-26 0 -54 -13t-45 -33h-59q10 24 24.5 57.5t30 68.5t29 66.5 t21.5 51.5h225l-14 -66h-176l-48 -103q15 10 35.5 16t46.5 6zM93 40l338 333l323 343l42 -45l-332 -329l-329 -348zM606 -5q-31 0 -56.5 8.5t-44 23t-28.5 34t-10 42.5q0 24 9 42.5t24 33t34.5 25t39.5 18.5q-22 9 -37 26t-15 43q0 27 16 49.5t41.5 38.5t56 25t59.5 9 q25 0 48 -6.5t41 -19t29 -30t11 -39.5q0 -35 -26 -59.5t-62 -36.5q29 -13 46.5 -34.5t17.5 -52.5q0 -30 -16.5 -56t-43.5 -44.5t-62 -29t-72 -10.5zM622 61q19 0 39 5.5t36 15t26 23t10 29.5q0 27 -26 42t-59 15q-20 0 -40 -5t-36 -15t-26 -23.5t-10 -30.5q0 -13 7.5 -23 t19.5 -17.5t27.5 -11.5t31.5 -4zM660 246q16 0 32.5 4t30.5 11.5t23 18t9 24.5q0 21 -22 33t-51 12q-36 0 -65 -15.5t-29 -42.5q0 -11 6.5 -19t16.5 -14t23 -9t26 -3z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seveneighths",
    unicode: "\u215E",
    horizAdvX: 845,
    d: "M23 40l338 333l323 343l42 -45l-332 -329l-329 -348zM578 -5q-31 0 -56.5 8.5t-44 23t-28.5 34t-10 42.5q0 24 9 42.5t24 33t34.5 25t39.5 18.5q-22 9 -37 26t-15 43q0 27 16 49.5t41.5 38.5t56 25t59.5 9q25 0 48 -6.5t41 -19t29 -30t11 -39.5q0 -35 -26 -59.5 t-62 -36.5q29 -13 46.5 -34.5t17.5 -52.5q0 -30 -16.5 -56t-43.5 -44.5t-62 -29t-72 -10.5zM594 61q19 0 39 5.5t36 15t26 23t10 29.5q0 27 -26 42t-59 15q-20 0 -40 -5t-36 -15t-26 -23.5t-10 -30.5q0 -13 7.5 -23t19.5 -17.5t27.5 -11.5t31.5 -4zM632 246q16 0 32.5 4 t30.5 11.5t23 18t9 24.5q0 21 -22 33t-51 12q-36 0 -65 -15.5t-29 -42.5q0 -11 6.5 -19t16.5 -14t23 -9t26 -3zM346 664h-230l14 66h334l-320 -412h-75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "partialdiff",
    unicode: "\u2202",
    horizAdvX: 565,
    d: "M252 -10q-49 0 -90.5 16t-71.5 44t-46.5 65.5t-16.5 81.5q0 48 20.5 91.5t55 76.5t79.5 52t95 19q52 0 90 -21.5t54 -59.5q2 15 3 32t1 36q0 35 -6 70.5t-21 64t-41.5 46.5t-67.5 18q-37 0 -73.5 -13t-55.5 -34l-61 65q35 36 87.5 55.5t111.5 19.5q111 0 169.5 -77 t58.5 -244q0 -98 -20 -173.5t-56 -126.5t-86.5 -77.5t-111.5 -26.5zM256 80q29 0 56 12t47.5 32t32.5 47t12 56q0 26 -9.5 48.5t-26.5 39t-40 26t-49 9.5q-29 0 -56 -11.5t-47 -31.5t-32 -46.5t-12 -56.5q0 -26 9.5 -48.5t26 -39.5t39.5 -26.5t49 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Delta",
    unicode: "\u2206",
    horizAdvX: 657,
    d: "M607 85v-85h-608v85l259 625h92zM490 99l-186 483l-186 -483h372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "product",
    unicode: "\u220F",
    horizAdvX: 772,
    d: "M548 613h-287v-703h-107v703h-80v97h661v-97h-80v-703h-107v703z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "summation",
    unicode: "\u2211",
    horizAdvX: 619,
    d: "M547 623h-328v-4l186 -250l-205 -268v-4h359v-97h-487v76l218 280l-211 283v71h468v-87z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "minus",
    unicode: "\u2212",
    horizAdvX: 550,
    d: "M76 271v89h403v-89h-403z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2215",
    unicode: "\u2215",
    horizAdvX: 589,
    d: "M-62 47l683 669l53 -53l-683 -669z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2219",
    unicode: "\u2219",
    horizAdvX: 211,
    d: "M47 243l29 137h91l-29 -137h-91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "radical",
    unicode: "\u221A",
    horizAdvX: 454,
    d: "M16 371h177l65 -283l112 702h101l-152 -790h-126l-85 293h-92v78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "infinity",
    unicode: "\u221E",
    horizAdvX: 704,
    d: "M217 526q29 0 51 -7.5t39 -19.5t30 -28.5t24 -34.5q11 18 24 34.5t30 28.5t39 19.5t52 7.5q37 0 67 -14t51.5 -37.5t33 -55.5t11.5 -68t-12.5 -67.5t-34.5 -55.5t-52 -37.5t-65 -13.5q-28 0 -49.5 6.5t-38.5 18t-30 26t-24 30.5q-11 -16 -23.5 -30.5t-30 -26t-40 -18 t-52.5 -6.5q-31 0 -60.5 14t-52.5 37.5t-37 55.5t-14 68t12.5 67.5t34.5 55.5t52 37.5t65 13.5zM221 262q20 0 35.5 7t28 19t23 28t19.5 34q-19 37 -42 63.5t-64 26.5q-15 0 -30 -5t-26.5 -15.5t-19 -27.5t-7.5 -40q0 -24 7.5 -41t19 -28t26.5 -16t30 -5zM501 262q15 0 30 5 t26.5 16t19 28t7.5 41q0 23 -7.5 40t-19 27.5t-26.5 15.5t-30 5q-21 0 -36.5 -7.5t-27.5 -20.5t-21.5 -30t-17.5 -36q9 -17 18.5 -32.5t21.5 -27t27.5 -18t35.5 -6.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "integral",
    unicode: "\u222B",
    horizAdvX: 334,
    d: "M105 644q-2 28 -3.5 52t-1.5 29q0 44 30 69.5t86 25.5q27 0 59.5 -6.5t58.5 -17.5l-22 -78q-29 13 -53 13q-25 0 -39.5 -10.5t-14.5 -31.5q0 -17 3 -65l34 -618q2 -23 2.5 -42t0.5 -22q0 -52 -30 -80.5t-85 -28.5q-26 0 -58.5 6.5t-57.5 17.5l22 78q28 -13 51 -13 q25 0 39.5 15.5t14.5 41.5q0 1 -0.5 15t-1.5 29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "approxequal",
    unicode: "\u2248",
    horizAdvX: 448,
    d: "M381 346q-14 -23 -38 -40t-61 -17q-23 0 -40 6.5t-31.5 15t-28.5 15t-30 6.5q-20 0 -31 -7.5t-16 -17.5l-50 44q13 22 35.5 39t57.5 17q22 0 38.5 -7t31 -15.5t29 -15.5t32.5 -7q21 0 33.5 7.5t19.5 16.5zM381 198q-14 -20 -38 -36t-61 -16q-23 0 -40 6.5t-31.5 15 t-28.5 15t-30 6.5q-20 0 -31 -7.5t-16 -17.5l-50 44q13 22 35.5 39t57.5 17q22 0 38.5 -7t31 -15.5t29 -15.5t32.5 -7q21 0 33.5 7t19.5 16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "notequal",
    unicode: "\u2260",
    horizAdvX: 480,
    d: "M79 388h185l65 123l44 -24l-52 -99h67v-73h-106l-41 -78h147v-73h-185l-64 -122l-44 24l51 98h-67v73h106l41 78h-147v73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lessequal",
    unicode: "\u2264",
    horizAdvX: 468,
    d: "M50 40v89h343v-89h-343zM50 412l340 164v-105l-201 -90l201 -87v-108l-340 158v68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greaterequal",
    unicode: "\u2265",
    horizAdvX: 492,
    d: "M74 129h342v-89h-342v89zM77 294l201 87l-201 90v105l339 -164v-68l-339 -158v108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lozenge",
    unicode: "\u25CA",
    horizAdvX: 543,
    d: "M345 730l186 -364l-186 -366h-120l-186 366l186 364h120zM433 354l-149 295l-138 -274l147 -297z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "commaaccent",
    unicode: "\uF6C3",
    horizAdvX: 179,
    d: "M21 -213l39 77h-32l19 88h94l-19 -88l-50 -77h-51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s_t",
    unicode: "\uFB06",
    horizAdvX: 810,
    d: "M183 -10q-31 0 -61 5.5t-57 15.5t-50 23t-39 28l58 75q76 -67 162 -67q22 0 43 5t37 15.5t25.5 25t9.5 34.5q0 17 -7.5 28t-21.5 18.5t-34 13t-44 11.5q-34 8 -62 16.5t-47.5 21.5t-30.5 33t-11 52q0 44 20.5 79t52.5 59t72.5 37t79.5 13q26 0 59 -7t56 -24 q-4 15 -6.5 32t-2.5 35q0 33 10.5 64t35 55t64 39t97.5 15q75 0 102.5 -26t27.5 -74q0 -23 -5 -53t-12 -65h107l-18 -85h-107l-62 -292q-1 -5 -1.5 -8t-0.5 -7q0 -20 11.5 -29t30.5 -9q21 0 42.5 8t33.5 13l3 -87q-12 -5 -28 -11t-34 -11.5t-38 -9t-39 -3.5q-43 0 -72 20 t-29 65q0 11 2 23.5t5 26.5l66 311h-66l18 85h66q15 72 15 107q0 33 -13 46t-45 13q-31 0 -53.5 -10t-37 -26.5t-21.5 -39.5t-7 -48q0 -17 2.5 -33t6.5 -29t7.5 -22.5t6.5 -13.5l-59 -68q-31 32 -64 43.5t-64 11.5q-21 0 -41.5 -5t-36 -15t-25 -25.5t-9.5 -37.5 q0 -19 8 -30.5t23 -19t37 -13t50 -11.5q34 -7 60.5 -15.5t45 -22t28 -33.5t9.5 -50q0 -44 -19.5 -78.5t-52 -58.5t-75 -36.5t-87.5 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A.sc",
    horizAdvX: 570,
    d: "M301 555h82l114 -555h-104l-29 144h-218l-89 -144h-107zM359 230l-43 203l-130 -203h173z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B.sc",
    horizAdvX: 569,
    d: "M127 555h302q26 0 45.5 -10t32.5 -26t19.5 -37t6.5 -43q0 -24 -8 -47.5t-22.5 -44t-35.5 -36.5t-47 -26q38 -12 59.5 -41.5t21.5 -71.5q0 -41 -18 -73t-47.5 -54t-68.5 -33.5t-81 -11.5h-277zM303 85q19 0 37 7.5t31.5 20t22 29t8.5 34.5q0 26 -16 45.5t-43 19.5h-184 l-32 -156h176zM338 320q18 0 34.5 6.5t29 18.5t20.5 28.5t8 36.5q0 26 -15.5 42t-41.5 16h-165l-32 -148h162z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C.sc",
    horizAdvX: 570,
    d: "M247 -5q-53 0 -93.5 20t-69 53.5t-43 76.5t-14.5 89q0 57 25.5 114.5t71.5 104t109 76t138 29.5q78 0 127.5 -33.5t64.5 -87.5l-87 -53q-6 24 -19.5 40.5t-31 26t-37.5 14t-39 4.5q-50 0 -90.5 -21t-69.5 -54t-44.5 -73.5t-15.5 -79.5q0 -32 9.5 -60t27.5 -50t44 -34.5 t59 -12.5q41 0 87.5 20.5t78.5 67.5l71 -48q-20 -31 -50.5 -55t-65.5 -40.5t-72 -25t-71 -8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D.sc",
    horizAdvX: 609,
    d: "M127 555h209q60 0 104 -17t73.5 -46.5t43.5 -70t14 -86.5q0 -73 -27 -134.5t-74 -106t-111.5 -69.5t-140.5 -25h-209zM237 88q53 0 96 19t73 50.5t46 73.5t16 89q0 66 -38 106.5t-113 40.5h-109l-81 -379h110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E.sc",
    horizAdvX: 513,
    d: "M127 555h395l-19 -88h-295l-31 -144h256l-17 -81h-256l-33 -154h303l-19 -88h-402z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F.sc",
    horizAdvX: 495,
    d: "M127 555h390l-19 -88h-290l-33 -152h244l-18 -82h-243l-50 -233h-99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G.alt",
    horizAdvX: 696,
    d: "M301 -5q-62 0 -110 24.5t-81 65.5t-50.5 94.5t-17.5 112.5q0 78 32.5 154t88 136t130 96.5t158.5 36.5q86 0 143.5 -40.5t82.5 -109.5l-104 -71q-6 18 -17 39t-29 39t-43.5 30t-59.5 12q-57 0 -106 -28.5t-85 -74t-56.5 -102t-20.5 -112.5q0 -39 9.5 -75t29 -64t49 -45 t69.5 -17q37 0 72.5 14.5t65.5 38t53 54t37 63.5h-161l21 100h284l-3 -12t-4 -17t-4 -17l-3 -12q-17 -63 -52 -120t-84 -99.5t-108.5 -68t-125.5 -25.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G.sc",
    horizAdvX: 596,
    d: "M416 64q-84 -68 -174 -68q-49 0 -88.5 19.5t-67.5 52t-43 75.5t-15 90q0 64 28 123t74.5 104t108 72t127.5 27q81 0 129 -33.5t65 -87.5l-87 -56q-13 44 -47.5 66t-81.5 22q-44 0 -83.5 -19.5t-68.5 -52t-46 -74t-17 -85.5q0 -33 10 -61t28 -48.5t44 -32.5t58 -12 q82 0 168 78l10 47h-119l15 73h203l-60 -283h-83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H.sc",
    horizAdvX: 628,
    d: "M127 555h99l-48 -227h285l47 227h100l-118 -555h-99l50 240h-284l-51 -240h-99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I.sc",
    horizAdvX: 245,
    d: "M127 555h99l-118 -555h-99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J.sc",
    horizAdvX: 422,
    d: "M81 -8q-75 0 -120 33l41 82q11 -9 36.5 -18t61.5 -9q37 0 61.5 12t41 36t27.5 60.5t21 84.5l60 282h100l-61 -282q-14 -63 -31 -115t-46.5 -89t-75.5 -57t-116 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K.sc",
    horizAdvX: 561,
    d: "M127 555h99l-59 -279l328 279h105l-279 -246l175 -309h-106l-142 252l-104 -84l-36 -168h-99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L.sc",
    horizAdvX: 466,
    d: "M127 555h99l-99 -467h283l-18 -88h-383z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "caron.alt",
    horizAdvX: 233,
    d: "M50 620l76 110h104l-114 -132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M.sc",
    horizAdvX: 731,
    d: "M127 555h107l117 -325l255 325h106l-118 -555h-99l81 380l-227 -285h-54l-106 285l-81 -380h-99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N.sc",
    horizAdvX: 646,
    d: "M127 555h77l244 -378l80 378h100l-118 -555h-82l-241 370l-79 -370h-99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O.sc",
    horizAdvX: 627,
    d: "M248 -4q-53 0 -94.5 19.5t-70 52t-43 74.5t-14.5 88q0 63 28.5 122t75.5 104.5t109 73.5t130 28q54 0 95 -19.5t69 -52.5t42.5 -75.5t14.5 -87.5q0 -62 -28 -121t-75 -105t-109 -73.5t-130 -27.5zM269 85q48 0 88 21t69 54t45.5 73.5t16.5 80.5q0 31 -9 59t-26.5 49.5 t-43.5 34t-60 12.5q-48 0 -88.5 -20.5t-70 -53.5t-46 -74t-16.5 -81q0 -31 9 -59t26.5 -49.5t44 -34t61.5 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P.sc",
    horizAdvX: 531,
    d: "M127 555h246q34 0 61.5 -13t46.5 -34.5t29 -49.5t10 -57q0 -39 -17.5 -77t-47.5 -68t-70 -48.5t-86 -18.5h-151l-40 -189h-99zM312 276q22 0 41 9t33.5 24.5t23 36.5t8.5 45q0 35 -20 55.5t-50 20.5h-140l-41 -191h145z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q.sc",
    horizAdvX: 627,
    d: "M408 39q-36 -20 -76.5 -31.5t-83.5 -11.5q-53 0 -94.5 19.5t-70 52t-43 74.5t-14.5 88q0 63 28.5 122t75.5 105t109 74t130 28q54 0 95 -20t69 -53t42.5 -75.5t14.5 -87.5q0 -67 -32 -129.5t-86 -109.5l59 -84h-95zM269 85q47 0 91 22l-65 93h96l31 -45q31 34 48.5 76 t17.5 84q0 31 -9 59t-26.5 49.5t-43.5 34t-60 12.5q-48 0 -88.5 -21t-70 -54t-46 -74t-16.5 -81q0 -31 9 -59t26.5 -49.5t44 -34t61.5 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R.sc",
    horizAdvX: 565,
    d: "M127 555h255q35 0 62.5 -13t46 -34.5t28.5 -49.5t10 -57q0 -31 -11 -61t-31 -55.5t-47 -45t-59 -30.5l94 -209h-114l-85 189h-128l-40 -189h-99zM321 276q21 0 40 9.5t34 25t23.5 36t8.5 42.5q0 34 -19.5 56t-50.5 22h-149l-41 -191h154z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S.sc",
    horizAdvX: 513,
    d: "M202 -6q-64 0 -122 19t-100 54l64 86q9 -12 25.5 -24.5t40 -22.5t52 -16.5t61.5 -6.5q55 0 85.5 19.5t30.5 55.5q0 16 -9.5 27.5t-27 20t-42 16t-55.5 15.5q-68 18 -102.5 45.5t-34.5 78.5q0 47 20 83.5t54 62t78.5 39t94.5 13.5q59 0 104.5 -18t76.5 -45l-60 -81 q-14 19 -52.5 37.5t-89.5 18.5q-61 0 -89.5 -22.5t-28.5 -57.5q0 -29 30 -43t89 -29q35 -9 64 -20t49.5 -26t31.5 -36t11 -51q0 -51 -20.5 -87t-55 -59.5t-79.5 -34.5t-94 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T.sc",
    horizAdvX: 521,
    d: "M247 467h-193l19 88h482l-18 -88h-191l-99 -467h-100z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U.sc",
    horizAdvX: 626,
    d: "M249 -4q-55 0 -93 15t-62 41t-35 61t-11 76q0 20 2.5 41t7.5 43l60 282h99l-59 -282q-4 -17 -6 -33t-2 -32q0 -26 6 -48.5t20 -39t36.5 -26t54.5 -9.5q43 0 75.5 16t56 42t37.5 60t22 70l59 282h100l-60 -282q-12 -57 -36.5 -107.5t-63 -88t-90.5 -59.5t-118 -22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V.sc",
    horizAdvX: 567,
    d: "M60 555h105l82 -415l256 415h105l-349 -555h-85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W.alt",
    horizAdvX: 1041,
    d: "M94 710h127l39 -542l279 542h123l52 -542l270 542h127l-363 -710h-118l-68 526l-289 -526h-117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W.sc",
    horizAdvX: 876,
    d: "M59 555h107l90 -435l116 182l-46 250h92l30 -185l110 185h92l-152 -250l40 -182l273 435h109l-359 -555h-83l-56 239l-157 -239h-85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X.sc",
    horizAdvX: 545,
    d: "M214 274l-153 281h109l112 -211l201 211h109l-272 -281l148 -274h-109l-107 203l-193 -203h-109z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y.sc",
    horizAdvX: 539,
    d: "M194 197l-139 358h108l98 -272l215 272h109l-293 -359l-41 -196h-100z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z.sc",
    horizAdvX: 534,
    d: "M-13 76l428 391h-336l18 88h453l-16 -76l-420 -391h338l-19 -88h-463z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a.alt",
    horizAdvX: 607,
    d: "M204 -10q-44 0 -78.5 17t-58 46t-36 68t-12.5 84q0 65 24.5 124.5t65 104.5t92.5 71.5t108 26.5q57 0 96 -30t53 -78l21 93h110l-110 -517h-110l20 93q-35 -48 -82 -75.5t-103 -27.5zM251 84q47 0 87.5 29t69.5 74l30 136q-8 51 -39 83t-77 32q-37 0 -70.5 -19t-59.5 -50 t-41.5 -69t-15.5 -77q0 -29 8 -54.5t23 -44t36.5 -29.5t48.5 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a.alt2",
    horizAdvX: 535,
    d: "M130 -10q-31 0 -56.5 10.5t-43.5 28.5t-28 42.5t-10 53.5q0 48 22 84t57 60.5t80 37t91 12.5q43 0 74.5 -7.5t48.5 -16.5l8 36q4 17 4 35q0 42 -24.5 65t-72.5 23q-40 0 -81 -15.5t-89 -44.5l-19 70q52 31 105.5 49.5t110.5 18.5q90 0 135 -41t45 -113q0 -29 -6 -59 l-68 -319h-106l15 76q-39 -44 -89 -65t-103 -21zM178 71q32 0 69 13.5t63 41.5q10 10 17.5 19.5t9.5 18.5l14 69q-24 11 -51.5 17t-53.5 6q-25 0 -51 -6.5t-47 -20t-34.5 -34t-13.5 -48.5q0 -35 22 -55.5t56 -20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c_t",
    horizAdvX: 885,
    d: "M226 -10q-51 0 -89.5 18t-65 48t-39.5 70t-13 84q0 60 23.5 117.5t66 103t102 73.5t130.5 28q47 0 75.5 -11t54.5 -31q-5 15 -8.5 35t-3.5 40q0 38 13.5 70.5t39 56t62.5 36.5t85 13q41 0 67.5 -8t42 -22t21.5 -33.5t6 -42.5q0 -25 -5 -53.5t-12 -58.5h107l-18 -85h-107 l-61 -292q-2 -5 -2 -15q0 -20 12 -29t29 -9q23 0 44 8t32 13l4 -87q-23 -10 -61 -22.5t-79 -12.5q-43 0 -72 20.5t-29 65.5q0 17 4 33l70 327h-67l19 85h65q7 29 11.5 54.5t4.5 45.5q0 32 -15 49t-53 17q-30 0 -50.5 -11.5t-34 -30.5t-19.5 -43.5t-6 -49.5q0 -21 3 -43.5 t7 -43t8 -38t6 -27.5l-113 -34q-12 35 -38 52.5t-63 17.5q-38 0 -71 -18.5t-58.5 -49t-40 -69t-14.5 -78.5q0 -29 8 -54.5t22.5 -44.5t35.5 -29.5t47 -10.5q16 0 34.5 5t36.5 14t33.5 22.5t24.5 30.5l100 -32q-19 -31 -46.5 -56t-60 -42t-69 -26.5t-73.5 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d.alt",
    horizAdvX: 606,
    d: "M205 -10q-44 0 -78.5 17t-58.5 46t-36.5 68.5t-12.5 84.5q0 64 23.5 123t63.5 104t92 72t108 27q58 0 96 -30.5t55 -77.5l65 306h110l-155 -730h-109l18 87q-35 -45 -82 -71t-99 -26zM252 84q21 0 44 8t44.5 22t39.5 33t28 41l28 137q-3 24 -13.5 45t-26 36t-35.5 23.5 t-41 8.5q-37 0 -70.5 -19t-59 -49.5t-40.5 -68.5t-15 -77q0 -30 8.5 -55.5t23.5 -44t36.5 -29.5t48.5 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.lnum",
    horizAdvX: 579,
    d: "M515 238q0 -54 -25 -99.5t-66 -78t-93.5 -50.5t-108.5 -18q-44 0 -81 13.5t-63.5 37.5t-41 57.5t-14.5 72.5q0 40 14.5 73t37.5 59t50 45t53 30q-28 15 -46.5 45.5t-18.5 68.5q0 51 25.5 91t64.5 68t85.5 42.5t88.5 14.5q34 0 67 -10.5t59.5 -30.5t42.5 -50t16 -69 q0 -30 -11 -56t-29 -48t-41 -39t-47 -27q34 -18 58 -55t24 -87zM404 234q0 24 -9 42.5t-24 31t-35 19.5t-41 7q-28 0 -56.5 -10.5t-51 -29.5t-36.5 -45.5t-14 -57.5q0 -23 9 -41.5t24 -31.5t34.5 -20t40.5 -7q28 0 56 10.5t51 29.5t37.5 45t14.5 58zM223 498q0 -20 8 -34.5 t20.5 -25t29 -15.5t33.5 -5q21 0 44.5 7.5t43 22t32.5 36t13 49.5q0 37 -27 58t-65 21q-24 0 -48 -8t-42.5 -23t-30 -36t-11.5 -47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.lnum",
    horizAdvX: 543,
    d: "M191 -10q-73 0 -124 34.5t-69 94.5l79 63q17 -43 53 -68.5t82 -25.5q33 0 62.5 12.5t52 35t36 53t13.5 65.5q0 48 -26.5 77.5t-71.5 29.5q-35 0 -69 -17t-60 -48h-97q6 14 19.5 47.5t30.5 77t36 91.5t35.5 89.5t28 71t15.5 37.5h331l-22 -101h-250l-74 -193 q20 19 48 29.5t63 10.5q40 0 73.5 -13.5t56.5 -37.5t36 -58t13 -74q0 -61 -24.5 -113t-66 -89.5t-96 -59t-114.5 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.numerator",
    horizAdvX: 374,
    d: "M251 583q57 0 92.5 -30.5t35.5 -79.5q0 -35 -16 -64.5t-44 -51.5t-64.5 -34t-76.5 -12q-48 0 -84 20t-49 53l50 43q13 -24 39 -37.5t62 -13.5q23 0 43.5 6t36.5 18t25 29t9 38q0 32 -23.5 48.5t-51.5 16.5q-26 0 -54 -13t-45 -33h-59q10 24 24.5 57.5t30 68.5t29 66.5 t21.5 51.5h225l-14 -66h-176l-48 -103q15 10 35.5 16t46.5 6z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.denominator",
    horizAdvX: 399,
    d: "M133 -5q-31 0 -56.5 8.5t-44 23t-28.5 34t-10 42.5q0 24 9 42.5t24 33t34.5 25t39.5 18.5q-22 9 -37 26t-15 43q0 27 16 49.5t41.5 38.5t56 25t59.5 9q25 0 48 -6.5t41 -19t29 -30t11 -39.5q0 -35 -26 -59.5t-62 -36.5q29 -13 46.5 -34.5t17.5 -52.5q0 -30 -16.5 -56 t-43.5 -44.5t-62 -29t-72 -10.5zM149 61q19 0 39 5.5t36 15t26 23t10 29.5q0 27 -26 42t-59 15q-20 0 -40 -5t-36 -15t-26 -23.5t-10 -30.5q0 -13 7.5 -23t19.5 -17.5t27.5 -11.5t31.5 -4zM187 246q16 0 32.5 4t30.5 11.5t23 18t9 24.5q0 21 -22 33t-51 12q-36 0 -65 -15.5 t-29 -42.5q0 -11 6.5 -19t16.5 -14t23 -9t26 -3z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.lnum",
    horizAdvX: 559,
    d: "M261 0l36 172h-297l21 98l425 440h75l-93 -439h84l-21 -99h-84l-36 -172h-110zM330 271l58 272l-255 -272h197z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j.alt",
    horizAdvX: 239,
    d: "M110 517h110l-155 -730h-110zM155 724h109l-24 -115h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l.alt",
    horizAdvX: 247,
    d: "M159 730h110l-155 -730h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.lnum",
    horizAdvX: 592,
    d: "M74 426q0 59 25.5 111.5t67.5 92t96.5 62.5t113.5 23q91 0 141.5 -60.5t50.5 -169.5q0 -100 -26 -189.5t-73.5 -157.5t-113 -108t-144.5 -40q-65 0 -111.5 31.5t-69.5 88.5l79 68q13 -42 45.5 -66.5t77.5 -24.5q70 0 125 63t81 178q-29 -45 -76 -71t-99 -26q-43 0 -78 15 t-60 41t-38.5 62t-13.5 77zM356 622q-32 0 -63 -15t-56 -39.5t-40 -57t-15 -67.5q0 -52 30.5 -87.5t80.5 -35.5q32 0 63.5 14.5t56 38.5t39.5 56t15 68q0 26 -8 48.5t-22.5 39.5t-35 27t-45.5 10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.lnum",
    horizAdvX: 448,
    d: "M22 99h130l108 506q-10 -12 -31 -26.5t-45.5 -28t-50 -22.5t-44.5 -9l22 102q25 0 55 14.5t56 32t43.5 32.5t18.5 17h112l-131 -618h120l-21 -99h-363z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.numerator",
    horizAdvX: 278,
    d: "M275 379l-14 -66h-211l15 66h75l59 279q-7 -7 -19.5 -15.5t-26.5 -16t-29 -13t-26 -5.5l14 66q15 0 32.5 8.5t33 19t26 19.5t10.5 10h68l-76 -352h69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.denominator",
    horizAdvX: 396,
    d: "M-31 0q8 40 21 70t32.5 52.5t46.5 39.5t64 31q26 10 52.5 19t48 21t35 28.5t13.5 40.5q0 23 -18.5 37t-55.5 14q-44 0 -76.5 -17.5t-52.5 -34.5l-32 49q8 8 24.5 20t40.5 22.5t54 18t66 7.5q63 0 95 -27.5t32 -74.5q0 -32 -10.5 -56t-30.5 -42t-49.5 -32t-67.5 -26 q-56 -18 -80.5 -44t-30.5 -51h219l-15 -65h-325v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.denominator",
    horizAdvX: 386,
    d: "M191 97h-212l14 64l286 253h46l-54 -252h58l-14 -65h-57l-21 -97h-66zM208 162l35 167l-184 -167h149z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.denominator",
    horizAdvX: 386,
    d: "M118 -5q-60 0 -96.5 21.5t-39.5 61.5l47 47q0 -9 6.5 -19.5t19 -20.5t31.5 -16.5t45 -6.5q23 0 43.5 4.5t36.5 13t25 20.5t9 27q0 28 -34 42t-94 14h-23l13 61h22q63 0 102 15.5t39 49.5q0 23 -23 35.5t-52 12.5q-38 0 -68 -14.5t-52 -37.5l-31 53q26 29 71 45t92 16 q62 0 99 -28t37 -70t-29 -68t-81 -37q38 -6 58.5 -30.5t20.5 -56.5q0 -33 -17 -58.5t-44.5 -42t-62 -25t-70.5 -8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q.alt",
    horizAdvX: 605,
    d: "M387 98q-42 -54 -92 -81t-106 -27q-41 0 -72.5 16.5t-53 45.5t-33 67.5t-11.5 82.5q0 67 25 127t67 105t95.5 71.5t110.5 26.5q58 0 97.5 -29t56.5 -75l20 95h97l-157 -736h-110zM248 84q46 0 86 28.5t72 71.5l29 138q-1 24 -10 45t-24 36.5t-35.5 25t-42.5 9.5 q-37 0 -71 -18.5t-60.5 -49.5t-42 -70t-15.5 -79q0 -29 7.5 -53.5t22.5 -43.5t36 -29.5t48 -10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.lnum",
    horizAdvX: 529,
    d: "M418 609h-322l21 101h496l-488 -710h-124z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.numerator",
    horizAdvX: 363,
    d: "M330 664h-230l14 66h334l-320 -412h-75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.lnum",
    horizAdvX: 591,
    d: "M237 -10q-92 0 -142 61t-50 169q0 100 26 190t73.5 158t113 107.5t145.5 39.5q64 0 110.5 -31t69.5 -88l-79 -68q-13 42 -45.5 66.5t-78.5 24.5q-69 0 -124 -63.5t-81 -178.5q30 45 76.5 71t98.5 26q43 0 77.5 -15t59.5 -41t38.5 -61.5t13.5 -77.5q0 -59 -25 -111 t-67 -92t-96.5 -63t-113.5 -23zM258 84q32 0 63 14.5t56 39.5t40 57t15 68q0 52 -30.5 87.5t-80.5 35.5q-33 0 -64 -14.5t-55 -39t-39 -56.5t-15 -67q0 -26 8 -48.5t22.5 -39.5t35 -27t44.5 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t.alt",
    horizAdvX: 350,
    d: "M127 423h-74l21 100h74l36 172h113l-37 -172h117l-21 -100h-117l-90 -423h-112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.lnum",
    horizAdvX: 560,
    d: "M198 -9q-87 0 -137 39.5t-55 108.5l75 70q0 -21 7.5 -41.5t23.5 -37t41 -27t61 -10.5q33 0 62.5 9t52.5 25.5t36.5 39.5t13.5 50q0 51 -46.5 76t-132.5 25h-32l20 93h32q45 0 83 8t66 23.5t43.5 38.5t15.5 53q0 44 -28.5 66t-70.5 22q-27 0 -52.5 -7.5t-47.5 -20.5 t-39 -29t-28 -32l-55 79q21 25 49 45t60.5 33.5t67.5 21t68 7.5q44 0 80 -12.5t61.5 -35t39.5 -53t14 -67.5q0 -65 -43 -114t-122 -67q53 -11 81.5 -51.5t28.5 -97.5q0 -55 -26.5 -98t-68.5 -72t-94.5 -44.5t-104.5 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.numerator",
    horizAdvX: 385,
    d: "M183 306q-60 0 -96 22t-39 61l47 48q0 -9 6.5 -19.5t19 -20.5t31.5 -16.5t45 -6.5q22 0 43 4.5t36.5 13t25 21t9.5 27.5q0 27 -34.5 41t-94.5 14h-22l12 61h22q64 0 103 16t39 49q0 23 -23.5 35.5t-52.5 12.5q-38 0 -68 -14.5t-51 -37.5l-32 53q13 15 31.5 26t40.5 19 t45.5 12t46.5 4q61 0 98.5 -28t37.5 -70q0 -41 -29.5 -67.5t-81.5 -36.5q38 -6 59 -30.5t21 -57.5t-17 -58.5t-44.5 -42.5t-62.5 -25.5t-71 -8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.lnum",
    horizAdvX: 576,
    d: "M-20 0q15 70 36 121t50 89.5t68.5 67t92.5 52.5q39 18 78 34.5t70.5 38t51.5 51.5t20 76q0 38 -22.5 63t-68.5 25q-29 0 -57 -8.5t-52.5 -22t-45 -29.5t-35.5 -31l-54 73q13 13 39.5 33t62.5 39t81 33t96 14q46 0 80 -13t56.5 -35.5t34 -53.5t11.5 -67q0 -58 -19 -99 t-50.5 -71.5t-73 -53.5t-86.5 -44t-78.5 -41t-56.5 -41.5t-37 -46t-20 -54.5h330l-21 -99h-481v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.numerator",
    horizAdvX: 393,
    d: "M36 313q8 40 21 70t32.5 52.5t46.5 39t63 30.5q27 10 53.5 19.5t48 21.5t35 28.5t13.5 40.5q0 23 -19 37t-55 14q-44 0 -76.5 -17t-52.5 -34l-33 48q8 8 24.5 20t40.5 22.5t54.5 18t65.5 7.5q64 0 95.5 -28t31.5 -74q0 -32 -11 -56t-31 -42.5t-49.5 -32.5t-66.5 -26 q-56 -18 -80.5 -43.5t-30.5 -50.5h209l-15 -65h-314z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u.alt",
    horizAdvX: 577,
    d: "M157 -10q-70 0 -99.5 35t-29.5 95q0 20 2.5 40t7.5 43l69 320h109l-63 -298q-8 -34 -8 -60q0 -37 16 -59t57 -22q43 0 87.5 31t75.5 82l69 326h110l-111 -523h-106l21 99q-19 -27 -43.5 -47t-51.5 -34t-55.5 -21t-56.5 -7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w.alt",
    horizAdvX: 819,
    d: "M58 523h114l39 -390l191 390h104l25 -390l204 390h114l-283 -523h-121l-28 353l-180 -353h-117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y.alt",
    horizAdvX: 518,
    d: "M18 -213q4 7 16 27t28.5 49t37.5 64t44 73l-91 523h116l56 -426l223 426h105l-409 -736h-126v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.lnum",
    horizAdvX: 670,
    d: "M269 -10q-59 0 -101 25.5t-69 67t-39.5 92.5t-12.5 102q0 49 13.5 100.5t38 99.5t59 90.5t76 74t89 50t99.5 18.5q59 0 101 -26t69 -67.5t39.5 -93t12.5 -102.5q0 -74 -29.5 -151t-80.5 -139t-119.5 -101.5t-145.5 -39.5zM290 91q54 0 98 32.5t75.5 81t48.5 105t17 104.5 q0 36 -7.5 71t-23.5 62.5t-40 44.5t-58 17q-55 0 -99 -34.5t-75 -85.5t-48 -110t-17 -108q0 -35 7 -67.5t23 -57.5t40 -40t59 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotbelow",
    horizAdvX: 194,
    d: "M7 -189l25 116h99l-24 -116h-100z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.denominator",
    horizAdvX: 460,
    d: "M166 -5q-41 0 -71 15.5t-49 40t-28 55.5t-9 61q0 42 19 86t52.5 79.5t78 58t95.5 22.5q41 0 70.5 -16t48.5 -41t28 -56t9 -61q0 -42 -19 -85.5t-52 -78.5t-77.5 -57.5t-95.5 -22.5zM179 61q37 0 67 17t51 42.5t32.5 55t11.5 55.5q0 21 -6 42t-18.5 37.5t-31.5 26.5 t-45 10q-38 0 -68 -17t-51 -42.5t-32 -55.5t-11 -56q0 -21 6 -41.5t18.5 -37t31.5 -26.5t45 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.denominator",
    horizAdvX: 305,
    d: "M-3 65h90l59 279q-7 -7 -20.5 -15.5t-30 -16t-34 -12.5t-30.5 -5l14 66q18 0 38 8.5t37.5 19t29.5 19.5t12 10h67l-75 -353h83l-13 -65h-240z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.denominator",
    horizAdvX: 375,
    d: "M112 -5q-49 0 -84.5 19.5t-49.5 52.5l50 43q14 -23 39.5 -37.5t62.5 -14.5q22 0 42.5 6.5t36.5 18.5t25 29t9 38q0 33 -23.5 49t-51.5 16q-26 0 -54 -13t-45 -33h-59q10 24 24.5 58t30 69t29 66.5t21.5 51.5h225l-14 -67h-176l-47 -103q14 10 34.5 16t46.5 6 q58 0 93 -30.5t35 -79.5q0 -35 -16 -64.5t-43.5 -51t-64 -33.5t-76.5 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.denominator",
    horizAdvX: 405,
    d: "M142 -5q-63 0 -98.5 37.5t-35.5 104.5q0 59 17 110.5t47.5 89t73.5 59t95 21.5q43 0 76.5 -17.5t47.5 -49.5l-48 -46q-10 23 -35 36t-57 13q-51 0 -88 -33t-51 -94q20 23 54 36.5t66 13.5q31 0 56.5 -9t43.5 -25t27.5 -37t9.5 -46q0 -33 -16.5 -63t-44.5 -52.5t-64 -35.5 t-76 -13zM157 56q23 0 44.5 7.5t38.5 20t27.5 29.5t10.5 35q0 29 -24.5 49.5t-62.5 20.5q-24 0 -46 -7.5t-39 -20t-27.5 -29t-10.5 -34.5q0 -29 25.5 -50t63.5 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.denominator",
    horizAdvX: 363,
    d: "M264 347h-230l14 67h334l-321 -414h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.denominator",
    horizAdvX: 406,
    d: "M124 -5q-44 0 -77 17.5t-48 49.5l50 45q9 -23 33.5 -36t57.5 -13q50 0 87.5 33t51.5 93q-20 -23 -54 -36t-67 -13q-63 0 -99.5 33t-36.5 83q0 34 16.5 64t44 52.5t64 36t76.5 13.5q63 0 98.5 -38t35.5 -105q0 -59 -17 -110t-48 -88.5t-73.5 -59t-94.5 -21.5zM174 194 q23 0 45 7.5t39 19.5t27 28.5t10 34.5q0 29 -24.5 50t-62.5 21q-23 0 -44.5 -7.5t-38.5 -20.5t-27.5 -29.5t-10.5 -34.5q0 -29 24.5 -49t62.5 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.numerator",
    horizAdvX: 460,
    d: "M233 311q-41 0 -71 15.5t-49 40t-28 55.5t-9 62q0 42 19 86t52.5 79.5t78.5 58t96 22.5q41 0 70.5 -16t48 -41t27.5 -56t9 -61q0 -42 -18.5 -85.5t-51.5 -79t-77.5 -58t-96.5 -22.5zM146 493q0 -21 6 -41.5t18.5 -37t31.5 -26.5t45 -10q38 0 68 17t51 42.5t32 55t11 55.5 q0 21 -6 42t-18.5 37t-32 26t-45.5 10q-38 0 -67.5 -17t-50.5 -42.5t-32 -55t-11 -55.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.numerator",
    horizAdvX: 387,
    d: "M239 318l20 95h-211l13 65l286 252h46l-54 -251h58l-14 -66h-57l-21 -95h-66zM127 479h149l35 167z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.numerator",
    horizAdvX: 406,
    d: "M410 473q0 -34 -16.5 -64t-44.5 -52.5t-64.5 -36t-76.5 -13.5q-63 0 -98 38t-35 104q0 60 17 111t47.5 89t73.5 59.5t95 21.5q43 0 76 -17.5t48 -49.5l-49 -45q-9 22 -34 35.5t-57 13.5q-51 0 -88.5 -33.5t-51.5 -93.5q20 23 54 36t67 13q63 0 100 -33t37 -83zM223 369 q23 0 45 7.5t39 20.5t27.5 29.5t10.5 34.5q0 30 -24.5 50t-63.5 20q-24 0 -45.5 -7.5t-38.5 -19.5t-27 -28.5t-10 -34.5q0 -30 24.5 -51t62.5 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.numerator",
    horizAdvX: 398,
    d: "M394 452q0 -30 -16.5 -56t-43.5 -45t-61.5 -29.5t-71.5 -10.5q-31 0 -57 8.5t-44.5 23t-28.5 34.5t-10 43q0 24 9 42.5t24 32.5t34.5 24.5t39.5 18.5q-22 9 -37 26.5t-15 42.5q0 27 16 50t41.5 39t56.5 25t60 9q24 0 47 -6.5t41 -19t29 -30t11 -39.5q0 -35 -26 -59.5 t-61 -37.5q28 -12 45.5 -34t17.5 -52zM327 451q0 13 -7 23.5t-19 18t-27 11.5t-31 4q-21 0 -41 -5.5t-35.5 -15t-25.5 -23t-10 -29.5q0 -14 7.5 -24.5t19.5 -17.5t27.5 -11t31.5 -4q19 0 39 5.5t35.5 15t25.5 23t10 29.5zM183 608q0 -21 22.5 -33t49.5 -12q15 0 32 4 t31 11.5t23 18t9 24.5q0 21 -22 33t-51 12q-18 0 -35 -4t-30 -11.5t-21 -18.5t-8 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.numerator",
    horizAdvX: 406,
    d: "M88 565q0 33 16.5 63t44 52.5t64 36t76.5 13.5q63 0 99 -38t36 -104q0 -60 -17 -111t-48 -89t-73.5 -59.5t-94.5 -21.5q-44 0 -77 18t-48 50l49 45q10 -23 34 -36.5t58 -13.5q50 0 87.5 33.5t51.5 94.5q-20 -23 -54 -36.5t-67 -13.5q-63 0 -100 33t-37 84zM275 668 q-23 0 -45 -7.5t-39 -20t-27.5 -29.5t-10.5 -35q0 -29 25 -49t63 -20q23 0 45 7t39 19.5t27 29t10 34.5q0 29 -24.5 50t-62.5 21z"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "y.alt",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "w.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "Y.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "W.sc",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "W.alt",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "V.sc",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "T.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "J.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "A.sc",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\u0166",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\u0142",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "v",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "X",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "V",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u012B",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u0129",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "$",
    u2: "7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    g2: "T.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0166",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "V",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u012B",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u0129",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "zero.lnum",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "six.lnum",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "four.lnum",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "U.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u018F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u012B",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0129",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xF0",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "(",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ")",
    u2: ")",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    g2: "J.sc",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    g2: "A.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0259",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u012B",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0129",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xF0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    g2: "two.lnum",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    g2: "seven.lnum",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    g2: "one.lnum",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    u2: "7",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    u2: "4",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    u2: "3",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    u2: "1",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u0166",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u0166",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "zero.lnum",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "six.lnum",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "four.lnum",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "five.lnum",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "S.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "J.sc",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "A.sc",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u018F",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u012B",
    k: -44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0129",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "6",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "5",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "4",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "2",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "0",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "/",
    k: 256
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    g2: "W.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "\xB0",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "\\\\\\\\",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "V",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "7",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: ")",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    g2: "W.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "\xD7",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "\xB0",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "\\\\\\\\",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "X",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "V",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "7",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "+",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    g2: "W.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "\xB0",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "\\\\\\\\",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "V",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    g2: "W.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\xB0",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\\\\\\\\",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "V",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "7",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    g2: "W.alt",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\u2212",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\xB0",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\\\\\\\\",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "V",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "7",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "+",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\u2212",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\xF7",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\xD7",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\xB7",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "V",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "=",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "+",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u2212",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xF7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xB7",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xA2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "=",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "5",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "4",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "/",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "+",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: ")",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "V",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    g2: "W.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "\xB0",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "\\\\\\\\",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "V",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "7",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ":",
    u2: "\u0166",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ";",
    u2: "\u0166",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "=",
    g2: "seven.lnum",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "=",
    u2: "7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "=",
    u2: "3",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "y.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "Y.sc",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "W.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "W.alt",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "V.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "T.sc",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "v",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "V",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u0142",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    g2: "W.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    g2: "J.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u02BC",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u0166",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "X",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "V",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\u0131",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\u012B",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\u0129",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "y.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "w.alt",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "t.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "Z.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "Y.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "X.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "W.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "V.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "U.sc",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "T.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "S.sc",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "J.sc",
    k: 118
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "A.sc",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u02BC",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0259",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u018F",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0142",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0131",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u012B",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0129",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF0",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xDF",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "x",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "v",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "@",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "9",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "7",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "5",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "4",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "3",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "1",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "/",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: " ",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "\u0166",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u012B",
    k: -57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u0129",
    k: -44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    g2: "J.sc",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    g2: "A.sc",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u02BC",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "X",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "V",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "4",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "/",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: " ",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u0166",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "\u0166",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    g2: "f_f_l",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    g2: "f_f_i",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    g2: "f_i",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    g2: "f_f",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0159",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0131",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u012B",
    k: -57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0129",
    k: -48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xDF",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "w.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "U.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "S.sc",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "J.sc",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "A.sc",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u02BC",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0259",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u018F",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0159",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0131",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u012B",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0129",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF0",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xDF",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xAE",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xA9",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "x",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "v",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "@",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "9",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "8",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "6",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "5",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "4",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "3",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "2",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "1",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "0",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "/",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "&",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: " ",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0159",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0131",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u012B",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0129",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xDF",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "y.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "w.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "U.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u2122",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u02BC",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0259",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u018F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u012B",
    k: -66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0129",
    k: -49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF0",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "v",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\\\\\\\\",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "0",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: " ",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u1EF9",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0177",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0159",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0131",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u012B",
    k: -58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0129",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xDF",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\u012B",
    k: -57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\u0129",
    k: -47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\u012B",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "zero.lnum",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "y.alt",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "w.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "six.lnum",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "Y.sc",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "W.sc",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "W.alt",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "V.sc",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "U.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "T.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u018F",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u0166",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "v",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "V",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "7",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "6",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "\xD0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "d",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "\xD0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u012D",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u012B",
    k: -101
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u0129",
    k: -77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xEF",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xEC",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "j",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "W",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "i",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "\u0135",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "j",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "\xD0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "\xD0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "j",
    k: -59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "W",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "\xD0",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "u",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    g2: "W.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u02BC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0259",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xF0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xD0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "X",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: ")",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: " ",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "\xD0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u02BC",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0259",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF0",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "V",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "\xD0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "z",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\u012B",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "y.alt",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "w.alt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "Y.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "W.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "W.alt",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "V.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "U.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "T.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\u0166",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\u0142",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\u0141",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\u0135",
    k: -120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\u0110",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\xD0",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "v",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "j",
    k: -112
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "V",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA1",
    u2: "V",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA3",
    g2: "four.lnum",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    g2: "y.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    g2: "w.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    g2: "Y.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    g2: "W.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    g2: "W.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    g2: "V.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    g2: "T.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "\u0141",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "\u0135",
    k: -123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "\u0110",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "\xD0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "v",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "j",
    k: -115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "V",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: "\u0166",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    g2: "four.lnum",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "9",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "5",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "4",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "3",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "0",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    g2: "seven.lnum",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "7",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "4",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "3",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "1",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\u0166",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\u0141",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\u0110",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\xD0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "y.alt",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "w.alt",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "t.alt",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "l.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "Z.sc",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "Y.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "X.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "W.sc",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "W.alt",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "V.sc",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "U.sc",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "T.sc",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "S.sc",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "J.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "A.sc",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0259",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u018F",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0166",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0142",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0141",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0135",
    k: -90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u012F",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0126",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0110",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\xF0",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\xD0",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "x",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "v",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "j",
    k: -82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "X",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "V",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC6",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC8",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC9",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xCA",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xCB",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD7",
    g2: "seven.lnum",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD7",
    u2: "7",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD7",
    u2: "3",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD7",
    u2: "1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u0166",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xDF",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    g2: "W.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    g2: "A.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u2122",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\\\\\\\\",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "X",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "V",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "?",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "7",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "/",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "*",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: ")",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    g2: "y.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    g2: "w.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    g2: "t.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    g2: "W.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "\u2122",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "\xD0",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "\xA6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "|",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "x",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "v",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "\\\\\\\\",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "X",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "V",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "\xD0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: " ",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    g2: "y.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    g2: "w.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    g2: "t.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    g2: "W.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "\xD0",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "|",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "x",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "v",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "X",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "V",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "?",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "*",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    g2: "seven.lnum",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    u2: "7",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    u2: "4",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    u2: "3",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    u2: "1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "\xD0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "j",
    k: -80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0105",
    u2: "j",
    k: -28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u2122",
    k: -49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u201D",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u2019",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u0133",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xFE",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xDF",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xA6",
    k: -54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "}",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "|",
    k: -51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "k",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "i",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "h",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "b",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "]",
    k: -28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\\\\\\\\",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "*",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: ")",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0112",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0114",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0116",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0118",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011A",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011C",
    u2: "\u0166",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011D",
    u2: "j",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011E",
    u2: "\u0166",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011F",
    u2: "j",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0120",
    u2: "\u0166",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0121",
    u2: "j",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0122",
    u2: "\u0166",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0123",
    u2: "j",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "q.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "d.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "a.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0121",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "q",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "g",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "d",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "a",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\u2122",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\xA6",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "}",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "|",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "]",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\\\\\\\\",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: ")",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "\xA6",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "|",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "\\\\\\\\",
    k: -44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "*",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: ")",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012F",
    u2: "j",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0133",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0133",
    u2: "j",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    u2: "j",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "\u012B",
    k: -57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013C",
    u2: "j",
    k: -77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    g2: "y.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    g2: "w.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    g2: "q.alt",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    g2: "d.alt",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    g2: "a.alt",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u2122",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\xE1",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\xA6",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "}",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "|",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "y",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "w",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "v",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "q",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "g",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "d",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "a",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "]",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\\\\\\\\",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "/",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: ")",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    g2: "y.alt",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    u2: "y",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    u2: "x",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014A",
    u2: "j",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014B",
    u2: "j",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0152",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "\xD0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: " ",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0154",
    u2: "\u0166",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0154",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0154",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0154",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0156",
    u2: "\u0166",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0156",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0156",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0156",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0158",
    u2: "\u0166",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0158",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0158",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0158",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015A",
    u2: "\u0166",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015C",
    u2: "\u0166",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015E",
    u2: "\u0166",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0160",
    u2: "\u0166",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    g2: "f_f_l",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    g2: "f_f_i",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    g2: "f_i",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    g2: "f_f",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\xDF",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0163",
    u2: "j",
    k: -121
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    g2: "f_f_l",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    g2: "f_f_i",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    g2: "f_i",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    g2: "f_f",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\xDF",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "y.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "w.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "u.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "q.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "d.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "c_t",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "a.alt2",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "a.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "Z.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "Y.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "X.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "W.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "V.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "U.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "S.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "R.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "Q.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "P.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "O.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "N.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "M.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "L.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "K.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "I.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "H.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "G.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "G.alt",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "F.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "E.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "D.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "C.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "B.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "A.sc",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\uFB06",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "f_l",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "f_i",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u203A",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u2039",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u2014",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u2013",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u1ECC",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u01FE",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u01F4",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u018F",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0153",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0152",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0150",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u014E",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u014C",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0122",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0120",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u011E",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u011C",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u010C",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u010A",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0108",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0106",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xF0",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xE6",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD8",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD6",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD5",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD4",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD3",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD2",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC7",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xBB",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xAE",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xAD",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xAB",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xA9",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "z",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "y",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "x",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "w",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "v",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "u",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "s",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "r",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "q",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "p",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "o",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "n",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "m",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "g",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "e",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "d",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "c",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "a",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "Q",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "O",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "G",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "C",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: ";",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: ":",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "/",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "-",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0168",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0168",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0168",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016A",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016A",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016A",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016C",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016C",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016C",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016E",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016E",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016E",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0170",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0170",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0170",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0172",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0172",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0172",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0173",
    u2: "j",
    k: -28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "\xDF",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\xDF",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xDF",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "\u012B",
    k: -57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01F4",
    u2: "\u0166",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01F5",
    u2: "j",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FA",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FA",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FA",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FC",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FD",
    u2: " ",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\u0166",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0218",
    u2: "\u0166",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    g2: "f_f_l",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    g2: "f_f_i",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    g2: "f_i",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    g2: "f_f",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    u2: "\xDF",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021B",
    u2: "j",
    k: -48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "y.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "w.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "t.alt",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "l.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "Z.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "Y.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "X.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "W.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "V.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "U.sc",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "T.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "S.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "J.sc",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "A.sc",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "x",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "v",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5A",
    u2: "\u0166",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5A",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5A",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5A",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E62",
    u2: "\u0166",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "\xDF",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6D",
    u2: "j",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "\xDF",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "\xDF",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E84",
    u2: "\xDF",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB8",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBC",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECA",
    u2: "j",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECB",
    u2: "j",
    k: -44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EE4",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EE4",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EE4",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\xDF",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF8",
    u2: "\xDF",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u012B",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u012B",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0129",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u0166",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u012B",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\u012B",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\u0129",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0166",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\u0166",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\u0166",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\u0141",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\u0110",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\xD0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u20AC",
    g2: "seven.lnum",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u20AC",
    g2: "four.lnum",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2120",
    g2: "J.sc",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2120",
    g2: "A.sc",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2120",
    u2: "\u012B",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2120",
    u2: "\u0129",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    g2: "seven.lnum",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    g2: "one.lnum",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    u2: "7",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    u2: "4",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    u2: "3",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    u2: "1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\u0149",
    k: -125
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\u012D",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\u012B",
    k: -89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\u0129",
    k: -65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\xEF",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\xEC",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_i",
    u2: "\u0149",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_i",
    u2: "\u012B",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_l",
    u2: "\u0149",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f_i",
    u2: "\u0149",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f_i",
    u2: "\u012B",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f_l",
    u2: "\u0149",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "Y.sc",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "W.sc",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "V.sc",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "U.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "T.sc",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "S.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\u2122",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\u2120",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\u02BC",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xBA",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xAE",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xAA",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xA9",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xA6",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "|",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\\\\\\\\",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "V",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "?",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "*",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: " ",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "Y.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "X.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "W.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "V.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "T.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "A.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "\u2122",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "\u02BC",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "\xA6",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "|",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "\\\\\\\\",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "V",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "?",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "*",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "Y.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "W.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "V.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "T.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "A.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "\u2122",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "\u02BC",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "\xA6",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "|",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "\\\\\\\\",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "V",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "?",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "*",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "Z.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "Y.sc",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "X.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "W.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "V.sc",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "T.sc",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "J.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "A.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\u2122",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\u2120",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\u02BC",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\xA6",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "|",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\\\\\\\\",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "X",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "V",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "?",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "*",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: ")",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "S.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    u2: "\u02BC",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "S.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "J.sc",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "A.sc",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    u2: "\u02BC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    u2: "X",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    u2: "/",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    u2: " ",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "y.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "W.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "J.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "A.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "\u2122",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "\u02BC",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "\u0166",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "v",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "X",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "V",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "/",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "*",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "Y.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "W.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "V.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "T.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "\u2122",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "\u02BC",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "\xA6",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "|",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "\\\\\\\\",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "V",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "?",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "*",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "J.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "A.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    u2: "\u02BC",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    u2: "\\\\\\\\",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    u2: "V",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    u2: "\u02BC",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    u2: " ",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "Y.sc",
    k: 97
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "W.sc",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "V.sc",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "U.sc",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "T.sc",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "S.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\u2122",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\u2120",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\u02BC",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xBA",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xB7",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xAE",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xAA",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xA9",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xA6",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "|",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\\\\\\\\",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "V",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "?",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "*",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: " ",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "Z.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "Y.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "X.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "W.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "V.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "T.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "J.sc",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "A.sc",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "\u02BC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "\\\\\\\\",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "X",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "V",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "?",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "*",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: ")",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: " ",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Q.sc",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "Y.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "W.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "V.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "T.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "A.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\u2122",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\u02BC",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\xA6",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "|",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\\\\\\\\",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "V",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "?",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "*",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "Y.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "W.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "V.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "T.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "A.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "\u2122",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "\u02BC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "\xA6",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "|",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "\\\\\\\\",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "V",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "?",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "*",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "J.sc",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "A.sc",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    u2: "\u02BC",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    u2: "@",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    u2: "/",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    u2: " ",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "J.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "A.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "\u02BC",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "\\\\\\\\",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "X",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "V",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "S.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "J.sc",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "A.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: "\u02BC",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: "X",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: "@",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: "/",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: ")",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: " ",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "S.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "J.sc",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "A.sc",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u02BC",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u0259",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u018F",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u0159",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u0131",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u012B",
    k: -48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u0129",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xF0",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xDF",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xAE",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xA9",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "@",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "9",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "8",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "6",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "5",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "4",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "3",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "2",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "0",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "/",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "&",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: " ",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "S.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "J.sc",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "A.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: "\u02BC",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: "X",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: "@",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: "/",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: ")",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: " ",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    u2: "\u02BC",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "S.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "J.sc",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "A.sc",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "\u02BC",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "X",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "@",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "/",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: ")",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "&",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: " ",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    u2: "\u02BC",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "y.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "w.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "t.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\u2122",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\u02BC",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\xA6",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "|",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "v",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\\\\\\\\",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "V",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "?",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "*",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d.alt",
    u2: "\u02BC",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d.alt",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "j.alt",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "j.alt",
    u2: "j",
    k: -59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l.alt",
    u2: "\u02BC",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l.alt",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lnum",
    g2: "seven.lnum",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lnum",
    u2: "/",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lnum",
    u2: ")",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    g2: "zero.lnum",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    g2: "four.lnum",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    u2: "\u2212",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    u2: "\xD7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    u2: "+",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "q.alt",
    u2: "j",
    k: -59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "zero.lnum",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "six.lnum",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "seven.lnum",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "four.lnum",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "five.lnum",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\u2212",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\xF7",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\xD7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\xB7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\xA2",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\\\\\\\\",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "/",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "+",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "#",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.numerator",
    u2: "\u2044",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "\u02BC",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "\u0259",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "\xF0",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "X",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "V",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "/",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: " ",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lnum",
    g2: "four.lnum",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\u02BC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\u0259",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\xF0",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\\\\\\\\",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "X",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "V",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "/",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: ")",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: " ",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "\u02BC",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "\u0259",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "\xF0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "X",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "V",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "/",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: ")",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: " ",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    g2: "seven.lnum",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    g2: "one.lnum",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    u2: "\xB0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    u2: "\\\\\\\\",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    u2: "/",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    u2: ")",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "ae,aeacute,a.alt2",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "b,h,k,germandbls,thorn,hcircumflex,hbar,kcommaaccent,hdotbelow",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,j.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "ae,aeacute,a.alt2",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "T.sc",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "U.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "V",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "V.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "W.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "W.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "Y.sc",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "ampersand",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "apostrophe",
    k: 121
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "asterisk",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "at",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "backslash",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "bar",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "brokenbar",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "copyright",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "eight",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "eth",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "guillemotleft,guilsinglleft",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "ordfeminine",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "ordmasculine",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "question",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "quoteleft,quotedblleft",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "quoteright,quotedblright",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "quotedbl,quotesingle",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "registered",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "schwa",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "seven",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "six",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "space",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "t.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "trademark",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "v",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "w.alt",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "y.alt",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "zero",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "servicemark",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "Schwa",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "J,Jcircumflex",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "V",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "apostrophe",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "V",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "W.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "apostrophe",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "asterisk",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "backslash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "quoteleft,quotedblleft",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "quoteright,quotedblright",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "quotedbl,quotesingle",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "trademark",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "J,Jcircumflex",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "A.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "AE,AEacute",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "J.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "slash",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "X",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "parenright",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "x",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "ae,aeacute,a.alt2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "T.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "U.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "V.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "W.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "Y.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "apostrophe",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "eth",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "guillemotleft,guilsinglleft",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "schwa",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "seven",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "t.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "v",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "w.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "y.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "Schwa",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "ae,aeacute,a.alt2",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,j.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "guillemotleft,guilsinglleft",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "J,Jcircumflex",
    k: 156
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "AE,AEacute",
    k: 128
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "colon,semicolon",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "guillemotright,guilsinglright",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "W.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "apostrophe",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "v",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "y.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "quoteleft,quotedblleft",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "quoteright,quotedblright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "quotedbl,quotesingle",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "J,Jcircumflex",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "AE,AEacute",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "apostrophe",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "eth",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "t.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "apostrophe",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "eth",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "J,Jcircumflex",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "A.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "J.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "slash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "U.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "V.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "W.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "Y.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "apostrophe",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "copyright",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "eth",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "registered",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "schwa",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "space",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "w.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "y.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "zero",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "Schwa",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "ae,aeacute,a.alt2",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 136
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "T.sc",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "U.sc",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "V",
    k: 112
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "V.sc",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 112
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "W.alt",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "W.sc",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "Y.sc",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "apostrophe",
    k: 149
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "asterisk",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "backslash",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "bar",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "brokenbar",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "copyright",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "eth",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "guillemotleft,guilsinglleft",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "ordfeminine",
    k: 107
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "ordmasculine",
    k: 107
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "question",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "quoteleft,quotedblleft",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "quoteright,quotedblright",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "quotedbl,quotesingle",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "registered",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "schwa",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "seven",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "six",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "space",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "t.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "trademark",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "v",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "w.alt",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "y.alt",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "zero",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "servicemark",
    k: 107
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "Schwa",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "AE,AEacute",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "guillemotright,guilsinglright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "periodcentered",
    k: 156
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "V",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "W.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "apostrophe",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "asterisk",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "backslash",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "quoteleft,quotedblleft",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "quoteright,quotedblright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "quotedbl,quotesingle",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "trademark",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "J,Jcircumflex",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "A.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "AE,AEacute",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "J.sc",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "slash",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "X",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "parenright",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "x",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "ae,aeacute,a.alt2",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "J,Jcircumflex",
    k: 105
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "AE,AEacute",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "ae,aeacute,a.alt2",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "b,h,k,germandbls,thorn,hcircumflex,hbar,kcommaaccent,hdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,j.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "V",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "apostrophe",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "eth",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "l.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "T.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "V",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "V.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "W.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "Y.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "apostrophe",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "ordfeminine",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "seven",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "v",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "w.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "y.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "ae,aeacute,a.alt2",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "T.sc",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "U.sc",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "V.sc",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "W.sc",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "Y.sc",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "apostrophe",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "at",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "copyright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "eth",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "guillemotleft,guilsinglleft",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "registered",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "schwa",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "seven",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "six",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "space",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "t.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "v",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "w.alt",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "y.alt",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "zero",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "Schwa",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "J,Jcircumflex",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "A.sc",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "AE,AEacute",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "J.sc",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "slash",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "x",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "colon,semicolon",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "guillemotright,guilsinglright",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "S.sc",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "X.sc",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "Z.sc",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "five",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "four",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "nine",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "one",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "three",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "two",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "quoteleft,quotedblleft",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "quoteright,quotedblright",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "quotedbl,quotesingle",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "J,Jcircumflex",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "ae,aeacute,a.alt2",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "b,h,k,germandbls,thorn,hcircumflex,hbar,kcommaaccent,hdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,j.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "apostrophe",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "eth",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "J,Jcircumflex",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "A.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "AE,AEacute",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "J.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "slash",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "l.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "four",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "ae,aeacute,a.alt2",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "guillemotleft,guilsinglleft",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "J,Jcircumflex",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "AE,AEacute",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "colon,semicolon",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "guillemotright,guilsinglright",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "ae,aeacute,a.alt2",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "U.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "ampersand",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "apostrophe",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "at",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "copyright",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "eight",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "eth",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "guillemotleft,guilsinglleft",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "registered",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "schwa",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "six",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "space",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "v",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "w.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "zero",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "Schwa",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "J,Jcircumflex",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "A.sc",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "AE,AEacute",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "J.sc",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "slash",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "x",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "colon,semicolon",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "guillemotright,guilsinglright",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "S.sc",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "five",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "four",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "nine",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "one",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "three",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "two",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "ae,aeacute,a.alt2",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "guillemotleft,guilsinglleft",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "J,Jcircumflex",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "AE,AEacute",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "guillemotright,guilsinglright",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "ae,aeacute,a.alt2",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "U.sc",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "V.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "W.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "Y.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "ampersand",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "apostrophe",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "at",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "copyright",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "eight",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "eth",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "guillemotleft,guilsinglleft",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "registered",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "schwa",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "six",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "space",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "t.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "v",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "w.alt",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "y.alt",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "zero",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "Schwa",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "J,Jcircumflex",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "A.sc",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "AE,AEacute",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "J.sc",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "slash",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "x",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "colon,semicolon",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "guillemotright,guilsinglright",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "S.sc",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "X.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "Z.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "five",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "four",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "nine",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "one",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "three",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "two",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "apostrophe",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "eth",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "schwa",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "zero",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "Schwa",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "V",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "apostrophe",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "backslash",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "bar",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "question",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "V",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "W.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "apostrophe",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "backslash",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "bar",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "question",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "quoteleft,quotedblleft",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "quoteright,quotedblright",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "quotedbl,quotesingle",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "V",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "W.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "apostrophe",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "asterisk",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "backslash",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "bar",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "brokenbar",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "ordmasculine",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "question",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "quoteleft,quotedblleft",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "quoteright,quotedblright",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "quotedbl,quotesingle",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "t.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "trademark",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "v",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "w.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "y.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "servicemark",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "J,Jcircumflex",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "X",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "parenright",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "x",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "V",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "W.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "apostrophe",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "asterisk",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "backslash",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "bar",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "brokenbar",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "eth",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "guillemotleft,guilsinglleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "question",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "quoteleft,quotedblleft",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "quoteright,quotedblright",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "quotedbl,quotesingle",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "trademark",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "v",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "w.alt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "y.alt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "apostrophe",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d.alt",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "V",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "W.alt",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "apostrophe",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "asterisk",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "backslash",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "bar",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "brokenbar",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "question",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "quoteleft,quotedblleft",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "quoteright,quotedblright",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "quotedbl,quotesingle",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "t.alt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "trademark",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "v",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "w.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "y.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "x",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "J,Jcircumflex",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "ae,aeacute,a.alt2",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "V",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "W.alt",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "apostrophe",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "backslash",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "bar",
    k: -19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "brokenbar",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "eth",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "guillemotleft,guilsinglleft",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "schwa",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "space",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "trademark",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "J,Jcircumflex",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "AE,AEacute",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "slash",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "X",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "parenright",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "guillemotright,guilsinglright",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "V",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "W.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "apostrophe",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "asterisk",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "backslash",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "bar",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "brokenbar",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "question",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "quoteleft,quotedblleft",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "quoteright,quotedblright",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "quotedbl,quotesingle",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "t.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "trademark",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "v",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "w.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "y.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "servicemark",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,f_i,f_f_i,j.alt",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,f_i,f_f_i,j.alt",
    g2: "apostrophe",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "ae,aeacute,a.alt2",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 95
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "V",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "W.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "apostrophe",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "asterisk",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "backslash",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "question",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "quoteleft,quotedblleft",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "quoteright,quotedblright",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "quotedbl,quotesingle",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "v",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "w.alt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "V",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "apostrophe",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "asterisk",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "bar",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "brokenbar",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "copyright",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "eth",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "guillemotleft,guilsinglleft",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "ordfeminine",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "ordmasculine",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "question",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "quoteleft,quotedblleft",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "quoteright,quotedblright",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "quotedbl,quotesingle",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "registered",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "space",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "trademark",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "v",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "w.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "y.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "servicemark",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "AE,AEacute",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "guillemotright,guilsinglright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "periodcentered",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l.alt",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "V",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "W.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "apostrophe",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "asterisk",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "backslash",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "bar",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "brokenbar",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "question",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "quoteleft,quotedblleft",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "quoteright,quotedblright",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "quotedbl,quotesingle",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "t.alt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "trademark",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "v",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "w.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "y.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "V",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "W.alt",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "apostrophe",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "asterisk",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "backslash",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "bar",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "brokenbar",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "ordmasculine",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "question",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "quoteleft,quotedblleft",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "quoteright,quotedblright",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "quotedbl,quotesingle",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "t.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "trademark",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "v",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "w.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "y.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "servicemark",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "J,Jcircumflex",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "X",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "x",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "ae,aeacute,a.alt2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "V",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "apostrophe",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "eth",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "guillemotleft,guilsinglleft",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "schwa",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "space",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "J,Jcircumflex",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "AE,AEacute",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "slash",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "X",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "guillemotright,guilsinglright",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "V",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "W.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "apostrophe",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "asterisk",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "backslash",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "bar",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "brokenbar",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "question",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "quoteleft,quotedblleft",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "quoteright,quotedblright",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "quotedbl,quotesingle",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "trademark",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "v",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "w.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "y.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "V",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "apostrophe",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "eth",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "guillemotleft,guilsinglleft",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "schwa",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "ae,aeacute,a.alt2",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "guillemotleft,guilsinglleft",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "J,Jcircumflex",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "AE,AEacute",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "guillemotright,guilsinglright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "V",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "apostrophe",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "backslash",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "bar",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "question",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "ae,aeacute,a.alt2",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "guillemotleft,guilsinglleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "J,Jcircumflex",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "AE,AEacute",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "ae,aeacute,a.alt2",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "V",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "apostrophe",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "eth",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "schwa",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "space",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "J,Jcircumflex",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "AE,AEacute",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "slash",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "X",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "parenright",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "ae,aeacute,a.alt2",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "guillemotleft,guilsinglleft",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "J,Jcircumflex",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "AE,AEacute",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "ae,aeacute,a.alt2",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "guillemotleft,guilsinglleft",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "ae,aeacute,a.alt2",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "V",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "apostrophe",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "eth",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "space",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "J,Jcircumflex",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "AE,AEacute",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "slash",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "X",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "parenright",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "ae,aeacute,a.alt2",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "guillemotleft,guilsinglleft",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "J,Jcircumflex",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "AE,AEacute",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "V",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "apostrophe",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "eth",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "guillemotleft,guilsinglleft",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "schwa",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "quoteleft,quotedblleft",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "quoteright,quotedblright",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "quotedbl,quotesingle",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "quoteleft,quotedblleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "quoteright,quotedblright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "quotedbl,quotesingle",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "quoteleft,quotedblleft",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "quoteright,quotedblright",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "quotedbl,quotesingle",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "quoteleft,quotedblleft",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "quoteright,quotedblright",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "quotedbl,quotesingle",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "J,Jcircumflex",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "J,Jcircumflex",
    k: 109
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "AE,AEacute",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "guillemotright,guilsinglright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "quoteleft,quotedblleft",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "quoteright,quotedblright",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "quotedbl,quotesingle",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "V",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "apostrophe",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "backslash",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "question",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 95
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "quoteleft,quotedblleft",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "quoteright,quotedblright",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "quotedbl,quotesingle",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "guillemotright,guilsinglright",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "T.sc",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "V",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "V.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "W.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "Y.sc",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "apostrophe",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "asterisk",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "backslash",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "bar",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "brokenbar",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "question",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "quoteleft,quotedblleft",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "quoteright,quotedblright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "quotedbl,quotesingle",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "trademark",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "servicemark",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "J,Jcircumflex",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "A.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "J.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "X",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "parenright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "X.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "Z.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "quoteleft,quotedblleft",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "quoteright,quotedblright",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "quotedbl,quotesingle",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "J,Jcircumflex",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "AE,AEacute",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "quoteleft,quotedblleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "quoteright,quotedblright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "quotedbl,quotesingle",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "quoteleft,quotedblleft",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "quoteright,quotedblright",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "quotedbl,quotesingle",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "J,Jcircumflex",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "AE,AEacute",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "guillemotright,guilsinglright",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "J,Jcircumflex",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "J,Jcircumflex",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "AE,AEacute",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "J,Jcircumflex",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "AE,AEacute",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "J,Jcircumflex",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "AE,AEacute",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "guillemotright,guilsinglright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "periodcentered",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "ae,aeacute,a.alt2",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "J,Jcircumflex",
    k: 97
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "AE,AEacute",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "quoteright,quotedblright",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "quotedbl,quotesingle",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "ae,aeacute,a.alt2",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "J,Jcircumflex",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "AE,AEacute",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "quoteright,quotedblright",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "quotedbl,quotesingle",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "quoteright,quotedblright",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "quotedbl,quotesingle",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "AE,AEacute",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "quoteright,quotedblright",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "quotedbl,quotesingle",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "AE,AEacute",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "quoteright,quotedblright",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "quotedbl,quotesingle",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "AE,AEacute",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "V",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "exclamdown",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "exclamdown",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "quotedbl,quotesingle",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "T.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "V",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "V.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "W.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "W.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "Y.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "quoteright,quotedblright",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "quotedbl,quotesingle",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "T.sc",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "V",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "V.sc",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "W.alt",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "W.sc",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "Y.sc",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "quoteright,quotedblright",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "quotedbl,quotesingle",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "t.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "v",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "w.alt",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "y.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "J,Jcircumflex",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "A.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "J.sc",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "x",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "X.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "Z.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "T.sc",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "V",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "V.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "W.alt",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "W.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "Y.sc",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "quoteright,quotedblright",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "quotedbl,quotesingle",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "seven",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "v",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "w.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "y.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "J,Jcircumflex",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "A.sc",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "J.sc",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "X",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "x",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "X.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "Z.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "four",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "one",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "three",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "one.lnum",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "seven.lnum",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine",
    g2: "quotedbl,quotesingle",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "quotedbl,quotesingle",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "AE,AEacute",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "T.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "U.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "V",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "V.sc",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "W.alt",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "W.sc",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "Y.sc",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "quoteleft,quotedblleft",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "quoteright,quotedblright",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "quotedbl,quotesingle",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "seven",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "six",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "w.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "y.alt",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "Schwa",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "four.lnum",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "nine.lnum",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "six.lnum",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "zero.lnum",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "ae,aeacute,a.alt2",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "b,h,k,germandbls,thorn,hcircumflex,hbar,kcommaaccent,hdotbelow",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,j.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "J,Jcircumflex",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "AE,AEacute",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "ae,aeacute,a.alt2",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "eth",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "schwa",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "J,Jcircumflex",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "A.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "AE,AEacute",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "J.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "ae,aeacute,a.alt2",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "at",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "eth",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "guillemotleft,guilsinglleft",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "schwa",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "space",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "J,Jcircumflex",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "A.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "AE,AEacute",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "J.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "slash",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "guillemotright,guilsinglright",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "ae,aeacute,a.alt2",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "at",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "eth",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "guillemotleft,guilsinglleft",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "schwa",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "space",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "J,Jcircumflex",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "A.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "AE,AEacute",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "J.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "slash",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "guillemotright,guilsinglright",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "five",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "four",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "nine",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "three",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "four.lnum",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "J,Jcircumflex",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "AE,AEacute",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "quoteright,quotedblright",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "quotedbl,quotesingle",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "J,Jcircumflex",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "AE,AEacute",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "quotedbl,quotesingle",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "AE,AEacute",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two",
    g2: "AE,AEacute",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "quotedbl,quotesingle",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "servicemark",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "servicemark",
    g2: "J,Jcircumflex",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "servicemark",
    g2: "AE,AEacute",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "AE,AEacute",
    k: -12
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRalewaySemiBoldItalic);
export default __webpack_public_path__ + "static/media/Raleway-SemiBoldItalic.2237d54e5cadeed713e37c1c7719135c.svg";
export { ForwardRef as ReactComponent };